<template>
    <div class="nav-bar-operations">
        <img src="@/assets/logogruas.png" alt="HomePage" @click="backMainPanel" class="logo-button"/>
    </div>
    <div class="note-container" style="font-family: 'Poppins', sans-serif; overflow-y: auto;">
        <div class="create-order" style="min-width: 1200px;">
            <div class="left">
                <h3 class="order-type">Orden de Trabajo: 
                    
                    <!-- {{ localNoteDetails.note_number }} -->

                </h3>
                <div class="form-group1">
                    <input type="text" id="order_number" placeholder="Ingrese un numero" v-model="localNoteDetails.note_number" disabled class="grayed-out"/>
                </div>
                {{ localNoteDetails.invoice_detail ? 'Factura: ' + localNoteDetails.invoice_detail.invoice_ident : localNoteDetails.status == 2 ? 'CANCELADO' : 'No facturado' }}
            </div>
            <div class="assignment-legend-block">
                <div>
                    <span>{{ localNoteDetails?.scheduled_for ? 'PROGRAMADO PARA:' : 'CREADO:' }}</span>
                    <span>{{ formatDateTime(localNoteDetails?.scheduled_for || localNoteDetails?.request_time) }}<span v-if="localNoteDetails?.scheduled_number">, # Prog: {{ localNoteDetails.scheduled_number }}</span></span>
                </div>
                <div style="display:flex;align-items:center;gap:8px;font-weight:600;" :style="isAssignmentPending ? { color: '#b91c1c' } : {}">
                    <span>ASIGNADO:</span>
                    <span style="font-weight:700;">
                        <span v-if="isAssignmentPending" style="display:inline-flex;align-items:center;gap:6px;">
                            <span class="spinner-grow spinner-grow-sm text-danger" role="status" aria-hidden="true"></span>
                            {{ assignedLegendDisplay }}
                        </span>
                        <span v-else>{{ assignedLegendDisplay }}</span>
                    </span>
                </div>
            </div>
            <div class="right">
                <button @click="showForm('initialData')">Datos iniciales y Cobro</button>
                <button v-if="canViewAssignationsTab" @click="showForm('assignment')">Asignación</button>
                <button v-if="canViewInvoicesTab" @click="showForm('billing')">Facturación</button>
                <button v-if="canViewImagesTab" @click="showForm('images')">Imágenes</button>
                <button v-if="canViewRouteReportTab" @click="showForm('report')">Reporte de ruta</button>
                <button v-if="canViewHistorialTab" @click="showForm('historial')">Historial</button>
                <button v-if="canViewChatTab" @click="showForm('chat')">Chat<span v-if="chatUnread > 0" style="background:#FFC434;color:#1a1a1a;border-radius:9px;padding:1px 7px;margin-left:6px;font-size:11px;font-weight:600;">{{ chatUnread }}</span></button>
                <button v-if="canViewSurveyTab" @click="showForm('encuesta')">Encuesta</button>
            </div>
        </div>
        <div v-if="currentForm === 'historial'" style="min-width: 1200px;">
            <NoteHistory :note-ident="localNoteDetails.note_ident" />
        </div>
        <div v-if="currentForm === 'chat'" style="min-width: 1200px;">
            <NoteChat :note-ident="localNoteDetails.note_ident" @read="chatUnread = 0" />
        </div>
        <div v-if="currentForm === 'encuesta'" style="min-width: 1200px;">
            <NoteSurvey :note-ident="localNoteDetails.note_ident" />
        </div>
        <div v-if="currentForm === 'initialData'" style="min-width: 1200px;">
            <div class="main-data-container">
                
                <div class="client-data-container">
                    <div class="container-card">
                        <div class="title">
                            <h4>Datos del cliente</h4>
                            <img src="@/assets/client-icon.png">
                            <h4 v-if="clientDetails.is_credit_suspended" style="color: red;">ESTE CLIENTE TIENE EL CRÉDITO SUSPENDIDO</h4>x 
                        </div>
                        <div class="container-card-body">
                            <div class="client-container pb-1">
                                <div class="d-flex gap-2 position-relative align-items-start">
                                    <div class="form-input-group w-100">
                                        <label for="client_name">Cliente</label>
                                        <input type="text" id="client_name" v-model="client_front_name" @input="filterClients" @keydown.down.prevent="navigateClients(1)" @keydown.up.prevent="navigateClients(-1)" @keydown.enter.prevent="selectHighlightedClient" autocomplete="off" />
                                    </div>
                                    <div class="button-add-new-client d-flex align-items-start" v-if="!isClientSelected">
                                        <button @click="toggleNewClientForm" class="btn-submit-save" v-if="!addNewClient">Agregar nuevo cliente</button>
                                    </div>
                                </div>
                                <div class="dropdown-container">
                                    <div class="dropdown" v-if="filteredClients.length" ref="dropdownContainer" v-click-outside="closeDropdown">
                                        <li v-for="(client, index) in filteredClients" :key="client.id" :class="{ 'active': index === highlightedIndex }" @click="selectClient(client)" ref="dropdownItem">
                                            {{ client.client_ident + ' - ' + client.client_name}}
                                        </li>
                                    </div>
                                </div>
                                
                            </div>
                            <div class="data-client" v-if="isClientSelected">
                                <table
                                    class="data-table text-end"
                                >
                                    <tbody>
                                        <tr>
                                            <td>
                                                <div class="data-main">
                                                    <span class="data-title">Número: </span>
                                                    <span class="data-value">{{ clientDetails.client_ident }}</span>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="data-main">
                                                    <span class="data-title">Calle: </span>
                                                    <span class="data-value">{{ clientDetails.client_address.street }}</span>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="data-main">
                                                    <span class="data-title">C.P: </span>
                                                    <span class="data-value">{{ clientDetails.client_address.codigoPostal }}</span>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="data-main">
                                                    <span class="data-title">Colonia: </span>
                                                    <span class="data-value">{{ clientDetails.client_address.neighborhood }}</span>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="data-main">
                                                    <span class="data-title">Ciudad: </span>
                                                    <span class="data-value">{{ clientDetails.client_address.city }}</span>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <div class="data-main">
                                                    <span class="data-title">Ciudad: </span>
                                                    <span class="data-value">{{ clientDetails.client_address.city }}</span>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="data-main">
                                                    <span class="data-title">Estado: </span>
                                                    <span class="data-value">{{ clientDetails.client_address.state }}</span>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="data-main">
                                                    <span class="data-title">RFC: </span>
                                                    <span class="data-value">{{ clientDetails.client_rfc }}</span>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="data-main">
                                                    <span class="data-title">Teléfono: </span>
                                                    <span class="data-value">{{ clientDetails.phone }}</span>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="data-client" v-if="addNewClient">
                                <table class="data-table">
                                    <tbody>
                                        <tr>
                                            <td>
                                                <div class="form-input-group">
                                                    <label for="client_street">Recurrente</label>
                                                    <div>
                                                        <label class="switch">
                                                            <input type="checkbox" id="isVip" v-model="clientDetails.is_privileged">
                                                            <span class="slider round"></span>
                                                        </label>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="form-input-group">
                                                    <label for="client_street">Calle</label>
                                                    <input type="text" id="client_street" v-model="clientDetails.client_address.street" />
                                                </div>
                                            </td>
                                            <td>
                                                <div class="form-input-group">
                                                    <label for="client_codigoPostal">C.P</label>
                                                    <input type="text" id="client_codigoPostal" placeholder="Ej. 64849" v-model="clientDetails.client_codigoPostal" @keypress="validatePositiveIntegerField"/>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="form-input-group">
                                                    <label for="client_neighborhood">Colonia</label>
                                                    <input type="text" id="client_neighborhood" placeholder="Ej. Tecnológico" v-model="client_neighborhood" />
                                                </div>
                                            </td>
                                            <td>
                                                <div class="form-input-group">
                                                    <label>Tipo</label>
                                                    <select v-model="clientDetails.client_type">
                                                        <option value='Asistencia'>Asistencia</option>
                                                        <option value='Aseguradora'>Aseguradora</option>
                                                        <option value='Cliente en general'>Cliente en general</option>
                                                    </select>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colspan="2">
                                                <div class="form-input-group">
                                                    <label for="client_city">Ciudad</label>
                                                    <input type="text" id="client_city" placeholder="Ingrese una ciudad" v-model="client_city" />
                                                </div>
                                            </td>
                                            <td>
                                                <div class="form-input-group">
                                                    <label for="client_state">Estado</label>
                                                    <select class="state-dropdown" id="client_state" v-model="client_state">
                                                        <option v-for="state in allStates" :key="state.name" :value="state.name">
                                                            {{ state.name }}
                                                        </option>
                                                    </select>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="form-input-group">
                                                    <label for="client_rfc">RFC</label>
                                                    <input type="text" id="client_rfc" placeholder="Ingrese el RFC" v-model="clientDetails.client_rfc" />
                                                </div>
                                            </td>
                                            <td>
                                                <div class="form-input-group">
                                                    <label for="phone">Teléfono</label>
                                                    <input type="text" id="phone" v-model="clientDetails.phone" />
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div class="buttons-for-saveClient pt-1">
                                    <button type="submit" class="btn-submit-save" @click="saveNewClient">Guardar datos del nuevo cliente</button>
                                    <button @click="cancelNewClient" class="btn-submit-cancel">Cancelar</button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="container-card">
                        <div class="title">
                            <h4>Datos del vehículo</h4>
                            <img src="@/assets/vehicle-icon.png">
                        </div>
                        <div class="container-card-body">
                            <table class="data-table">
                                <tbody>
                                    <tr>
                                        <td>
                                            <div>
                                                <label class="custom-checkbox">
                                                    Enviar a lote
                                                    <input type="checkbox" checked="checked" v-model="sendToLot" :disabled="blockEdit">
                                                    <span class="checkmark"></span>
                                                </label>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="form-input-group">
                                                <label for="vehicle_brand">Marca: </label>
                                                <select class="state-dropdown" v-model="localNoteDetails.vehicle_brand" @change="FetchFilteredSubBrands" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit, 'missing-required-field': missingRequiredFieldMap.vehicle_brand }">
                                                    <option v-for="(brand, pk) in brands" :key="brand" :value="brand">
                                                        {{ pk }}
                                                    </option>
                                                </select>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="form-input-group">
                                                <label for="vehicle_subbrand">Submarca: </label>
                                                <select class="state-dropdown" v-model="localNoteDetails.vehicle_sub_brand" :disabled="blockEdit || subBrandLoading"
                                                :class="{ 'grayed-out': blockEdit, 'sub-brand-loading-grayed-out': subBrandLoading, 'missing-required-field': missingRequiredFieldMap.vehicle_sub_brand }">
                                                    <option v-for="(sub_brand, id) in sub_brands" :key="sub_brand" :value="sub_brand">
                                                        {{ id }}
                                                    </option>
                                                </select> 
                                            </div>
                                        </td>
                                        <td>
                                            <div class="form-input-group">
                                                <label for="vehicle_model">Modelo: </label>
                                                <input type="text" id="vehicle_model" placeholder="Si desconoce, deje vacío. (Formato YYYY)" v-model="localNoteDetails.vehicle_model" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }" @keypress="validatePositiveIntegerField"/>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div class="form-input-group">
                                                <label for="vehicle_plates">Placas: </label>
                                                <input type="text" id="vehicle_plates" placeholder="Ingrese las placas" v-model="localNoteDetails.vehicle_plates" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }"/>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="form-input-group">
                                                <label for="vehicle_engine_series">Serie: </label>
                                                <input type="text" id="vehicle_engine_series" placeholder="Ingrese la serie" v-model="localNoteDetails.vehicle_engine_series" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }"/>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="form-input-group">
                                                <label for="vehicle_color">Color&nbsp;1: </label>
                                                <input type="text" id="vehicle_color" placeholder="Ingrese el color" v-model="localNoteDetails.vehicle_color" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }"/>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="form-input-group">
                                                <label for="vehicle_color2">Color&nbsp;2:</label>
                                                <input type="text" id="vehicle_color2" placeholder="Ingrese el color 2" v-model="localNoteDetails.vehicle_color2" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }"/>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div class="form-input-group">
                                                <label for="insurance_policy">Póliza:</label>
                                                <input type="text" id="insurance_policy" placeholder="Ingrese la póliza" v-model="localNoteDetails.insurance_policy" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }"/>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="form-input-group">
                                                <label for="vehicle_owner_name">Asegurado: </label>
                                                <input type="text" id="vehicle_owner_name" placeholder="Ingrese el nombre del asegurado" v-model="localNoteDetails.vehicle_owner_name" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }"/>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="form-input-group">
                                                <label for="file_number">Expediente: </label>
                                                <input type="text" id="file_number" placeholder="Ingrese el expediente" v-model="localNoteDetails.file_number" :disabled="blockEdit" :class="['expediente-field', { 'grayed-out': blockEdit }]"/>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="form-input-group">
                                                <label for="sucursal">Sucursal: </label>
                                                <select class="state-dropdown" id="sucursal" v-model="localNoteDetails.sucursal" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }">
                                                    <option v-for="opt in $catalogs.sucursales" :key="opt" :value="opt">{{ opt }}</option>
                                                </select>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div class="form-input-group">
                                                <label for="file_number">Aprobado&nbsp;por:</label>
                                                <input type="text" id="approved_by" placeholder="Ingrese el nombre de quien aprueba" v-model="localNoteDetails.approved_by" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }"/>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="form-input-group">
                                                <label for="expected_time">Tiempo&nbsp;estimado:</label>
                                                <input type="text" id="expected_time" placeholder="Ingrese el tiempo esperado en minutos" v-model="localNoteDetails.expected_time" />
                                            </div>
                                        </td>
                                        <td>
                                            <div class="form-input-group" >
                                                <label for="???">Lote</label>
                                                <select class="state-dropdown" type="text" id="payment_method" v-model="localNoteDetails.lot">
                                                    <option v-for="opt in $catalogs.lotes" :key="opt" :value="opt">{{ opt }}</option>
                                                </select>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="form-input-group" >
                                                <label for="???">Retención</label>
                                                <select class="state-dropdown" type="text" id="payment_method" v-model="localNoteDetails.lot_retention">
                                                    <option value="A DISPOSICION DE SU DUEÑO">A DISPOSICION DE SU DUEÑO</option>
                                                    <option value="ABANDONO">ABANDONO</option>
                                                    <option value="ACCIDENTE">ACCIDENTE</option>
                                                    <option value="ATROPELLO">ATROPELLO</option>
                                                    <option value="EMBARGO">EMBARGO</option>
                                                    <option value="INFRACCIONES">INFRACCIONES</option>
                                                    <option value="INVESTIGACIONES">INVESTIGACIONES</option>
                                                    <option value="OPERATIVO AA">OPERATIVO AA</option>
                                                </select>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="2">
                                            <div class="form-input-group">
                                                <label for="???">Autoridad</label>
                                                <select class="state-dropdown" type="text" id="lot_authority" v-model="localNoteDetails.lot_authority">
                                                    <option value="">-Ninguno-</option>
                                                    <option v-for="opt in $catalogs.autoridades" :key="opt" :value="opt">{{ opt }}</option>
                                                </select>
                                            </div>
                                            <!-- <div class="form-input-group" >
                                                <label for="???">Autoridad</label>
                                                <input type="text" id="???" placeholder="Ingrese la autoridad" v-model="localNoteDetails.lot_authority"/>
                                            </div> -->
                                        </td>
                                        <td>
                                            <div class="form-input-group justify-content-end">
                                                <label>Ingreso al lote: </label>
                                                <!-- <div class="text-color-for-date"><label>{{ formatDateTime(assignationData.arrival_time) }}</label></div> -->
                                                <input type="datetime-local" style="max-width: 200px;" :value="localNoteDetails.lot_start_time ? localNoteDetails.lot_start_time.slice(0, 16) : ''" @input="updateLotStartTime($event.target.value)"/>  <!--v-model="lot_start_time"/>-->
                                            </div>
                                        </td>
                                        <td>
                                            <div class="form-input-group justify-content-end">
                                                <label>Salida del lote: </label>
                                                <!-- <div class="text-color-for-date"><label>{{ formatDateTime(assignationData.arrival_time) }}</label></div> -->
                                                <input type="datetime-local" style="max-width: 200px;" :value="localNoteDetails.lot_end_time ? localNoteDetails.lot_end_time.slice(0, 16) : ''" @input="updateLotEndTime($event.target.value)"/> 
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div class="form-input-group">
                                                <label for="insurance_incident">Siniestro:</label>
                                                <input type="text" id="insurance_incident" placeholder="Ingrese el siniestro" v-model="localNoteDetails.insurance_incident" />
                                            </div>
                                        </td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    
                    <div class="container-card">
                        <div class="title">
                            <h4>Origen</h4>
                            <img src="@/assets/ubi-icon.png">
                        </div>
                        <div class="container-card-body">
                            <table class="data-table">
                                <tbody>
                                    <tr>
                                        <td>
                                            <div>
                                                <label class="custom-checkbox">
                                                    Servicio carretero
                                                    <input type="checkbox" id="toggleFields" v-model="showOptionalFields" :disabled="blockEdit">
                                                    <span class="checkmark"></span>
                                                </label>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="form-input-group">
                                                <label for="source_street">Calle&nbsp;y&nbsp;número: </label>
                                                <input type="text" id="source_street" v-model = "localNoteDetails.source.street_name" placeholder="Ingrese la calle y número principal" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }"/>
                                            </div>
                                        </td>
                                        
                                        <td>
                                            <div class="form-input-group" v-show="!showOptionalFields">
                                                <label for="source_inbtw">Entrecalles: </label>
                                                <input type="text" id="source_inbtw" v-model = "localNoteDetails.source.between_streets" placeholder="Ingrese entre que calles se encuentra" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }"/>
                                            </div>
                                        </td>
                                        <td>
                                            <!-- <div class="form-input-group" v-show="!showOptionalFields">
                                                <label for="source_number">Número: </label>
                                                <input type="text" id="source_number" v-model = "localNoteDetails.source.number" placeholder="Ingrese el número" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }"/>
                                            </div> -->
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div class="form-input-group" v-show="!showOptionalFields">
                                                <label for="source_neighborhood">Colonia: </label>
                                                <input type="text" id="source_neighborhood" v-model = "localNoteDetails.source.neighborhood" placeholder="Ingrese la colonia" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }"/>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="form-input-group">
                                                <label for="source_postal_code">C.P: </label>
                                                <input type="text" id="source_postal_code" v-model = "localNoteDetails.source.zip_code" placeholder="Ingrese el código postal" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }" @keypress="validatePositiveIntegerField"/>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="form-input-group" v-show="!showOptionalFields" style="position: relative;">
                                                <label for="source_municipality">Municipio: </label>
                                                <input type="text" id="source_municipality" v-model="localNoteDetails.source.city" @input="sourceFilterMunicipalities" placeholder="Ingrese el municipio" autocomplete="off" />
                                                <ul class="muni-dropdown" v-if="sourceFilteredMunicipalities.length" v-click-outside="closeDropdown">
                                                    <li v-for="(municipality, index) in sourceFilteredMunicipalities" :key="index" @click="sourceSelectMunicipality(municipality)">
                                                        {{ municipality }}
                                                    </li>
                                                </ul>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="form-input-group" v-show="!showOptionalFields">
                                                <label for="source_state">Estado: </label>
                                                <select id="source_state" v-model="localNoteDetails.source.state" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }">
                                                    <option v-for="state in allStates" :key="state.name" :value="state.name">
                                                        {{ state.name }}
                                                    </option>
                                                </select>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div class="form-input-group">
                                                <label for="source_lat">Latitud: </label>
                                                <input type="text" id="source_lat" v-model="localNoteDetails.source.lat" placeholder="Ingrese la latitud" @keypress="validateFloatField" :disabled="blockEdit" :class="[{ 'grayed-out': blockEdit }, {'input-error': !isSourceLatValid}, { 'missing-required-field': missingRequiredFieldMap.source_lat }]"/>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="form-input-group">
                                                <label for="source_long">Longitud: </label>
                                                <input type="text" id="source_long" v-model="localNoteDetails.source.lon" placeholder="Ingrese la longitud" @keypress="validateFloatField" :disabled="blockEdit" :class="[{ 'grayed-out': blockEdit }, {'input-error': !isSourceLonValid}, { 'missing-required-field': missingRequiredFieldMap.source_lon }]"/>
                                            </div>
                                        </td>
                                        <td>
  <div class="form-input-group">
    <label>Coords:</label>
    <input
      type="text"
      v-model="source_coords_helper"
      placeholder="lat, lon"
      :disabled="blockEdit"
      :class="[{ 'grayed-out': blockEdit }]"
    />
  </div>
</td>
                                        <td>
                                            <div class="form-input-group" v-show="showOptionalFields">
                                                <label for="source_km" style="white-space: nowrap;">KM (Solo si es en carretera): </label>
                                                <input type="text" id="source_km" v-model = "localNoteDetails.source_km" placeholder="Ingrese el KM de la carretera" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }" @keypress="validatePositiveIntegerField"/>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="4">
                                            <div class="form-input-group d-block text-start">
                                                <label for="source_notes">Observaciones: </label>
                                                <div class="row">
                                                    <div class="col">
                                                        <textarea id="source_notes" rows="2" v-model = "localNoteDetails.source_notes" placeholder="Ingrese información adicional" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }"></textarea>
                                                    </div>
                                                    <div class="col ps-0">
                                                        <textarea id="quick_origin" rows="2" v-model = "localNoteDetails.quick_origin" placeholder="Ingrese el origen"></textarea>
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div class="container-card">
                        <div class="title">
                            <h4>Destino</h4>
                            <img src="@/assets/ubi-des-icon.png">
                        </div>
                        <div class="container-card-body">
                            <table class="data-table">
                                <tr>
                                    <td>

                                        <div>
                                            <label class="custom-checkbox">
                                                Servicio carretero
                                                <input type="checkbox" v-model="showOptionalFields1" :disabled="blockEdit">
                                                <span class="checkmark"></span>
                                            </label>
                                        </div>
                                    </td>
                                    <td colspan="2">
                                        <div class="form-input-group">
                                            <label for="source_street" style="white-space: nowrap;">Calle y número: </label>
                                            <input type="text" id="source_street" v-model= "localNoteDetails.destination.street_name" placeholder="Ingrese la calle y número principal" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }"/>
                                        </div>
                                    </td>
                                    
                                    <td>
                                        <div class="form-input-group" v-show="!showOptionalFields1">
                                            <label for="source_inbtw">Entrecalles: </label>
                                            <input type="text" id="source_inbtw" v-model= "localNoteDetails.destination.between_streets" placeholder="Ingrese entre que calles se encuentra" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }"/>
                                        </div>
                                    </td>
                                    <!-- <td>
                                        <div class="form-input-group" v-show="!showOptionalFields1">
                                            <label for="source_number">Número: </label>
                                            <input type="text" id="source_number" v-model = "localNoteDetails.destination.number" placeholder="Ingrese el número" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }"/>
                                        </div>
                                    </td> -->
                                </tr>
                                <tr>
                                    <td>
                                        <div class="form-input-group" v-show="!showOptionalFields1">
                                            <label for="source_neighborhood">Colonia: </label>
                                            <input type="text" id="source_neighborhood" v-model = "localNoteDetails.destination.neighborhood" placeholder="Ingrese la colonia" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }"/>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="form-input-group">
                                            <label for="source_postal_code">C.P: </label>
                                            <input type="text" id="source_postal_code" v-model="localNoteDetails.destination.zip_code" placeholder="Ingrese el código postal" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }" @keypress="validatePositiveIntegerField"/>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="form-input-group position-relative" v-show="!showOptionalFields">
                                            <label for="destination_municipality">Municipio: </label>
                                            <input type="text" id="destination_municipality" v-model="localNoteDetails.destination.city" @input="destinationFilterMunicipalities" placeholder="Ingrese el municipio" autocomplete="off" />
                                            <ul class="muni-dropdown" v-if="destinationFilteredMunicipalities.length" v-click-outside="closeDropdown">
                                                <li v-for="(municipality, index) in destinationFilteredMunicipalities" :key="index" @click="destinationSelectMunicipality(municipality)">
                                                    {{ municipality }}
                                                </li>
                                            </ul>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="form-input-group" v-show="!showOptionalFields1">
                                            <label for="destination_state">Estado: </label>
                                            <select id="destination_state" v-model="localNoteDetails.destination.state" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }">
                                                <option v-for="state in allStates" :key="state.name" :value="state.name">
                                                    {{ state.name }}
                                                </option>
                                            </select>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <div class="form-input-group">
                                            <label for="source_lat">Latitud: </label>
                                            <input type="text" id="source_lat" v-model="localNoteDetails.destination.lat" placeholder="Ingrese la latitud" @keypress="validateFloatField" :disabled="blockEdit" :class="[{ 'grayed-out': blockEdit }, {'input-error': !isDestLatValid}, { 'missing-required-field': missingRequiredFieldMap.destination_lat }]"/>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="form-input-group">
                                            <label for="source_long">Longitud: </label>
                                            <input type="text" id="source_long" v-model="localNoteDetails.destination.lon" placeholder="Ingrese la longitud" @keypress="validateFloatField" :disabled="blockEdit" :class="[{ 'grayed-out': blockEdit }, {'input-error': !isDestLonValid}, { 'missing-required-field': missingRequiredFieldMap.destination_lon }]"/>
                                        </div>
                                    </td>
                                    <td>
  <div class="form-input-group">
    <label>Coords:</label>
    <input
      type="text"
      v-model="destination_coords_helper"
      placeholder="lat, lon"
      :disabled="blockEdit"
      :class="[{ 'grayed-out': blockEdit }]"
    />
  </div>
</td>
                                    <td colspan="2">
                                        <div class="form-input-group" v-show="showOptionalFields1">
                                            <label for="source_km">KM (Solo si es en carretera): </label>
                                            <input type="text" id="source_km" v-model="localNoteDetails.destination_km" placeholder="Ingrese el KM de la carretera" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }" @keypress="validatePositiveIntegerField"/>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="4">
                                        <div class="form-input-group d-block text-start">
                                            <label for="source_notes">Observaciones: </label>
                                            <div class="row">
                                                <div class="col">
                                                    <textarea id="source_notes" rows="2" v-model="localNoteDetails.destination_notes" placeholder="Ingrese información adicional" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }"></textarea>
                                                </div>
                                                <div class="col ps-0">
                                                    <textarea id="quick_destination" rows="2" v-model = "localNoteDetails.quick_destination" placeholder="Ingrese el destino"></textarea>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
                <!-- <div class="payment-data-container"> -->
                    
                <!-- </div> -->
                <div class="payment-data-container">
                    <div class="container-card" v-if="assignationsData.length > 0">
                        <div class="title">
                            <h4>Tiempos de asignación</h4>
                            <img src="@/assets/ubi-des-icon.png">
                        </div>
                        <div class="container-card-body">
                            <div class="d-flex justify-content-center">
                                <table class="data-table text-align-end " style="max-width: 400px;">
                                    <tr>
                                        <td>
                                            <div class="form-input-group justify-content-end">
                                                <label>Fecha y Hora de Inicio: </label>
                                                <!-- <div class="text-color-for-date"><label>{{ formatDateTime(assignationData.start_time) }}</label></div> -->
                                                <input type="datetime-local" style="max-width: 200px;" :value="assignationsData[0].start_time ? assignationsData[0].start_time.slice(0, 16) : ''" @input="updateStartTime($event.target.value, 0)"  :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }" />
                                                <!-- <label>Fecha y Hora de Inicio</label> -->
                                                <!-- <div class="text-color-for-date"><label>{{ formatDateTime(assignationData.start_time) }}</label></div> -->
                                                <!-- <input type="datetime-local" v-model="assignationData.start_time" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }" /> -->
                                            </div>
                                        </td>
                                        
                                    </tr>
                                    <tr>
                                        <td>
                                            <div class="form-input-group justify-content-end">
                                                <label>Fecha y Hora de Arribo: </label>
                                                <!-- <div class="text-color-for-date"><label>{{ formatDateTime(assignationData.arrival_time) }}</label></div> -->
                                                <input type="datetime-local" style="max-width: 200px;" :value="assignationsData[0].arrival_time ? assignationsData[0].arrival_time.slice(0, 16) : ''" @input="updateArrivalTime($event.target.value, 0)"  :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }" />
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div class="form-input-group justify-content-end">
                                                <label>Fecha y Hora de Contacto: </label>
                                                <!-- <div class="text-color-for-date"><label>{{ formatDateTime(assignationData.contact_time) }}</label></div> -->
                                                <input type="datetime-local" style="max-width: 200px;" :value="assignationsData[0].contact_time ? assignationsData[0].contact_time.slice(0, 16) : ''" @input="updateContactTime($event.target.value, 0)"  :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }" />
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div class="form-input-group justify-content-end">
                                                <label>Fecha y Hora de Termino: </label>
                                                <!-- <div class="text-color-for-date"><label>{{ formatDateTime(assignationData.end_time) }}</label></div> -->
                                                <input type="datetime-local" style="max-width: 200px;" :value="assignationsData[0].end_time ? assignationsData[0].end_time.slice(0, 16) : ''" @input="updateEndTime($event.target.value, 0)"  :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }" />
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div class="d-flex justify-content-end mt-1">
                                                <!-- <button class="btn-submit-save" @click="saveAssignation(assignationsData[0],0)" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }">Actualizar</button> -->
                                            </div>    
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>

                    <div class="container-card">
                        <div class="title">
                            <h4>Costos</h4>
                            <img src="@/assets/cost-icon.png">
                            <button @click="this.updateClientInvoiceInfo(this.localNoteDetails.client)" class="btn-clean-selection">Actualizar información del cliente</button>
                        </div>
                        <div class="container-card-body">

                            <table class="data-table">
                                <tbody>
                                    <tr>
                                        <td>
                                            <div class="form-input-group">
                                                <label for="cost_by_km" style="white-space: nowrap;">Costo por kilómetro: </label>
                                                <input type="text" id="cost_by_km" placeholder="Ingrese el costo por km" v-model="localNoteDetails.cost_by_km" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }"/>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="form-input-group">
                                                <label for="maneuvers">Maniobras: </label>
                                                <input type="text" id="maneuvers" placeholder="Ingrese las maniobras realizadas" v-model="localNoteDetails.maneuvers" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }"/>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="form-input-group">
                                                <label for="total_kms" style="white-space: nowrap;">Total de kilómetros: </label>
                                                <input type="text" id="total_kms" placeholder="Ingrese el total de kms" v-model="localNoteDetails.total_kms" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }"/>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div class="form-input-group">
                                                <label for="total_kms" style="white-space: nowrap;">Costo por tráfico: </label>
                                                <input type="text" id="cost_by_traffic" placeholder="Ingrese el costo por tráfico" v-model="localNoteDetails.cost_by_traffic" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }"/>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="form-input-group">
                                                <label for="highway_tolls">Casetas: </label>
                                                <input type="text" id="highway_tolls" placeholder="Ingrese el número de casetas pagadas" v-model="localNoteDetails.highway_tolls" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }"/>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="form-input-group">
                                                <label for="subtotal">Subtotal: </label>
                                                <input type="text" id="subtotal" placeholder="Ingrese el subtotal" v-model="localNoteDetails.subtotal" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }"/>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div class="form-input-group">
                                                <label for="lot_cost_per_day" style="white-space: nowrap;">Costo por día: </label>
                                                <input type="text" id="lot_cost_per_day" placeholder="Ingrese el costo" v-model="localNoteDetails.lot_cost_per_day" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }"/>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="form-input-group">
                                                <label for="lot_total_cost" style="white-space: nowrap;">Costo total de pensión: </label>
                                                <input type="text" id="lot_total_cost" placeholder="Ingrese el costo" v-model="localNoteDetails.lot_total_cost" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }"/>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div class="form-input-group">
                                                <label for="iva">IVA: </label>
                                                <input type="text" id="iva" placeholder="Ingrese el iva" v-model="localNoteDetails.iva" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }"/>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="form-input-group">
                                                <label for="retention">Retención: </label>
                                                <input type="text" id="retention" placeholder="Ingrese la retención" v-model="localNoteDetails.retention" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }"/>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="form-input-group">
                                                <label for="total">Total: </label>
                                                <input type="text" id="total" placeholder="Ingrese el total" v-model="localNoteDetails.total" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }"/>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div class="form-input-group">
                                                <label for="discount">Descuento: </label>
                                                <input type="text" id="discount" placeholder="Ingrese el descuento a aplicar" v-model="localNoteDetails.discount" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }"/>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div class="form-input-group">
                                                <label for="internal_payment_type" style="white-space: nowrap;">Tipo de pago: </label>
                                                <select class="state-dropdown" type="tel" id="internal-payment-type" v-model="localNoteDetails.internal_payment_type" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }">
                                                    <option value="80">80 - Error SAT</option>
                                                    <option value="23">23 - Pago remolque</option>
                                                    <option value="21">21 - Incobrable</option>
                                                    <option value="20">20 - Obsoleto</option>
                                                    <option value="9">9 - Transferencia bancaria</option>
                                                    <option value="8">8 - Remates</option>
                                                    <option value="7">7 - Ligada</option>
                                                    <option value="6">6 - Filial</option>
                                                    <option value="5">5 - Clave 8</option>
                                                    <option value="3">3 - Tarjeta de Crédito</option>
                                                    <option value="4">4 - Crédito</option>
                                                    <option value="2">2 - Cheque</option>
                                                    <option value="1">1 - Efectivo</option>
                                                </select>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="form-input-group">
                                                <label for="payment_method" style="white-space: nowrap;">Método de pago: </label>
                                                <select class="state-dropdown" id="payment_method" v-model="localNoteDetails.payment_method" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }">
                                                    <option value="PPD">PAGO EN PARCIALIDADES O DIFERIDO</option>
                                                    <option value="PUE">PAGO EN UNA EXHIBICIÓN</option>
                                                </select>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="form-input-group">
                                                <label for="payment_type" style="white-space: nowrap;">Forma de pago (SAT): </label>
                                                <select class="state-dropdown" id="payment-type" v-model="localNoteDetails.payment_type" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }">
                                                    <option value="99" v-if="localNoteDetails.payment_method === 'PPD'">POR DEFINIR</option>
                                                    <template v-if="localNoteDetails.payment_method !== 'PPD'">
                                                        <option value="99">POR DEFINIR</option>
                                                        <option value="04">TARJETA DE CRÉDITO</option>
                                                        <option value="03">TRANSFERENCIA</option>
                                                        <option value="01">EFECTIVO</option>
                                                        <option value="28">TARJETA DE DÉBITO</option>
                                                        <option value="02">CHEQUE NOMINATIVO</option>
                                                    </template>
                                                </select>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr style="vertical-align: top;">
                                        <td>
                                            <div class="form-input-group">
                                                <label for="invoice_use">CFDI: </label>
                                                <select class="state-dropdown" id="invoice_use" v-model="localNoteDetails.invoice_use" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }">
                                                    <option value="G01">ADQUISICIÓN DE MERCANCÍAS</option>
                                                    <option value="G02">DEVOLUCIOINES, DESCUENTOS O BONIFICACIONES</option>
                                                    <option value="G03">GASTOS EN GENERAL</option>
                                                    <option value="I01">CONSTRUCCIONES</option>
                                                    <option value="I02">MOBILIARIO Y EQUIPO DE OFICINA POR INVERSIONES</option>
                                                    <option value="I03">EQUIPO DE TRANSPORTE</option>
                                                    <option value="I04">EQUIPO DE CÓMPUTO Y ACCESORIOS</option>
                                                    <option value="I05">DADOS, TROQUELES, MOLDES, MATRICES Y HERRAMENTAL</option>
                                                    <option value="I06">COMUNICACIONES TELEFÓNICAS</option>
                                                    <option value="I07">COMUNICACIONES SATELITALES</option>
                                                    <option value="I08">OTRA MAQUINARIA Y EQUIPO</option>
                                                    <option value="D01">HONORARIOS MÉDICOS, DENTALES Y GASTOS HOSPITALARIOS</option>
                                                    <option value="D02">GASTOS MÉDICOS POR INCAPACIDAD O DISCAPACIDAD</option>
                                                    <option value="D03">GASTOS FUNERALES</option>
                                                    <option value="D04">DONATIVOS</option>
                                                    <option value="D05">INTERESES REALES EFECTIVAMENTE PAGADOS POR CRÉDITOS HIPOTECARIOS</option>
                                                    <option value="D06">APORTACIONES VOLUNTARIAS AL SAR</option>
                                                    <option value="D07">PRIMAS POR SEGUROS DE GASTOS MÉDICOS</option>
                                                    <option value="D08">GASTOS DE TRANSPORTACIÓN ESCOLAR OBLIGATORIA</option>
                                                    <option value="D09">DEPÓSITOS EN CUENTAS PARA EL AHORRO </option>
                                                    <option value="D10">PAGOS POR SERVICIOS EDUCATIVOS</option>
                                                    <option value="S01">SIN EFECTOS FISCALES</option>
                                                    <option value="CP01">PAGOS</option>
                                                    <option value="CN01">NÓMINA</option>
                                                </select>
                                            </div>
                                        </td>
                                        <td colspan="2">
                                            <div class="form-input-group d-block text-start">
                                                <label for="payment-notes" style="white-space: nowrap; margin-top: 0;">Notas del pago: </label>
                                                <textarea id="payment-notes" rows="2" placeholder="Ingrese notas del pago" v-model="localNoteDetails.payment_notes" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }"></textarea>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="commissions-validation-bar">
                    <label class="commissions-validation-label">
                        <input
                            type="checkbox"
                            v-model="localNoteDetails.commissions_validated"
                            :disabled="validatingCommissions || !canUpdateNote"
                        />
                        Comisiones validadas
                    </label>
                    <button
                        type="button"
                        class="btn-commission-validation"
                        :disabled="validatingCommissions || !canUpdateNote"
                        @click="saveCommissionsValidation"
                    >
                        {{ validatingCommissions ? 'Guardando...' : 'Guardar validación' }}
                    </button>
                </div>
                <div class="form-input-group" style="margin-top: 12px; max-width: 320px;">
                    <label for="lead_source">Origen marketing: </label>
                    <select class="state-dropdown" id="lead_source" v-model="localNoteDetails.lead_source" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }">
                        <option value="">Seleccionar origen</option>
                        <option value="Google">Google</option>
                        <option value="Facebook">Facebook</option>
                        <option value="Instagram">Instagram</option>
                        <option value="Recomendación">Recomendación</option>
                        <option value="Twitter">Twitter</option>
                        <option value="Otro">Otro</option>
                    </select>
                </div>
                </div>
            </div>

            <div class="table-footer">
                <form @submit.prevent="guardarDatos">
                    <table>
                        <thead>
                        <tr>
                            <th>No. unidad</th>
                            <th>Nombre de unidad</th>
                            <th>KM Inicio</th>
                            <th>KM Fin</th>
                            <th>No. operador</th>
                            <th>Nombre de operador</th>
                            <th>Comisiones</th>
                            <th>Acciones</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(grupo, index) in gruposCampos" :key="index">
                            <td>
                                <input type="text" v-model="grupo.unit" placeholder="Unidad" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }"/>
                            </td>
                            <td>
                                <label :class="{ 'grayed-out': blockEdit }">{{ grupo.unidad_name || 'Nombre Unidad' }}</label>
                            </td>
                            <td>
                                <input type="number" v-model.number="grupo.start_km" placeholder="KM Inicio" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }" @keypress="validatePositiveIntegerField"/>
                            </td>
                            <td>
                                <input type="number" v-model.number="grupo.end_km" placeholder="KM Fin" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }" @keypress="validatePositiveIntegerField"/>
                            </td>
                            <td>
                                <input type="text" v-model="grupo.operator" placeholder="Operador" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }" />
                            </td>
                            <td>
                                <label :class="{ 'grayed-out': blockEdit }">{{ grupo.operador_name + ' ' + grupo.operador_last_name || 'Nombre Operador' }}</label>
                            </td>
                            <td>
                                <input type="number" v-model.number="grupo.commission" placeholder="Comisión del operador" :disabled="isCommissionInputDisabled" :class="{ 'grayed-out': isCommissionInputDisabled }" step="any"/>
                            </td>
                            <td>
                                <button type="button" @click.prevent="eliminarCampos(index)" class="button-delete-operator" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }" > Eliminar </button>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    <div
                        class="table-footer-edit" 
                    >
                        <button @click.prevent="agregarCampos" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }">Agregar más operadores</button>
                        <!-- <button type="submit" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }" :style="{ backgroundColor: blockEdit ? '#d3d3d3' : '#2ada85', color: blockEdit ? 'black' : 'white'}">Guardar asignaciones</button> -->
                    </div>
                </form>
            </div>
            
        </div>

    <div v-if="currentForm === 'assignment' && canViewAssignationsTab" class="assignations-page">
            <div class="assignations-container">

                <!-- Time Data Section -->
                <div class="assignations-section time-section">
                <h3>Datos de tiempo</h3>
                <img src="@/assets/time-icon.png" class="assignations-icon">

                <div
                    v-for="(assignationData, index) in assignationsData"
                    :key="index"
                    class="assignations-time-block"
                >
                    <div class="void"></div>
                    <div class="assignations-form-group">
                    <div><b>Unidad:</b> {{ assignationData.unidad }}</div>
                    <div>{{ assignationData.unidad_name }}</div>
                    <div><b>Operador:</b> {{ assignationData.operador }}</div>
                    <div>{{ assignationData.operador_name }} {{ assignationData.operador_last_name }}</div>

                    <label>Fecha y Hora de Inicio</label>
                    <!-- <div class="assignations-date-label">{{ formatDateTime(assignationData.start_time) }}</div> -->
                    <!-- <input type="datetime-local" v-model="assignationData.start_time" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }" /> -->
                    <input type="datetime-local" style="max-width: 200px;" :value="assignationsData[index].start_time ? assignationsData[index].start_time.slice(0, 16) : ''" @input="updateStartTime($event.target.value, index)"  :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }" />

                    <label>Fecha y Hora de Arribo</label>
                    <!-- <div class="assignations-date-label">{{ formatDateTime(assignationData.arrival_time) }}</div> -->
                    <input type="datetime-local" style="max-width: 200px;" :value="assignationsData[index].arrival_time ? assignationsData[index].arrival_time.slice(0, 16) : ''" @input="updateArrivalTime($event.target.value, index)"  :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }" />

                    <label>Fecha y Hora de Contacto</label>
                    <!-- <div class="assignations-date-label">{{ formatDateTime(assignationData.contact_time) }}</div> -->
                    <input type="datetime-local" style="max-width: 200px;" :value="assignationsData[index].contact_time ? assignationsData[index].contact_time.slice(0, 16) : ''" @input="updateContactTime($event.target.value, index)"  :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }" />

                    <label>Fecha y Hora de Termino</label>
                    <!-- <div class="assignations-date-label">{{ formatDateTime(assignationData.end_time) }}</div> -->
                    <input type="datetime-local" style="max-width: 200px;" :value="assignationsData[index].end_time ? assignationsData[index].end_time.slice(0, 16) : ''" @input="updateEndTime($event.target.value, index)"  :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }" />
                    </div>

                <button class="assignations-btn-save" @click="saveAssignation(assignationData,index)" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }">Actualizar</button>
                </div>
                </div>

                <!-- Map Section -->
                <div class="assignations-section map-section">
                <h3>Asignación de unidad y operador</h3>
                <img src="@/assets/operator-assignament-icon.png" class="assignations-icon">

                <div class="assignations-map-container">
                    <Map :center="mapCenter" :zoom="10" map-type-id="roadmap" class="assignations-map">
                    <Marker v-if="showOriginMarker" :position="this.originMarkerPosition.value" :icon="require('@/assets/red-marker.png')" :options="{ zIndex: 99999 }" />
                    <Marker v-if="showDestinationMarker" :position="this.destinationMarkerPosition.value" :icon="blueMarkerIcon" :options="{ zIndex: 99998 }" />
                    </Map>
                </div>
                </div>

            <!-- Recommendations Section -->
                <div class="assignations-section recommend-section">
                    <h3>Sugerencias</h3>
                    <table class="assignations-table">
                    <tr>
                        <th>Recomendación</th>
                        <th>Número económico</th>
                        <th>Tiempo estimado de arribo (min)</th>
                        <th>Distancia estimada (km)</th>
                        <th>Seleccionar</th>
                    </tr>
                    <tr v-for="(rec, idx) in recommendations" :key="idx">
                        <td>{{ idx + 1 }}</td>
                        <td>{{ rec.unit }}</td>
                        <td>{{ rec.time_to_origin ?? rec.time_queue }}</td>
                        <td>{{ rec.distance_to_origin ?? '—' }}</td>
                        <td>
                        <button
                            @click="seleccionarOpcion(rec.unit)"
                            :disabled="buttonClicked['btn' + (idx+1)] || blockEdit || blockRecommend || !isRecommendationValid(rec)"
                            :class="{ 'grayed-out': buttonClicked['btn' + (idx+1)] || blockEdit || blockRecommend || !isRecommendationValid(rec) }"
                        >
                            Elegir
                        </button>
                        </td>
                    </tr>
                    </table>

                    <div class="assignations-actions">
                    <form @submit.prevent="guardarDatos">
                        <button @click.prevent="agregarCampos" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }">Agregar más operadores</button>
                        <button @click.prevent="fetchRecommendations()" :disabled="blockEdit||!blockRecommend||recommenderLoading" :class="{ 'grayed-out': !blockRecommend||recommenderLoading }">Recomendar</button>
                        <button type="button" @click.prevent="eliminarCampos()" class="assignations-btn-delete" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }">Eliminar</button>

                        <div v-for="(grupo, index) in gruposCampos" :key="index" class="assignations-extra-fields">
                            <div class="grupo-block">
                                <h4 class="grupo-title">Asignación {{ index + 1 }}</h4>

                                <div class="assignations-form-group">
                                <label :for="'unidad-' + index">Unidad asignada</label>
                                <input
                                    type="text"
                                    :id="'unidad-' + index"
                                    v-model="grupo.unit"
                                    :disabled="blockEdit"
                                    :class="{ 'grayed-out': blockEdit }"
                                />
                                </div>

                                <div class="assignations-form-group">
                                <label :for="'operador-' + index">Operador asignado</label>
                                <input
                                    type="text"
                                    :id="'operador-' + index"
                                    v-model="grupo.operator"
                                    :disabled="blockEdit"
                                    :class="{ 'grayed-out': blockEdit }"
                                />
                                </div>

                                <div class="assignations-form-group">
                                <label :for="'kmInicio-' + index">Km inicio</label>
                                <input
                                    type="text"
                                    :id="'kmInicio-' + index"
                                    v-model.number="grupo.start_km"
                                    :disabled="blockEdit"
                                    @keypress="validatePositiveIntegerField"
                                />
                                </div>

                                <div class="assignations-form-group">
                                <label :for="'kmFin-' + index">Km fin</label>
                                <input
                                    type="text"
                                    :id="'kmFin-' + index"
                                    v-model.number="grupo.end_km"
                                    :disabled="blockEdit"
                                    @keypress="validatePositiveIntegerField"
                                />
                                </div>
                            </div>
                        </div>

                        <button type="submit" class="assignations-btn-save" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }">Guardar</button>
                    </form>
                    </div>
                </div>
            </div>
        </div>

    <div v-if="currentForm === 'billing'">
        <div class="form-section">
            <h3>Facturación</h3>
            <img src="@/assets/cost-icon.png">
        </div>
        <div class="form-container">
            
            <div class="form-section">
                <h4>Datos de la factura</h4>
                <div class="checkbox-group">
                    <input type="checkbox" id="toggleFields2" v-model="invoiceBreakdown"> <!--:disabled="blockEdit" :class="{ 'grayed-out': blockEdit }"-->
                    <label for="toggleFields2">Desglosar factura</label>
                </div>
                <!-- Not breakdown options, default -->
                <div class="form-group" v-if="!invoiceBreakdown">
                    <label for="prefered_product_key_traffic">Clave de producto</label>
                    <select id="prefered_product_key_traffic" v-model="this.prefered_product_key_traffic"> <!--:disabled="blockEdit" :class="{ 'grayed-out': blockEdit }"-->
                        <option value="72154503">72154503 - SERVICIO DE ALQUILER DE GRUAS</option><!--GRUA-->
                        <option value="78121603">78121603 - TARIFA DE LOS FLETES</option><!--KILOMETRAJE-->
                        <option value="90121800">90121800 - SERVICIO DE ASISTENCIA DE EMERGENCIA EN VIAJES</option> <!--PASO DE CORRIENTE-->
                        <option value="81141601">81141601 - LOGÍSTICA</option> <!--MANIOBRA . MONTACARGAS 15 MIL LBS<-->
                        <option value="78101803">78101803 - SERVICIO DE TRANSPORTE DE VEHÍCULOS</option> <!--TRAFICO-->
                        <option value="78181702">78181702 - DE ALMACENAJE DE VEHICULOS DE TRANSPORTE</option> 
                        <option value="78181500">78181500 - SERVICIOS DE MANTENIMIENTO Y REPARACIÓN DE VEHÍCULOS</option> 
                        <option value="78121604">78121604 - SERVICIO DE ARRIENDO O LEASING DE MONTACARGAS</option> 
                </select> 
                </div>
                <div class="form-group" v-if="!invoiceBreakdown">
                    <label for="prefered_measurement_unit_traffic">Unidad de medida</label>
                    <select id="prefered_measurement_unit_traffic" v-model="this.prefered_measurement_unit_traffic"> <!--:disabled="blockEdit" :class="{ 'grayed-out': blockEdit }"-->
                        <option value="ACT">ACT - TRAFICO</option>
                        <option value="E48">E48 - UNIDAD DE SERVICIO</option>
                        <option value="H87">H87 - PIEZA</option>
                    </select> 
                </div>
                <!-- Breakdown, options from client -->
                <div class="checkbox-group" v-if="invoiceBreakdown">
                    <input type="checkbox" id="toggleFields3" v-model="invoiceBreakdownEdit"> <!--:disabled="blockEdit" :class="{ 'grayed-out': blockEdit }"-->
                    <label for="toggleFields3">Editar claves y unidades</label>
                </div>
                <div class="form-group" v-if="invoiceBreakdown && invoiceBreakdownEdit" >
                    <label for="prefered_product_key_pension_days">Clave de producto pensión</label>
                    <select id="prefered_product_key_pension_days" v-model="this.prefered_product_key_pension_days"> <!--:disabled="blockEdit" :class="{ 'grayed-out': blockEdit }"-->
                        <option value="72154503">72154503 - SERVICIO DE ALQUILER DE GRUAS</option><!--GRUA-->
                        <option value="78121603">78121603 - TARIFA DE LOS FLETES</option><!--KILOMETRAJE-->
                        <option value="90121800">90121800 - SERVICIO DE ASISTENCIA DE EMERGENCIA EN VIAJES</option> <!--PASO DE CORRIENTE-->
                        <option value="81141601">81141601 - LOGÍSTICA</option> <!--MANIOBRA . MONTACARGAS 15 MIL LBS<-->
                        <option value="78101803">78101803 - SERVICIO DE TRANSPORTE DE VEHÍCULOS</option> <!--TRAFICO-->
                        <option value="78181702">78181702 - DE ALMACENAJE DE VEHICULOS DE TRANSPORTE</option> 
                </select> 
                </div>
                <div class="form-group" v-if="invoiceBreakdown && invoiceBreakdownEdit">
                    <label for="prefered_measurement_unit_pension_days">Unidad de medida pensión</label>
                    <select id="prefered_measurement_unit_pension_days" v-model="this.prefered_measurement_unit_pension_days"> <!--:disabled="blockEdit" :class="{ 'grayed-out': blockEdit }"-->
                        <option value="ACT">ACT - TRAFICO</option>
                        <option value="E48">E48 - UNIDAD DE SERVICIO</option>
                        <option value="H87">H87 - PIEZA</option>
                    </select> 
                </div>
                <div class="form-group" v-if="invoiceBreakdown && invoiceBreakdownEdit">
                    <label for="prefered_product_key_traffic">Clave de producto tráfico</label>
                    <select id="prefered_product_key_traffic" v-model="this.prefered_product_key_traffic"> <!--:disabled="blockEdit" :class="{ 'grayed-out': blockEdit }"-->
                        <option value="72154503">72154503 - SERVICIO DE ALQUILER DE GRUAS</option><!--GRUA-->
                        <option value="78121603">78121603 - TARIFA DE LOS FLETES</option><!--KILOMETRAJE-->
                        <option value="90121800">90121800 - SERVICIO DE ASISTENCIA DE EMERGENCIA EN VIAJES</option> <!--PASO DE CORRIENTE-->
                        <option value="81141601">81141601 - LOGÍSTICA</option> <!--MANIOBRA . MONTACARGAS 15 MIL LBS<-->
                        <option value="78101803">78101803 - SERVICIO DE TRANSPORTE DE VEHÍCULOS</option> <!--TRAFICO-->
                        <option value="78181702">78181702 - DE ALMACENAJE DE VEHICULOS DE TRANSPORTE</option> 
                </select> 
                </div>
                <div class="form-group" v-if="invoiceBreakdown && invoiceBreakdownEdit">
                    <label for="prefered_measurement_unit_traffic">Unidad de medida tráfico</label>
                    <select id="prefered_measurement_unit_traffic" v-model="this.prefered_measurement_unit_traffic"> <!--:disabled="blockEdit" :class="{ 'grayed-out': blockEdit }"-->
                        <option value="ACT">ACT - TRAFICO</option>
                        <option value="E48">E48 - UNIDAD DE SERVICIO</option>
                        <option value="H87">H87 - PIEZA</option>
                    </select> 
                </div>
                <div class="form-group" v-if="invoiceBreakdown && invoiceBreakdownEdit">
                    <label for="prefered_product_key_cost_km">Clave de producto kilometraje</label>
                    <select id="prefered_product_key_cost_km" v-model="this.prefered_product_key_cost_km"> <!--:disabled="blockEdit" :class="{ 'grayed-out': blockEdit }"-->
                        <option value="72154503">72154503 - SERVICIO DE ALQUILER DE GRUAS</option><!--GRUA-->
                        <option value="78121603">78121603 - TARIFA DE LOS FLETES</option><!--KILOMETRAJE-->
                        <option value="90121800">90121800 - SERVICIO DE ASISTENCIA DE EMERGENCIA EN VIAJES</option> <!--PASO DE CORRIENTE-->
                        <option value="81141601">81141601 - LOGÍSTICA</option> <!--MANIOBRA . MONTACARGAS 15 MIL LBS<-->
                        <option value="78101803">78101803 - SERVICIO DE TRANSPORTE DE VEHÍCULOS</option> <!--TRAFICO-->
                        <option value="78181702">78181702 - DE ALMACENAJE DE VEHICULOS DE TRANSPORTE</option> 
                </select> 
                </div>
                <div class="form-group" v-if="invoiceBreakdown && invoiceBreakdownEdit">
                    <label for="prefered_measurement_unit_cost_km">Unidad de medida kilometraje</label>
                    <select id="prefered_measurement_unit_cost_km" v-model="this.prefered_measurement_unit_cost_km"> <!--:disabled="blockEdit" :class="{ 'grayed-out': blockEdit }"-->
                        <option value="ACT">ACT - TRAFICO</option>
                        <option value="E48">E48 - UNIDAD DE SERVICIO</option>
                        <option value="H87">H87 - PIEZA</option>
                    </select> 
                </div>
                <div class="form-group" v-if="invoiceBreakdown && invoiceBreakdownEdit">
                    <label for="prefered_product_key_maneuvers">Clave de producto maniobras</label>
                    <select id="prefered_product_key_maneuvers" v-model="this.prefered_product_key_maneuvers"> <!--:disabled="blockEdit" :class="{ 'grayed-out': blockEdit }"-->
                        <option value="72154503">72154503 - SERVICIO DE ALQUILER DE GRUAS</option><!--GRUA-->
                        <option value="78121603">78121603 - TARIFA DE LOS FLETES</option><!--KILOMETRAJE-->
                        <option value="90121800">90121800 - SERVICIO DE ASISTENCIA DE EMERGENCIA EN VIAJES</option> <!--PASO DE CORRIENTE-->
                        <option value="81141601">81141601 - LOGÍSTICA</option> <!--MANIOBRA . MONTACARGAS 15 MIL LBS<-->
                        <option value="78101803">78101803 - SERVICIO DE TRANSPORTE DE VEHÍCULOS</option> <!--TRAFICO-->
                        <option value="78181702">78181702 - DE ALMACENAJE DE VEHICULOS DE TRANSPORTE</option> 
                </select> 
                </div>
                <div class="form-group" v-if="invoiceBreakdown && invoiceBreakdownEdit">
                    <label for="prefered_measurement_unit_maneuvers">Unidad de medida maniobras</label>
                    <select id="prefered_measurement_unit_maneuvers" v-model="this.prefered_measurement_unit_maneuvers"> <!--:disabled="blockEdit" :class="{ 'grayed-out': blockEdit }"-->
                        <option value="ACT">ACT - TRAFICO</option>
                        <option value="E48">E48 - UNIDAD DE SERVICIO</option>
                        <option value="H87">H87 - PIEZA</option>
                    </select> 
                </div>
                <div class="form-group" v-if="invoiceBreakdown && invoiceBreakdownEdit">
                    <label for="prefered_product_key_service_hours">Clave de producto horas de servicio</label>
                    <select id="prefered_product_key_service_hours" v-model="this.prefered_product_key_service_hours"> <!--:disabled="blockEdit" :class="{ 'grayed-out': blockEdit }"-->
                        <option value="72154503">72154503 - SERVICIO DE ALQUILER DE GRUAS</option><!--GRUA-->
                        <option value="78121603">78121603 - TARIFA DE LOS FLETES</option><!--KILOMETRAJE-->
                        <option value="90121800">90121800 - SERVICIO DE ASISTENCIA DE EMERGENCIA EN VIAJES</option> <!--PASO DE CORRIENTE-->
                        <option value="81141601">81141601 - LOGÍSTICA</option> <!--MANIOBRA . MONTACARGAS 15 MIL LBS<-->
                        <option value="78101803">78101803 - SERVICIO DE TRANSPORTE DE VEHÍCULOS</option> <!--TRAFICO-->
                        <option value="78181702">78181702 - DE ALMACENAJE DE VEHICULOS DE TRANSPORTE</option> 
                </select> 
                </div>
                <div class="form-group" v-if="invoiceBreakdown && invoiceBreakdownEdit">
                    <label for="prefered_measurement_unit_service_hours">Unidad de medida horas de servicio</label>
                    <select id="prefered_measurement_unit_service_hours" v-model="this.prefered_measurement_unit_service_hours"> <!--:disabled="blockEdit" :class="{ 'grayed-out': blockEdit }"-->
                        <option value="ACT">ACT - TRAFICO</option>
                        <option value="E48">E48 - UNIDAD DE SERVICIO</option>
                        <option value="H87">H87 - PIEZA</option>
                    </select> 
                </div>
                <div class="form-input-group" v-if="(localNoteDetails.status === 4 || localNoteDetails.status === 6)">
                        <label for="invoice_series">Serie: </label>
                        <select id="invoice_series" v-model="invoiceSeries" :disabled=" localNoteDetails.status === 6" :class="{ 'grayed-out': localNoteDetails.status === 6 }"> <!--:disabled="blockEdit" :class="{ 'grayed-out': blockEdit }"-->
                            <option value="NG">NG</option> <!--PASO DE CORRIENTE-->
                            <option value="NSN">NSN</option> <!--MANIOBRA . MONTACARGAS 15 MIL LBS<-->
                            <option value="NR">NR</option> <!--TRAFICO-->
                            <option value="NI">NI</option><!--GRUA-->
                        </select>
                    </div>
                <div class="form-input-group" v-if="(client_rfc === 'XAXX010101000' || client_rfc === 'XEXX010101000') && (localNoteDetails.status === 4 || localNoteDetails.status === 6)">
                        <label for="retention">Periodicidad: </label>
                        <select id="invoice_generic_frequency" v-model="invoice_generic_frequency" :disabled=" localNoteDetails.status === 6" :class="{ 'grayed-out': localNoteDetails.status === 6 }"> <!--:disabled="blockEdit" :class="{ 'grayed-out': blockEdit }"-->
                            <option value="01">Diario</option> <!--PASO DE CORRIENTE-->
                            <option value="02">Semanal</option> <!--MANIOBRA . MONTACARGAS 15 MIL LBS<-->
                            <option value="03">Quincenal</option> <!--TRAFICO-->
                            <option value="04">Mensual</option><!--GRUA-->
                            <option value="05">Bimestral</option><!--KILOMETRAJE-->
                        </select>
                    </div>
                <div class="form-input-group" v-if="(client_rfc === 'XAXX010101000' || client_rfc === 'XEXX010101000') && (localNoteDetails.status === 4 || localNoteDetails.status === 6)">
                    <label for="retention">Mes: </label>
                    <input type="text" id="invoice_month" placeholder="Ingrese el mes" v-model="invoice_generic_month" :disabled="localNoteDetails.status === 6" :class="{ 'grayed-out': localNoteDetails.status === 6 }"/>
                </div>
                <div class="form-input-group" v-if="(client_rfc === 'XAXX010101000' || client_rfc === 'XEXX010101000') && (localNoteDetails.status === 4 || localNoteDetails.status === 6)">
                        <label for="retention">Año: </label>
                        <input type="text" id="invoice_year" placeholder="Ingrese el año" v-model="invoice_generic_year" :disabled="localNoteDetails.status === 6" :class="{ 'grayed-out': localNoteDetails.status === 6 }"/>
                </div>
            </div>
            <div class="form-section">
                <h4>Datos de la cartaporte</h4>
                <div class="checkbox-group">
                    <input type="checkbox" id="toggleFields1" v-model="cartaporte">
                    <label for="toggleFields1">Generar carta porte</label>
                </div>
                <div class="form-group1">
                    <label for="mercancia_descripcion">Descripción de mercancía</label>
                    <input type="text" id="mercancia_descripcion" placeholder="Ingrese la descripción de mercancía" v-model="localNoteDetails.mercancia_descripcion"/>
                </div>
                <div class="form-group1">
                    <label for="mercancia_valor">Valor del vehículo</label>
                    <input type="text" id="mercancia_valor" placeholder="Ingrese el valor del vehículo" v-model="localNoteDetails.mercancia_valor"/>
                </div>
                <div class="form-group1">
                    <label for="unit_inventory">UNIDADES DE MEDIDA DE LA MERCANCÍA</label>
                    <select id="unit_inventory" v-model="unit_inventory" >
                        <option value="E48">E48 - UNIDAD DE SERVICIO</option>
                        <option value="H87">H87 - PIEZA</option>
                    </select>
                </div>
                <div class="form-group1">
                    <label for="mercancia_peso">Peso de la mercancía (KGM)</label>
                    <input type="text" id="mercancia_peso" placeholder="Ingrese el peso de la mercancia" v-model="mercancia_peso"/>
                </div>
                <div class="form-group1">
                    <label for="bienes_transportados">Clave bienes transportados</label>
                    <input type="text" id="bienes_transportados" placeholder="Ingrese la clave de bienes transportados" v-model="bienes_transportados"/>
                </div>
                <div class="form-group1">
                    <label for="mercancia_dimensiones">Dimensiones de la mercancia </label>
                    <label for="mercancia_dimensiones">(Ej. 300/220/180cm)</label>
                    <input type="text" id="mercancia_dimensiones" placeholder="Ingrese las dimensiones de la mercancia" v-model="mercancia_dimensiones"/>
                </div>
            </div>
        </div>
        <div v-if="showPopup" class="popup-overlay" @click="closePopup">
            <div class="popup-content" @click.stop>
                <div class="popup-header">
                    <div class="popup-header-left">
                        <p><strong>Refacturación</strong></p>
                    </div>
                </div>    
                <div class="popup-body">   
                    <div class="form-group-filters">
                        <label for="relationship_type">Tipo de relación: </label>
                        <select id="relationship_type" v-model="relationship_type" class="form-select">
                            <!-- <option value='01'>Asistencia</option> -->
                            <option value='01'>01 - Nota de crédito de los documentos relacionados</option>
                            <option value='02'>02 - Nota de débito de los documentos relacionados</option>
                            <option value='03'>03 - Devolución de mercancía sobre facturas o traslados previos</option>
                            <option value='04'>04 - Sustitución de los CFDI previos</option>
                            <option value='05'>05 - Traslados de mercancías facturados previamente</option>
                            <option value='06'>06 - Factura generada por los traslados previos</option>
                            <option value='07'>07 - CFDI por aplicacióon de anticipo</option>
                            <option value='08'>08 - Factura generada por pagos en parcialidades</option>
                            <option value='09'>09 - Factura generada por pagos diferidos</option>
                            <!-- <option value='Cliente en general'>Cliente en general</option> -->
                        </select>
                    </div>
                    <div class="form-group-filters">
                        <label for="related_cfdi">CFDI relacionado: </label>
                        <input type="text" id="related_cfdi" placeholder="Ingrese el UUID relacionado" v-model="this.related_cfdi" />
                    </div>
                </div>
                <button v-if="canGenerateDocuments" class="popup-close-button" @click="generateInvoiceDocument">Generar factura</button>
                <button class="popup-close-button" @click="closePopup">Cerrar</button>
            </div>
        </div>
        <!-- <button class="btn-submit-savebilling-edit-assistance" @click="generateNoteDocument">Imprimir Orden de Trabajo</button> -->
        <!-- <button class="btn-submit-savebilling-edit-assistance" v-if="localNoteDetails.status === 4 || localNoteDetails.status === 6" @click="checkForRelatedInvoices">Generar factura</button> -->
         <button
                class="btn-submit-savebilling-edit-assistance"
                v-if="localNoteDetails.status === 4 || localNoteDetails.status === 6"
                @click="checkForRelatedInvoices"
                :disabled="saving_invoice"
                :class="{ 'saving-invoice': saving_invoice }"
                >
                {{ saving_invoice ? 'Generando...' : 'Generar factura' }}
            </button>
    </div>

    <div v-show="currentForm === 'images' && canViewImagesTab">
        <div class="form-section">
      <h3>Evidencia del siniestro</h3>
      <img src="@/assets/images-section.png">
    </div>
    <div class="form-container">
        <div class="form-section-images" v-for="section in imageSections" :key="section.loc">
            <div class="form-group-images">
            <label>{{ section.label }}</label>
            </div>
            <div class="image-container" v-if="section.images.default">
            <img :src="section.images.default">
            </div>
            <div class="image-container-upload" v-for="(image, index) in section.images.uploaded" :key="index">
            <div class="image-wrapper">
                <img :src="image">
                <button class="delete-button" @click="deleteImage(section, index)">x</button>
            </div>
            </div>
            <button class="btn-submit-upload-images" @click="uploadFile(section)"> Subir imágen</button>
            <button class="btn-submit-download-images" @click="downloadAllImages(section)"> Descargar imágenes</button>
        </div>
        </div>
    <div class="signature-container">
    <h3>Firma del Cliente:</h3>
    <div class="signature-box">
    <canvas ref="signatureCanvas" class="signature-canvas"></canvas>
</div>
</div>

<div class="text-inventory" v-if="canViewInventoryTab">
        <h1>Inventario</h1>
    </div>
    <div class="checkbox-group-inventory">
      <input type="checkbox" id="extinguidor" v-model="localNoteDetails.vehicle_inventory.extinguidor">
      <label for="extinguidor">Extinguidor</label>
    </div>
    <div class="checkbox-group-inventory">
      <input type="checkbox" id="cables_pasa_corriente" v-model="localNoteDetails.vehicle_inventory.cablesPasaCorriente">
      <label for="cables_pasa_corriente">Cables pasa corriente</label>
    </div>
    <div class="checkbox-group-inventory">
      <input type="checkbox" id="llave_birlo_seguridad" v-model="localNoteDetails.vehicle_inventory.llaveBirloSeguridad">
      <label for="llave_birlo_seguridad">Llave de birlo de seguridad</label>
    </div>
    <div class="checkbox-group-inventory">
      <input type="checkbox" id="llave_ruedas" v-model="localNoteDetails.vehicle_inventory.llaveRuedas">
      <label for="llave_ruedas">Llave de ruedas</label>
    </div>
    <div class="checkbox-group-inventory">
      <input type="checkbox" id="senales_carretera" v-model="localNoteDetails.vehicle_inventory.senalesCarretera">
      <label for="senales_carretera">Señales de carretera</label>
    </div>
    <div class="checkbox-group-inventory">
      <input type="checkbox" id="tarjeta_circulacion" v-model="localNoteDetails.vehicle_inventory.tarjetaCirculacion">
      <label for="tarjeta_circulacion">Tarjeta de circulación</label>
    </div>
    <div class="checkbox-group-inventory">
      <input type="checkbox" id="permiso_importacion" v-model="localNoteDetails.vehicle_inventory.permisoImportacion">
      <label for="permiso_importacion">Permiso de importación</label>
    </div>
    <div class="checkbox-group-inventory">
      <input type="checkbox" id="llaves" v-model="localNoteDetails.vehicle_inventory.llaves">
      <label for="llaves">Llaves</label>
    </div>
    <div class="checkbox-group-inventory">
      <input type="checkbox" id="llavero" v-model="localNoteDetails.vehicle_inventory.llavero">
      <label for="llavero">Llavero</label>
    </div>
    <div class="checkbox-group-inventory">
      <input type="checkbox" id="control" v-model="localNoteDetails.vehicle_inventory.control">
      <label for="control">Control</label>
    </div>
    <div class="checkbox-group-inventory">
      <input type="checkbox" id="antena" v-model="localNoteDetails.vehicle_inventory.antena">
      <label for="antena">Antena</label>
    </div>
    <div class="checkbox-group-inventory">
      <input type="checkbox" id="canastilla" v-model="localNoteDetails.vehicle_inventory.canastilla">
      <label for="canastilla">Canastilla</label>
    </div>
    <div class="checkbox-group-inventory">
      <input type="checkbox" id="emblemas" v-model="localNoteDetails.vehicle_inventory.emblemas">
      <label for="emblemas">Emblemas</label>
    </div>
    <div class="checkbox-group-inventory">
      <input type="checkbox" id="espoilers_delantero" v-model="localNoteDetails.vehicle_inventory.espoilersDelantero">
      <label for="espoilers_delantero">Espoilers delantero</label>
    </div>
    <div class="checkbox-group-inventory">
      <input type="checkbox" id="espoilers_trasero" v-model="localNoteDetails.vehicle_inventory.espoilersTrasero">
      <label for="espoilers_trasero">Espoilers trasero</label>
    </div>
    <div class="checkbox-group-inventory">
      <input type="checkbox" id="tapones_ruedas" v-model="localNoteDetails.vehicle_inventory.taponesRuedas">
      <label for="tapones_ruedas">Tapones ruedas</label>
    </div>
    <div class="checkbox-group-inventory">
      <input type="checkbox" id="tapon_gasolina" v-model="localNoteDetails.vehicle_inventory.taponGasolina">
      <label for="tapon_gasolina">Tapón gasolina</label>
    </div>
    <div class="checkbox-group-inventory">
      <input type="checkbox" id="tapa_armella_enganche" v-model="localNoteDetails.vehicle_inventory.tapaArmellaEnganche">
      <label for="tapa_armella_enganche">Tapa de armella de enganche</label>
    </div>
    <div class="checkbox-group-inventory">
      <input type="checkbox" id="porta_placas" v-model="localNoteDetails.vehicle_inventory.portaPlacas">
      <label for="porta_placas">Porta placas</label>
    </div>
    <div class="checkbox-group-inventory">
      <input type="checkbox" id="placas_delanteras" v-model="localNoteDetails.vehicle_inventory.placasDelanteras">
      <label for="placas_delanteras">Placas delanteras</label>
    </div>
    <div class="checkbox-group-inventory">
      <input type="checkbox" id="placas_trasera" v-model="localNoteDetails.vehicle_inventory.placasTrasera">
      <label for="placas_trasera">Placas trasera</label>
    </div>
    <div class="checkbox-group-inventory">
      <input type="checkbox" id="toldo" v-model="localNoteDetails.vehicle_inventory.toldo">
      <label for="toldo">Toldo</label>
    </div>
    <div class="checkbox-group-inventory">
      <input type="checkbox" id="quemacocos" v-model="localNoteDetails.vehicle_inventory.quemacocos">
      <label for="quemacocos">Quemacocos</label>
    </div>
    
    <div class="form-section">
      <div class="form-group-inventory">
        <label for="marca_bateria">Marca batería</label>
        <input type="text" id="marca_bateria" v-model="localNoteDetails.vehicle_inventory.marcaBateria" placeholder="Comentarios" />
      </div>
    </div>
    <div class="form-section">
      <div class="form-group-inventory">
        <label for="marca_radio">Marca radio estéreo</label>
        <input type="text" id="marca_radio" v-model="localNoteDetails.vehicle_inventory.marcaRadio" placeholder="Comentarios" />
      </div>
    </div>
    <div class="form-section">
      <div class="form-group-inventory">
        <label for="numero_bocinas">Número de bocinas</label>
        <input type="text" id="numero_bocinas" v-model="localNoteDetails.vehicle_inventory.numeroBocinas" placeholder="Comentarios" />
      </div>
    </div>
    <div class="form-section">
      <div class="form-group-inventory">
        <label for="numero_herramientas">Número de herramientas</label>
        <input type="text" id="numero_herramientas" v-model="localNoteDetails.vehicle_inventory.numeroHerramientas" placeholder="Comentarios" />
      </div>
    </div>
    <div class="form-section">
      <div class="form-group-inventory">
        <label for="tipo_gato">Tipo de gato</label>
        <input type="text" id="tipo_gato" v-model="localNoteDetails.vehicle_inventory.tipoGato" placeholder="Comentarios" />
      </div>
    </div>
    <div class="form-section">
      <div class="form-group-inventory">
        <label for="marca_llanta_refaccion">Marca llanta de refacción</label>
        <input type="text" id="marca_llanta_refaccion" v-model="localNoteDetails.vehicle_inventory.marcaLlantaRefaccion" placeholder="Comentarios" />
      </div>
    </div>
    <div class="form-section">
      <div class="form-group-inventory">
        <label for="rines">Rines</label>
        <input type="text" id="rines" v-model="localNoteDetails.vehicle_inventory.rines" placeholder="Escribir originales u Otra marca" />
      </div>
    </div>
    <div class="form-section">
      <div class="form-group-inventory">
        <label for="marca_llantas_vehiculo">Marca llantas del vehículo</label>
        <input type="text" id="marca_llantas_vehiculo" v-model="localNoteDetails.vehicle_inventory.marcaLlantasVehiculo" placeholder="Comentarios" />
      </div>
    </div>
    <div class="form-section">
      <div class="form-group-inventory">
        <label for="vida_llantas">Vida de las llantas</label>
        <input type="text" id="vida_llanta_del_izq" v-model="localNoteDetails.vehicle_inventory.vidaLlantasdelanteraIzq" placeholder="Delantera Izq" />
        <input type="text" id="vida_llanta_del_der" v-model="localNoteDetails.vehicle_inventory.vidaLlantasdelanteraDer" placeholder="Delantera Der" />
        <input type="text" id="vida_llanta_tras_izq" v-model="localNoteDetails.vehicle_inventory.vidaLlantastraseraIzq" placeholder="Trasera Izq" />
        <input type="text" id="vida_llanta_tras_der" v-model="localNoteDetails.vehicle_inventory.vidaLlantastraseraDer" placeholder="Trasera Der" />
      </div>
    </div>
    
    </div>

    <div v-if="currentForm === 'report' && canViewRouteReportTab">
    <div>
            <div class="report-map-container">
            <div class="report-map" id="map" style="width: 50%; height: 60vh;"></div>
                <div class="quote-text">
                    <h1>Ruta de unidad</h1>
                    <h2>Distancia de asignación a origen: {{ Number(base_to_origin) }} KM</h2>
                    <h2>Distancia de origen a destino: {{ Number(origin_to_destination) }} KM</h2>
                    <h2>Total de KMs recorridos: {{ Number(origin_to_destination) +  Number(base_to_origin)}} KM</h2>
                    <h2>Tiempo total utilizado: {{ timeToComplete }} horas</h2>
                    <h2>Costo antes de impuestos: ${{ Number(subtotal) }} pesos</h2>
                    <button @click="showMap" class="btn-save">Generar reporte</button>
                </div>
            </div>
        </div>
  </div>

</div>

<div class="d-flex justify-content-center gap-2 action-btns" style="min-width: 1200px;">
            <button type="submit" class="btn-submit-save-edit-assistance" @click="newSaveNote" v-if="canUpdateNote" :disabled="blockEdit||!isFormValid||saving_note" :class="{ 'grayed-out-missing-input':!isFormValid,'grayed-out': blockEdit, 'saving-note':saving_note }" :title="missingRequiredFieldsMessage" :data-missing-fields="missingRequiredFieldsMessage">Guardar</button>
            <button type="button" class="btn-submit-back" onclick="history.back()">Regresar</button>
            <button type="submit" class="btn-submit-complete" @click="completeNote" v-if="localNoteDetails.status !== 4 && allTimesCompletedBack && allTimesCompletedFront && canUpdateNote" :disabled=" localNoteDetails.status === 6" :class="{ 'grayed-out': localNoteDetails.status === 6 }">
                Completar nota
            </button>
            <button type="submit" class="btn-submit-close" @click="cancelNote" v-if="localNoteDetails.status !== 2  && canCancelNoteButton">Cancelar nota</button>
            <button class="btn-submit-savebilling-edit-assistance" @click="generateNoteDocument">Imprimir Orden de Trabajo</button>
            <button type="submit" class="btn-submit-reOpenNoEdit" @click="editNoReopen" v-if="localNoteDetails.status === 4 && localNoteDetails.status !== 6 && canEditNoteButton">
                Editar nota
            </button>
            <button
                type="button"
                class="btn-submit-save-edit-assistance"
                style="background-color: #001f3f; color: #ffffff;"
                v-if="isFacturada && canEditFacturadaCommissions"
                :disabled="savingCommissionChangesOnly || !gruposCampos.length"
                @click="toggleCommissionsEdition"
            >
                {{ commissionsEditMode ? (savingCommissionChangesOnly ? 'Guardando comisiones...' : 'Guardar comisiones') : 'Editar comisiones' }}
            </button>
</div>
</template>

<style>
    #app {
        margin-top: 0 !important;
    }

.missing-required-field {
    border-color: #e06a6a !important;
    background-color: #ffe7e7 !important;
    box-shadow: 0 0 0 2px rgba(224, 106, 106, 0.2), inset 0 1px 2px rgba(127, 29, 29, 0.1);
}


.expediente-field {
    font-size: 10px !important;
    padding-left: 6px !important;
    padding-right: 6px !important;
    letter-spacing: 0;
}

</style>

<style scoped>

.text-inventory {
    background-color: #444040; 
    color: rgb(255, 255, 255); 
    padding: 2px 5px; 
    border-radius: 3px;
    margin-bottom: 2vh;

    display: block;     /* ensures it takes full width by default */
    width: 100%;        /* span max horizontal length */
    box-sizing: border-box; /* makes sure padding doesn’t overflow */
}
.signature-container {
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.signature-pad {
    border: 1px solid black; /* Add a visible black border */
    box-sizing: border-box; /* Ensure padding and border are included in width/height */
    width: 100%; /* Canvas scales to fit container */
    height: 200px; /* Set a fixed height, adjust as needed */
    max-width: 500px; /* Optional: limit max width */
    touch-action: none; /* Prevent touch gestures from interfering */
    background-color: white; /* Optional: white background for clarity */
}

.signature-actions button {
    margin: 10px;
    padding: 8px 15px;
    background-color: #FFC434;
    border: none;
    border-radius: 5px;
    cursor: pointer;
}

.signature-actions button:hover {
    background-color: #E3AB00;
}

.logo-button {
    height: 40px;
}

.nav-bar-operations {
    height: 50px;
}

.muni-dropdown {
    position: absolute; /* Position relative to the parent container */
    top: 100%; /* Place it directly below the input field */
    left: 0; /* Align with the input field's left edge */
    z-index: 10000;
    width: 100%; /* Match the input field's width */
    background-color: #fff;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
    max-height: 200px;
    overflow-y: auto;
    list-style: none;
    padding: 0; /* Remove any default padding */
    margin: 0; /* Remove the left margin */
}

.muni-dropdown li {
    padding: 8px 12px;
    cursor: pointer;
}

.muni-dropdown li:hover,
.muni-dropdown li.active {
    background-color: #007bff;
    color: #fff;
}
.muni-dropdown {
    position: absolute; /* Position relative to the parent container */
    top: 100%; /* Place it directly below the input field */
    left: 0; /* Align with the input field's left edge */
    z-index: 10000;
    width: 100%; /* Match the input field's width */
    background-color: #fff;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
    max-height: 200px;
    overflow-y: auto;
    list-style: none;
    padding: 0; /* Remove any default padding */
    margin: 0; /* Remove the left margin */
}

.muni-dropdown li {
    padding: 8px 12px;
    cursor: pointer;
}

.muni-dropdown li:hover,
.muni-dropdown li.active {
    background-color: #007bff;
    color: #fff;
}

.dropdown-container {
    position: relative;
    z-index: 1050;
}

.dropdown {
    width: 100%; 
    background-color: #fff;
    border: 1px solid #f3f3f3;
    border-radius: 10px;
    box-shadow: 0 2px 5px rgba(56, 56, 56, 0.2);
    max-height: 200px;
    overflow-y: auto; 
    list-style: none;
    z-index: 1050;
    position: absolute;
}
.dropdown li {
    padding: 8px 12px;
    cursor: pointer;
    text-align: left;
    font-size: 14px;
    font-weight: 500;
}

.dropdown li:hover {
    background: #f3f3f3;
}

.dropdown li.active {
    background-color: #007bff;
    color: #fff;
}

.data-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
}

.state-dropdown option, select {
    font-size: .9rem;
}

.table-footer {
    display: flex;
    flex-direction: column; /* Stack items for better responsiveness */
    width: 100%;
    height: auto;
    margin-top: 5px;
}

.commissions-validation-bar {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 10px;
    margin: 8px 0 10px;
}

.commissions-validation-label {
        display: block;
        font-size: 11px;
        margin-bottom: 0;
        font-weight: 600;
        color: #4b5563;
}

.btn-commission-validation {
    border: 1px solid #5388b4;
    background-color: #5388b4;
    color: #fff;
    border-radius: 4px;
    padding: 5px 10px;
    font-size: 0.85rem;
    font-weight: 600;
}

.btn-commission-validation:disabled {
    opacity: 0.65;
    cursor: not-allowed;
}

.table-footer table {
    width: 100%; /* Table takes full width of its container */
    border-collapse: collapse; /* Collapse borders for compact layout */
    table-layout: auto; /* Ensure the table adapts to content */
}

.table-footer th, 
.table-footer td {
    padding: 4px 8px; /* Reduced padding for a smaller height */
    text-align: left;
    border: 1px solid #ddd; /* Add borders for clarity */
    /* white-space: nowrap;  */
    line-height: 1; /* Reduce line height for a more compact look */
}

.table-footer th {
    background-color: #5388b4;
    color: white;
    font-weight: bold;
    font-size: 14px;
}

.table-footer td input, 
.table-footer td label, 
.table-footer td button {
    padding: 2px 6px; /* Reduced padding to make rows smaller */
    width: auto; /* Let inputs/buttons adapt to content */
    box-sizing: border-box;
    font-size: 0.8rem; /* Slightly smaller font size */
    line-height: .9; 
}

.table-footer button {
    margin-top: 0px; 
    padding: 2px 6px; /* Smaller padding on buttons */
}

.table-footer button:disabled {
    background-color: #d3d3d3;
    cursor: not-allowed;
}

.table-footer-edit {
    display: flex;
    justify-content: center;
    gap: 8px;
    padding: 10px 0;
}

.table-footer-edit button {
    font-size: 14px;
    padding: 4px 15px !important;
    font-weight: bold;
}

@media (max-width: 768px) {

    

    .table-footer td::before {
        content: attr(data-label);
        position: absolute;
        left: 10px;
        width: calc(50% - 20px); /* Adjust width for labels */
        font-weight: bold;
        white-space: nowrap;
        line-height: .5; 
    }
}

/* The switch - the box around the slider */
.switch {
    position: relative;
    display: inline-block;
    width: 30px;
    height: 17px; 
    margin-right: 15px;
}

/* Hide default HTML checkbox */
.switch input {
    opacity: 0;
    width: 0;
    height: 0;
}

/* The slider */
.slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    -webkit-transition: .4s;
    transition: .4s;
}

.slider:before {
    position: absolute;
    content: "";
    height: 13px;
    width: 13px;
    left: 2px;
    bottom: 2px;
    background-color: white;
    -webkit-transition: .4s;
    transition: .4s;
}

input:checked + .slider {
    background-color: #2196F3;
}

input:focus + .slider {
    box-shadow: 0 0 1px #2196F3;
}

input:checked + .slider:before {
    -webkit-transform: translateX(13px);
    -ms-transform: translateX(13px);
    transform: translateX(13px);
}

/* Rounded sliders */
.slider.round {
    border-radius: 17px;
}

.slider.round:before {
    border-radius: 50%;
}
.checkbox-container {
    display: flex;
    align-items: center; /* Align items vertically */
    text-align: left; 
    font-weight: bold;
    width: 10vw;
    margin-left: 5px;
}

.form-input-group {
    display: flex;
    align-items: start;
    gap: 10px;
}

/* The container */
.custom-checkbox {
  display: block;
  position: relative;
  padding-left: 25px;
  font-size: 11px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  text-align: left;
}

/* Hide the browser's default checkbox */
.custom-checkbox input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.custom-checkbox .checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 15px;
  width: 15px;
  border-radius: 4px;
  border: 1px solid #d4d4d4;
  cursor: pointer;
}

.custom-checkbox input:disabled ~ .checkmark {
    border: 1px solid #e9e9e9;
    cursor: auto;
    background-color: white !important;
}

/* On mouse-over, add a grey background color */
.custom-checkbox:hover input ~ .checkmark {
  background-color: #f5f5f5;
}

/* When the checkbox is checked, add a blue background */
.custom-checkbox input:checked ~ .checkmark {
  background-color: #2196F3;
}

/* Create the checkmark/indicator (hidden when not checked) */
.custom-checkbox .checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.custom-checkbox input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.custom-checkbox .checkmark:after {
  left: 4px;
  top: 1.5px;
  width: 4px;
  height: 8px;
  border: solid white;
  border-width: 0 2px 2px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}

.custom-checkbox input:disabled ~ .checkmark:after {
    border-color: #c9c9c9;
}

.data-table td {
    border: none !important;
    padding-right: 5px; 
}

.data-table td:last-child {
    padding-right: 0;
}

.data-table tr {
    background: none !important;
}

.data-table {
    border: none !important;
}

.data-main {
    font-size: 11px;
    font-weight: 600;
    line-height: 16px;
    display: inline-block;
}
.data-main .data-value {
    color: #929292;
}

input[type=text], input[type=number], input[type=datetime-local], select, textarea {
        padding: 1.5px 8px;
        width: 100%;
        font-size: 12px;
        border: 1px solid #b7c3d4;
        border-radius: 5px;
        font-weight: 500;
        color: #1f2937;
        background-color: #ffffff;
        box-shadow: inset 0 1px 2px rgba(15, 23, 42, 0.06);
        transition: border-color 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease;
        outline: none;
        margin-bottom: 0;
}

input[type=text]:focus, input[type=number]:focus, input[type=datetime-local]:focus, select:focus, textarea:focus {
        border-color: #2f6feb;
        box-shadow: 0 0 0 2px rgba(47, 111, 235, 0.18), inset 0 1px 2px rgba(15, 23, 42, 0.06);
        background-color: #fbfdff;
}

label {
    display: block;
    font-size: 11px;
    margin-bottom: 0;
    font-weight: 600;
    color: #929292;
}

.form-input-group label {
    margin-top: 2px;
}

.main-data-container {
    display: grid;
    grid-template-columns: repeat(14, minmax(0, 1fr));
    gap: 12px;
}

.container-card {
        border: 1px solid #d5deea;
        border-radius: 0px;
        margin-bottom: 0px;
        border-top: none;
        background: linear-gradient(180deg, #ffffff 0%, #fbfcff 100%);
        box-shadow: 0 1px 3px rgba(15, 23, 42, 0.06);
}

.container-card-body {
    padding: 5px 8px;
}

.title {
        background: #d6e6fa;
        padding: 5px 15px;
        border-radius: 0;
        display: flex;
        align-items: center;
        gap: 10px;
        border-bottom: 1px solid #a9c3e4;
}

.title h4 {
        font-size: 16px;
        text-align: left;
        line-height: 20px;
        margin-bottom: 0;
        font-weight: 700;
        color: #1f3f66;
        letter-spacing: 0.2px;
}

.title img {
    width: 15px;
}


.nav-bar-operations {
    position: relative; 
}

.note-container {
    padding: 0 15px;
}

.create-order{
    display: flex;
    padding: 5px 0;
    justify-content: space-between;
}

#order_number {
    font-size: 18px;
    width: 100px;
    text-align: center;
}

.create-order h3 {
    font-size: 18px;
    font-weight: bold;
    padding-right: 10px;
}

.create-order .left {
    display: flex;
    align-items: center;
}

.create-order .right {
    display: flex;
    gap: 7px;
}

.create-order button {
    padding: 5px 15px;
    background-color: #d5171d;
    color: white;
    border: none;
    border-radius: 7px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    transition: .3s all;
}

.create-order button:hover {
    background: black;
}

.client-data-container {
    grid-column: span 8;
}

.client-data-container .btn-submit-save {
    background-color: #2ada85; /* Color del botón de enviar */
    color: #fff; /* Color del texto del botón */
    border: none;
    padding: 2px 10px;
    border-radius: 6px;
    cursor: pointer;
    font-size: 11px;
    font-weight: 600;
    white-space: nowrap;
    flex-shrink: 0;
    margin-right: 0;
}

.client-data-container .btn-submit-cancel {
    background-color: #d5171d; /* Color del botón de enviar */
    color: #fff; /* Color del texto del botón */
    border: none;
    padding: 2px 10px;
    border-radius: 6px;
    font-size: 11px;
    cursor: pointer;
    white-space: nowrap;
    flex-shrink: 0;
}

.payment-data-container {
    grid-column: span 6;
}

.payment-data-container .btn-submit-save {
    border: none;
    padding: 4px 10px;
    border-radius: 6px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 600;
    white-space: nowrap;
    flex-shrink: 0;
    margin-right: 0;
}

.client-data-container .buttons-for-saveClient {
    display: flex;
    justify-content: end;
    gap: 6px;
}

.form-container {
    display: flex;
    justify-content: space-between;
    margin: 5px;
}

.form-section, .form-section-images{
    flex-basis: calc(33% - 10px); /* Ajuste para margen entre secciones */
    margin-right: 10px; /* Margen entre secciones */
    background: #fff; /* Fondo para cada sección del formulario */
    padding: 20px;
    box-shadow: 0px 0px 10px rgba(0,0,0,0.1); /* Sombra suave para resaltar secciones */
}

.form-section-images img{
    width: 100px;
    height: 100px;
}

.image-container {
    margin-top: 10vh;
    width: 100%;
    height: 200px;
}

.image-container-upload {
    margin-top: 2vh;
    margin-bottom: 3vh;
    width: 100%;
    height: 200px;
}

.form-group-images{
    height: 8vh;
}

.image-container-upload img{
    width: 200px !important;
    height: 200px !important;
}


.form-section:last-child {
    margin-right: 0; /* Para que no haya margen a la derecha de la última sección */
}

h2 {
    margin-bottom: 20px; /* Espacio debajo de los títulos de sección */
}
.form-group label {
    text-align: left; /* Alinea el texto de la etiqueta a la izquierda */
    font-weight: bold; /* Hace que el texto de la etiqueta sea negrita */
    display: inline-block; /* Hace que la etiqueta sea en bloque pero alinee su contenido */
    width: 100%; /* Asegura que la etiqueta ocupe todo el ancho disponible */
}
.form-group1 label {
    text-align: left; /* Alinea el texto de la etiqueta a la izquierda */
    font-weight: bold; /* Hace que el texto de la etiqueta sea negrita */
    /* display: inline-block; Hace que la etiqueta sea en bloque pero alinee su contenido */
    width: 100%; /* Asegura que la etiqueta ocupe todo el ancho disponible */
    /* border: 2px; */
}
.form-section img{
    width: 40px;
    height: 40px;
}

.map-container {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 60vh;
    padding: 20px;
}
.map {
    width: 40vw; /* Ancho inicial para pantallas grandes */
    height: 50vh; /* Altura inicial para pantallas grandes */
}


.report-map-container {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 60vh;
    padding: 20px;
}
.report-map {
    width: 40vw; /* Ancho inicial para pantallas grandes */
    height: 50vh; /* Altura inicial para pantallas grandes */
}

table {
  width: 100%;
  border-collapse: collapse;
}

table, th, td {
  border: 1px solid black;
}

th {
  background-color: #000000;
  color: #FFC434;
}

tr:nth-child(even) {
  background-color: #f2f2f2;
}

tr:nth-child(odd) {
  background-color: #ffffff;
}

button {
    color: #ffffff;
    background-color: #FFC434;
    border: none;
    border-radius: 5px;
  /* Añadir estilos al botón si es necesario */
}
.time-data{
    display: grid;
    place-items: center;
}
.checkbox-group {
    display: flex;
    justify-content: flex-start; 
    gap: 5px; 
    font-weight: bold;
    width: 10vw;
    margin-left: 5px;   
}
.button-delete-operator{
    background-color: #ff0000;
    color: white;
    font-weight: bold;
    padding: 4px 10px !important;
    border-radius: 6px;   
}
.client-container .client-dropdown {
    position: absolute;
    z-index: 10000;
    width: 15vw; 
    background-color: #fff;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-shadow: 0 2px 5px rgba(0,0,0,0.2);
    max-height: 200px;
    overflow-y: auto; 
    margin-left: 20px;
}
.form-group .client-dropdown {
    position: absolute;
    z-index: 1000;
    width: 20vw; 
    background-color: #fff;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-shadow: 0 2px 5px rgba(0,0,0,0.2);
    max-height: 200px;
    overflow-y: auto; 
}
.client-dropdown div {
    padding: 10px;
    cursor: pointer;
    transition: background-color 0.2s;
}
.client-dropdown div:hover {
    background-color: #f2f2f2;
}
.form-group select {
    width: 20vw; 
    padding: 8px; 
    margin-bottom: 10px; 
    border: 1px solid #ccc;
    border-radius: 4px; 
    background-color: white; 
    -webkit-appearance: none; 
    -moz-appearance: none; 
    appearance: none; 
    position: relative;
    background-image: url('data:image/svg+xml;utf8,<svg fill="black" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M7 10l5 5 5-5z"/></svg>'); 
    background-repeat: no-repeat;
    background-position: right 8px top 50%; 
    background-size: 12px; 
}
.grayed-out {
    cursor: not-allowed;
}
.grayed-out-missing-input {
    opacity: 0.5; /* You can adjust the opacity to your preference */
    cursor: not-allowed;
    position: relative; /* Ensure button's position is relative */
}
.grayed-out-missing-input::after {
    content: attr(data-missing-fields);
    position: absolute;
    top: -50%; /* Center the text vertically */
    left: 50%; /* Center the text horizontally */
    transform: translate(-50%, -50%); /* Center the text both vertically and horizontally */
    background-color: rgba(0, 0, 0, 0.8);
    color: #fff;
    padding: 10px;
    border-radius: 5px;
    white-space: pre;
    z-index: 999;
    opacity: 0; /* Initially hide the text */
    transition: opacity 0.3s ease;
}

.grayed-out-missing-input:hover::after {
    opacity: 1; /* Show the text on hover */
}
.saving-note {
    opacity: 0.5; /* You can adjust the opacity to your preference */
    cursor: not-allowed;
    position: relative; /* Ensure button's position is relative */
}
.saving-invoice {
    opacity: 0.5; /* You can adjust the opacity to your preference */
    cursor: not-allowed;
    position: relative; /* Ensure button's position is relative */
}
.saving-note::after {
    content: "Espere a que se guarde la nota"; /* Text to show on mouse hover */
    position: absolute;
    top: -50%; /* Center the text vertically */
    left: 50%; /* Center the text horizontally */
    transform: translate(-50%, -50%); /* Center the text both vertically and horizontally */
    background-color: rgba(0, 0, 0, 0.8);
    color: #fff;
    padding: 10px;
    border-radius: 5px;
    white-space: nowrap;
    z-index: 999;
    opacity: 0; /* Initially hide the text */
    transition: opacity 0.3s ease;
}
.saving-invoice::after {
    content: "Espere a que se guarde la factura"; /* Text to show on mouse hover */
    position: absolute;
    top: -50%; /* Center the text vertically */
    left: 50%; /* Center the text horizontally */
    transform: translate(-50%, -50%); /* Center the text both vertically and horizontally */
    background-color: rgba(0, 0, 0, 0.8);
    color: #fff;
    padding: 10px;
    border-radius: 5px;
    white-space: nowrap;
    z-index: 999;
    opacity: 0; /* Initially hide the text */
    transition: opacity 0.3s ease;
}
.saving-note:hover::after {
    opacity: 1; /* Show the text on hover */
}
.saving-invoice:hover::after {
    opacity: 1; /* Show the text on hover */
}
.text-color-for-date{
    color: rgb(21, 0, 255);
}

.action-btns {
    padding-top: 15px;
}

.action-btns button {
    padding: 5px 15px;
    font-weight: bold;
    font-size: 14px;
    border-radius: 6px;
}

.btn-submit-save-edit-assistance {
    background-color: #2ada85; 
    color: #000000; 
    border: none;
    padding: 10px 20px;
    border-radius: 4px;
    cursor: pointer;
}
.btn-submit-savebilling-edit-assistance{
    background-color: #5d5d5d; 
    color: #ffffff; 
    border: none;
    padding: 10px 20px;
    border-radius: 4px;
    cursor: pointer;
}
.btn-submit-back {
    background-color: #ff7700; 
    color: #fff; 
    border: none;
    padding: 10px 20px;
    border-radius: 4px;
    cursor: pointer;
}
.btn-submit-complete {
    background-color: #00eeff; 
    color: #000000; 
    border: none;
    padding: 10px 20px;
    border-radius: 4px;
    cursor: pointer;
}
.btn-submit-close {
    background-color: #ff0000; 
    color: #fff; 
    border: none;
    padding: 10px 20px;
    border-radius: 4px;
    cursor: pointer;
}
.btn-submit-reOpen {
    background-color: #0000ff; 
    color: #fff; 
    border: none;
    padding: 10px 20px;
    border-radius: 4px;
    cursor: pointer;
}
.btn-submit-reOpenNoEdit {
    background-color: #7700ff; 
    color: #fff; 
    border: none;
    padding: 10px 20px;
    border-radius: 4px;
    cursor: pointer;
}
.btn-submit-upload-images{
    background-color: #b1d0ff; 
    color: #000000; 
    border: none;
    padding: 10px 20px;
    border-radius: 4px;
    cursor: pointer;
}

.btn-submit-download-images{
    margin-top: 2vh;
    background-color: #1d0061; 
    color: #ffffff; 
    border: none;
    padding: 10px 20px;
    border-radius: 4px;
    cursor: pointer;
}

.form-section-images {
  margin-bottom: 20px;
  clear: both;
}

.form-group-images {
  padding-bottom: 40px; /* Increased padding to ensure clear separation */
}

.image-container-upload {
  position: relative;
  display: inline-block;
  margin-right: 10px;
  margin-bottom: 10px;
}

.image-wrapper {
  position: relative;
  display: inline-block;
  margin: 10px; /* Ensure separation between images */
  vertical-align: top;
}

.image-wrapper img {
  display: block;
  max-width: 100%; /* Ensure the image doesn't overflow its container */
  border: 1px solid #ddd; /* Optional: add border for better visibility */
  border-radius: 4px; /* Optional: add border radius for better aesthetics */
  padding: 5px; /* Optional: add padding for better spacing */
}

.delete-button {
  position: absolute;
  top: 5px;
  right: 5px;
  background-color: red;
  color: white;
  border: none;
  border-radius: 50%;
  padding: 5px 10px;
  cursor: pointer;
}

.delete-button:hover {
  background-color: darkred;
}

.btn-submit-upload-images,
.btn-submit-download-images {
  display: block;
  margin-top: 10px;
}
/* Assignations Scoped Styling */
.assignations-page {
  background: #fafafa;
  padding: 15px;
  font-size: 12px;
}

/* .assignations-container {
  display: flex;
  justify-content: space-between;
  gap: 15px;
} */
.assignations-container {
  display: grid;
  grid-template-columns: .7fr 1.5fr .8fr; /* 3 equal columns */
  gap: 20px; /* space between columns */
  width: 100%;

}

.assignations-section {
  background: #fff;
  padding: 15px;
  border-radius: 8px;
  box-shadow: 0px 2px 6px rgba(0,0,0,0.1);
  overflow-y: auto; /* allows scroll if content is tall */
  /* flex: 1; */
}

.assignations-section h3 {
    font-size: 16px;
    font-weight: bold;
    color: #0f2f52;
    margin-bottom: 10px;
    background: #d1e4fb;
    border: 1px solid #9fbee2;
    border-left: 4px solid #2f6fb3;
    border-radius: 6px;
    padding: 6px 10px;
}

.assignations-icon {
  width: 35px;
  height: 35px;
  margin-bottom: 10px;
}

.assignations-time-block {
  border: 1px solid #ececec;
  padding: 10px;
  margin-bottom: 10px;
  border-radius: 6px;
  background: #f9f9f9;
}

.assignations-form-group label {
  font-weight: 600;
  font-size: 11px;
  margin-top: 5px;
  color: #666;
}

.assignations-date-label {
  font-size: 11px;
  color: #1a4fff;
  margin-bottom: 3px;
}

.assignations-btn-save {
  margin-top: 10px;
  padding: 4px 10px;
  border-radius: 6px;
  background: #2ada85;
  color: white;
  font-size: 12px;
  font-weight: bold;
  cursor: pointer;
  border: none;
}

.assignations-btn-delete {
  background: #ff0000;
  color: white;
  padding: 4px 10px;
  border-radius: 6px;
  font-weight: bold;
  border: none;
}

.assignations-map-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 55vh;
  width: 100%;
}

.assignations-map {
  width: 100%;
  height: 100%;
  border-radius: 8px;
  border: 1px solid #eee;
}

.assignations-table {
  width: 100% !important;
  border-collapse: collapse;
  margin-top: 10px;
  table-layout: auto; /* allows table to adjust column widths */
  /* min-width: 60  0px; optional: prevents squishing too much */
}

.assignations-table th {
  background: #222;
  color: #ffc434;
  font-size: 12px;
  padding: 5px;
}

.assignations-table td {
  text-align: center;
  padding: 5px;
  font-size: 11px;
}

.assignations-actions {
  margin-top: 15px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.assignations-extra-fields {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
  margin: 10px 0;
}

.grupo-block {
  display: block;
  width: 200% !important;          /* block fills wrapper */
  box-sizing: border-box;
  border: 1px solid #ddd;
  border-radius: 5px;
  padding: 5px;
  margin-bottom: 5px;
  background: #fafafa;
}

.grupo-title {
  font-size: 1rem;
  font-weight: bold;
  margin-bottom: 10px;
  color: #333;
}

input:disabled,
select:disabled {
    color: #4b5563;         /* keeps text legible */
    opacity: 1;             /* removes dimming */
    cursor: not-allowed;    /* still shows locked cursor */
    background-color: #f3f5f8;
    border-color: #c6d0dd;
}

.input-error {
  border: 2px solid red !important;
  box-shadow: 0 0 6px red;
}
</style>

<script>
/* global google */
import { ref } from 'vue'
import axios from 'axios';
import Swal from 'sweetalert2';
import { Map, Marker } from '@fawmi/vue-google-maps';
import Compressor from 'compressorjs';
import SignaturePad from 'signature_pad';
import NoteHistory from './NoteHistory.vue';
import NoteChat from './NoteChat.vue';
import NoteSurvey from './NoteSurvey.vue';
import { useDashboardWS } from '../composables/useDashboardWS';

export default {
    props: ['noteDetails', 'assignations', 'user_id', 'user_groups'],
    components: {
        Map,
        Marker,
        NoteHistory,
        NoteChat,
        NoteSurvey
    },
    setup() {
        // Chat pings (shared stream with the global bubble) drive the unread
        // badge on the Chat tab; there is no polling.
        const { onMessage: onChatWsMessage } = useDashboardWS('chat');
        return { onChatWsMessage };
    },
    data() {
        
        const mapCenter = ref({ lat: 25.66831199290133, lng: -100.2802354639708 })
        const originMarkerPosition = ref({ lat: 25.689214, lng: -100.314343 });
        const destinationMarkerPosition = ref({ lat: 25.689214, lng: -100.314343 });
        const showOriginMarker = ref(true);
        const showDestinationMarker = ref(true);
        const blueMarkerIcon = "https://maps.google.com/mapfiles/ms/icons/blue-dot.png";

        return {
            signatureOptions: {
            penColor: "black",
            backgroundColor: "rgba(255,255,255,1)",
            throttle: 16, // Smooth out strokes
        },
            permissions: [],
            buttonClicked: {
                btn1: false,
                btn2: false,
                btn3: false,
                btn4: false,
                btn5: false,
                images_tab : false,
            },
            blockEdit: false, //Linked to the note status, determines wheter the fields are enabled or not 
            localNoteDetails: {},
            mapCenter,
            originMarkerPosition,
            destinationMarkerPosition,
            showOriginMarker,
            showDestinationMarker,
            blueMarkerIcon,
            client_name: this.noteDetails.client,
            vehicle_brand: this.noteDetails.vehicle_brand,
            vehicle_sub_brand: this.noteDetails.vehicle_sub_brand,
            brands: [],
            sub_brands: [],
            subBrandLoading: true,
            // Since the user is encouraged to not fill this field if they dont know it, handle as needed
            vehicle_model: this.noteDetails.vehicle_model != null? this.noteDetails.vehicle_model.toString(): null,
            vehicle_plates: this.noteDetails.vehicle_plates,
            vehicle_engine_series: this.noteDetails.vehicle_engine_series,
            vehicle_color: this.noteDetails.vehicle_color,
            vehicle_color2: this.noteDetails.vehicle_color2,
            insurance_policy: this.noteDetails.insurance_policy,          
            vehicle_owner_name: this.noteDetails.vehicle_owner_name,
            file_number: this.noteDetails.file_number,
            source_street: this.noteDetails.source.street_name,
            source_between_streets: this.noteDetails.source.between_streets,
            source_neighborhood: this.noteDetails.source.neighborhood,
            // source_street_number: this.noteDetails.source.number,
            source_city: this.noteDetails.source.city,
            source_zip_code: this.noteDetails.source.zip_code,
            source_state: this.noteDetails.source.state,
            source_lat: this.noteDetails.source.lat,
            source_lon: this.noteDetails.source.lon,
            // not all services need source and destination km. Check the current value and adjust the display accordingly
            source_km: this.noteDetails.source_km != null ? this.noteDetails.source_km.toString() : null,
            source_references: this.noteDetails.source_notes,
            destination_street: this.noteDetails.destination.street_name,
            destination_between_streets: this.noteDetails.destination.between_streets,
            destination_neighborhood: this.noteDetails.destination.neighborhood,
            // destination_street_number: this.noteDetails.destination.number,
            destination_city: this.noteDetails.destination.city,
            destination_zip_code: this.noteDetails.destination.zip_code,
            destination_state: this.noteDetails.destination.state,
            destination_lat: this.noteDetails.destination.lat,
            destination_lon: this.noteDetails.destination.lon,
            // not all services need source and destination km. Check the current value and adjust the display accordingly
            destination_km: this.noteDetails.destination_km != null ? this.noteDetails.destination_km.toString() : null,
            destination_references: this.noteDetails.destination_notes,
            quick_origin: this.noteDetails.quick_origin,
            quick_destination: this.noteDetails.quick_destination,
            cost_by_km: this.noteDetails.cost_by_km,
            total_kms: this.noteDetails.total_kms,
            maneuvers: this.noteDetails.maneuvers,
            highway_tolls: this.noteDetails.highway_tolls,
            subtotal: this.noteDetails.subtotal,
            iva: this.noteDetails.iva,
            retention: this.noteDetails.retention,
            total: this.noteDetails.total,
            //total_ovr: this.noteDetails.total_ovr,
            payment_method: this.noteDetails.payment_method,
            internal_payment_type: this.noteDetails.internal_payment_type,
            payment_type: this.noteDetails.payment_type,
            invoice_use: this.noteDetails.invoice_use,
            payment_notes: this.noteDetails.payment_notes,
            metodo_pago: this.noteDetails.metodo_pago,
            forma_pago: this.noteDetails.forma_pago,
            clave_prod_serv: this.noteDetails.clave_prod_serv,
            concepto_descripcion: this.noteDetails.concepto_descripcion,
            mercancia_descripcion: this.noteDetails.mercancia_descripcion,
            mercancia_unidad: this.noteDetails.mercancia_unidad,
            asegura_resp_civil: this.noteDetails.asegura_resp_civil,
            poliza_resp_civil: this.noteDetails.poliza_resp_civil,
            remolque_tipo: this.noteDetails.remolque_tipo,
            expected_time: this.noteDetails.expected_time,
            sucursal: this.noteDetails.sucursal,
            cost_by_traffic: this.noteDetails.cost_by_traffic,
            note_number: this.noteDetails.note_number,
            currentForm: 'initialData',
            chatUnread: 0,
            client_state: '',
            allStates: [
                { name: 'Aguascalientes' },
                { name: 'Baja California' },
                { name: 'Baja California Sur' },
                { name: 'Campeche' },
                { name: 'Chiapas' },
                { name: 'Chihuahua' },
                { name: 'Ciudad de México' },
                { name: 'Coahuila' },
                { name: 'Colima' },
                { name: 'Durango' },
                { name: 'Estado de México' },
                { name: 'Guanajuato' },
                { name: 'Guerrero' },
                { name: 'Hidalgo' },
                { name: 'Jalisco' },
                { name: 'Michoacán' },
                { name: 'Morelos' },
                { name: 'Nayarit' },
                { name: 'Nuevo León' },
                { name: 'Oaxaca' },
                { name: 'Puebla' },
                { name: 'Querétaro' },
                { name: 'Quintana Roo' },
                { name: 'San Luis Potosí' },
                { name: 'Sinaloa' },
                { name: 'Sonora' },
                { name: 'Tabasco' },
                { name: 'Tamaulipas' },
                { name: 'Tlaxcala' },
                { name: 'Veracruz' },
                { name: 'Yucatán' },
                { name: 'Zacatecas' }
            ],
            filteredClientStates: [],
            filteredSourceStates: [],
            filteredDestinationStates: [],
            client_address: '',
            client_rfc: '',
            phone:'',
            addNewClient: false,
            clients: [], 
            filteredClients: [], 
            clientDetails: {
                "client_address": {
                    
                },
                "client_type": 'Cliente en general'
            }, 
            isClientSelected: false,
            showOptionalFields: false,
            showOptionalFields1: false,
            gruposCampos: [ 
            { unit: '', operator: '', start_km: null, end_km: null, assistance_note: this.noteDetails.id, assigned_by: this.user_id, commission: ''},
            ],
            assignationsData: [],
            saving_note: false,
            validatingCommissions: false,
            commissionsEditMode: false,
            savingCommissionChangesOnly: false,
            saving_invoice: false,
            lot_start_time: this.noteDetails.lot_start_time,
            lot_end_time: this.noteDetails.lot_end_time,
            lot_cost_per_day: this.lot_cost_per_day,
            lot_total_cost: this.lot_total_cost,
            base_to_origin: 0,
            origin_to_destination: 0,
            reportMapCenter: '',
            timeToComplete: '',
            prefered_product_key_traffic: '78101803',
            prefered_measurement_unit_traffic: 'E48',
            prefered_product_key_pension_days: '78181702',
            prefered_measurement_unit_pension_days: 'E48',
            prefered_product_key_cost_km: '78121603',
            prefered_measurement_unit_cost_km: 'E48',
            prefered_product_key_maneuvers: '81141601',
            prefered_measurement_unit_maneuvers: 'E48',
            prefered_product_key_service_hours: '78101803',
            prefered_measurement_unit_service_hours: 'E48',
            invoiceBreakdown: false,
            invoiceBreakdownEdit: false,
            cartaporte:false,
            applies_retention: Number(this.noteDetails.retention) !==0,
            selectedClient: null, 
            highlightedIndex: -1,
            municipalities: [
                "Monterrey", "San Nicolás de los Garza", "San Pedro Garza García",
                "Guadalupe", "Apodaca", "Escobedo", "Santa Catarina", "Juárez", "García",
                "Pesquería", "Santiago", "El Carmen", "Cadereyta"
            ],
            sourceFilteredMunicipalities: [],
            destinationFilteredMunicipalities: [],
            invoiceNumber: 0,
            invoiceSeries: this.noteDetails?.invoice_detail?.invoice_series ?? 'NG',
            invoice_generic_frequency: this.noteDetails?.invoice_detail?.invoice_generic_frequency ?? "",
            invoice_generic_month: this.noteDetails?.invoice_detail?.invoice_generic_month ?? "",
            invoice_generic_year: this.noteDetails?.invoice_detail?.invoice_generic_year ?? "",
            signaturePad: null,
            related_cfdi: '',
            relationship_type: '',
            showPopup: false,
            insurance_incident: this.noteDetails.insurance_incident,
            client_front_name: '',
            initialAssignations:'',
            assignmentLegendNowIso: new Date().toISOString(),
            assignmentLegendIntervalId: null,
            mercancia_peso: '3000.000',
            bienes_transportados: '25101503',
            mercancia_dimensiones: '300/220/180cm',
            // distancia: 0,
            imageSections: [
                { loc: 'front', label: 'Fotografías de la parte de enfrente del vehículo', images: { default: '', uploaded: [], blob_ids: [] } },
                { loc: 'engine', label: 'Fotografías del motor del vehículo', images: { default: '', uploaded: [], blob_ids: [] } },
                { loc: 'left', label: 'Fotografías del lado izquierdo del vehículo', images: { default: '', uploaded: [], blob_ids: [] } },
                { loc: 'right', label: 'Fotografías del lado derecho del vehículo', images: { default: '', uploaded: [], blob_ids: [] } },
                { loc: 'back', label: 'Fotografías de la parte trasera del vehículo', images: { default: '', uploaded: [], blob_ids: [] } },
                { loc: 'complementary', label: 'Fotografías complementarias del vehículo (Llantas, Cajuela, interior del vehículo, etc.)', images: { default: '', uploaded: [], blob_ids: [] } },
            ],
        };
    },
    watch: {
        assignations: {
            immediate: true,
            deep: true,
            handler(newVal) {
                if (Array.isArray(newVal) && newVal.length > 0) {
                    this.gruposCampos = newVal.map(assignation => ({
                        id: assignation.id,
                        unit: assignation.unit.unit_short_id,
                        operator: assignation.operator.employee_ident,
                        assigned_by: assignation.assigned_by.employee_user,
                        start_km: assignation.start_km,
                        end_km: assignation.end_km,
                        assistance_note: assignation.assistance_note.id,
                        operador_name: assignation.operator.employee_first_name,
                        operador_last_name: assignation.operator.employee_last_name,
                        unidad_name: assignation.unit.unit_sub_brand,
                        commission: assignation.commission
                    }));
                    } 
        },
        client_state(newValue) {
            this.filteredClientStates = this.getFilteredStates(newValue);
        },
        source_state(newValue) {
            this.filteredSourceStates = this.getFilteredStates(newValue);
        },
        destination_state(newValue) {
            this.filteredDestinationStates = this.getFilteredStates(newValue);
        },
        'localNoteDetails.note_ident': function(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.fetchAssignationsForNote();
            }
        }
        },
        'localNoteDetails.lot_start_time': 'updateCalculatedCosts',
        'localNoteDetails.lot_end_time': 'updateCalculatedCosts',
        'localNoteDetails.cost_by_km': 'updateCalculatedCosts',
        'localNoteDetails.total_kms': 'updateCalculatedCosts',
        'localNoteDetails.cost_by_traffic': 'updateCalculatedCosts',
        'localNoteDetails.maneuvers': 'updateCalculatedCosts',
        'localNoteDetails.highway_tolls': 'updateCalculatedCosts',
        'localNoteDetails.lot_cost_per_day': 'updateCalculatedCosts',
        'localNoteDetails.discount': 'updateCalculatedCosts',
        'applies_retention': 'updateCalculatedCosts',
    },
    mounted() {
        this.fetchAssignationsForNote();
        this.assignmentLegendIntervalId = window.setInterval(() => {
            if (!this.assignedAtLegendTime && !this.isCancelledNote) {
                this.assignmentLegendNowIso = new Date().toISOString();
            }
        }, 1000);
        // Format lot_start_time on mount
        // this.formatDateTimeShow();
        const canvas = this.$refs.signatureCanvas;
        this.signaturePad = new SignaturePad(canvas);
    window.addEventListener('resize', this.resizeCanvas);
    },
    beforeUnmount() {
    if (this.assignmentLegendIntervalId) {
        window.clearInterval(this.assignmentLegendIntervalId);
        this.assignmentLegendIntervalId = null;
    }
    window.removeEventListener('resize', this.resizeCanvas);
    },
    computed: {
        assignedAtLegendTime() {
            const mergedAssignations = [
                ...(Array.isArray(this.assignationsData) ? this.assignationsData : []),
                ...(Array.isArray(this.assignations) ? this.assignations : []),
            ];
            const firstAssigned = mergedAssignations.find((item) => item && item.assigned_at);
            return firstAssigned ? firstAssigned.assigned_at : null;
        },
        assignedLegendDisplay() {
            if (this.assignedAtLegendTime) {
                return this.formatDateTime(this.assignedAtLegendTime);
            }
            if (this.isCancelledNote) {
                return '(sin asignación)';
            }

            const now = new Date(this.assignmentLegendNowIso);
            const time = now
                .toLocaleTimeString('es-MX', { hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: true })
                .toLowerCase();
            const date = now.toLocaleDateString('es-MX', { year: 'numeric', month: '2-digit', day: '2-digit' });
            return `${time} del ${date}`;
        },
        isAssignmentPending() {
            return !this.assignedAtLegendTime && !this.isCancelledNote;
        },
        isCancelledNote() {
            return Number(this.localNoteDetails?.status) === 2;
        },
        canViewAssignationsTab() {
            return this.hasAnyPerm(['operations.view_assignations_tab'])
        },
        canViewHistorialTab() {
            return this.hasAnyPerm(['operations.view_history_tab'])
        },
        canViewChatTab() {
            return this.hasAnyPerm(['operations.view_chat_tab'])
        },
        canViewSurveyTab() {
            return this.hasAnyPerm(['operations.view_survey_tab'])
        },
        canViewImagesTab() {
            return this.hasAnyPerm(['operations.view_images_tab'])
        },
        canViewInventoryTab() {
            return this.hasAnyPerm(['operations.view_inventory_tab'])
        },
        canViewRouteReportTab() {
            return this.hasAnyPerm(['operations.view_route_report_tab'])
        },
        canUpdateNote() {
            return this.hasAnyPerm(['operations.update_assistance_note'])
        },
        isFacturada() {
            return Number(this.localNoteDetails?.status) === 6
        },
        canEditFacturadaCommissions() {
            return this.hasAnyPerm(['ui_access_edit_facturada_commissions'])
        },
        isCommissionInputDisabled() {
            if (this.isFacturada) {
                return !this.commissionsEditMode || this.savingCommissionChangesOnly
            }
            return this.blockEdit
        },
        canEditNoteButton() {
            return this.hasAnyPerm(['operations.edit_note_button'])
        },
        canCancelNoteButton() {
            return this.hasAnyPerm(['operations.cancel_note_button'])
        },
        canViewInvoicesTab() {
            return this.hasAnyPerm(['accounting.view_invoices_tab'])
        },
        canGenerateDocuments() {
            return this.hasAnyPerm(['accounting.generate_invoice_documents'])
        },

        source_coords_helper: {
    get() {
      const lat = this.normalizeCoords(this.localNoteDetails?.source?.lat);
      const lon = this.normalizeCoords(this.localNoteDetails?.source?.lon);
      return lat && lon ? `${lat}, ${lon}` : "";
    },
    set(val) {
      const parsed = this.parseCoordsStrict(val);
      if (!parsed) return;

      // IMPORTANT: ensure objects exist
      if (!this.localNoteDetails.source) this.localNoteDetails.source = {};
      this.localNoteDetails.source.lat = parsed.lat;
      this.localNoteDetails.source.lon = parsed.lon;
    }
  },

  destination_coords_helper: {
    get() {
      const lat = this.normalizeCoords(this.localNoteDetails?.destination?.lat);
      const lon = this.normalizeCoords(this.localNoteDetails?.destination?.lon);
      return lat && lon ? `${lat}, ${lon}` : "";
    },
    set(val) {
      const parsed = this.parseCoordsStrict(val);
      if (!parsed) return;

      if (!this.localNoteDetails.destination) this.localNoteDetails.destination = {};
      this.localNoteDetails.destination.lat = parsed.lat;
      this.localNoteDetails.destination.lon = parsed.lon;
    }
  },
        isDestLatValid() {
    const lat = parseFloat(this.localNoteDetails.destination.lat);
    return lat >= 14.0 && lat <= 32.0;
  },

  isDestLonValid() {
    const lon = parseFloat(this.localNoteDetails.destination.lon);
    return lon >= -118.0 && lon <= -86.0;
  },
  isSourceLatValid() {
    const lat = parseFloat(this.localNoteDetails.source.lat);
    return lat >= 14.0 && lat <= 32.0;
  },

  isSourceLonValid() {
    const lon = parseFloat(this.localNoteDetails.source.lon);
    return lon >= -118.0 && lon <= -86.0;
  },
        allTimesCompletedBack() {
            if (!Array.isArray(this.initialAssignations) || this.initialAssignations.length === 0) {
                return false;
            }

            const sumCommissions = (this.initialAssignations || []).reduce(
            (total, grupo) => total + (Number(grupo.commission) || 0),
            0
            );
            if (this.initialAssignations.length === 2) {
                const areEqual = Math.abs(Number(this.noteDetails.subtotal) - sumCommissions) < 0.000001;

                if (!areEqual) {
                    return false; // ❌ Stop execution, do not save
                }
            }

            const kmValid = this.initialAssignations.every(assignation => {
                // Only validate times if operador and unidad are not 999
                if ((assignation.start_km ?? null) === null || (assignation.end_km ?? null) === null) {
                    return false;
                }
                if (assignation.start_km >= assignation.end_km) {
                    return false;
                }
                return true;
            });

            if (!kmValid) {
                return false;
            }
            
            if (this.initialAssignations[0]) {
                return (
                    this.initialAssignations[0].start_time &&
                    this.initialAssignations[0].arrival_time &&
                    this.initialAssignations[0].contact_time &&
                    this.initialAssignations[0].end_time
                );
            } else {
                return false;
            }
        },
        allTimesCompletedFront() {
            if (!Array.isArray(this.assignationsData) || this.assignationsData.length === 0) {
                return false;
            }
            
            const sumCommissions = (this.gruposCampos || []).reduce(
            (total, grupo) => total + (Number(grupo.commission) || 0),
            0
            );

            if (this.gruposCampos.length === 2) {
                const areEqual = Math.abs(Number(this.localNoteDetails.subtotal) - sumCommissions) < 0.000001;

    if (!areEqual) {
        return false; // ❌ Stop execution, do not save
    }
            }
            if (this.gruposCampos && this.gruposCampos.length > 0) {
                const gruposValid = this.gruposCampos.every(assignation => {
                    if ((assignation.start_km ?? null) === null || (assignation.end_km ?? null) === null) {
                        return false;
                    }
                    if (assignation.start_km === '' || assignation.end_km === '') {
                        return false;
                    }
                    if (assignation.start_km >= assignation.end_km) {
                        return false;
                    }
                    return true; // ✅ you need this inside every()
                });

                if (!gruposValid) {
                    return false;
                }
            }
            
            if (this.assignationsData[0]) {
                return (
                    this.assignationsData[0].start_time &&
                    this.assignationsData[0].arrival_time &&
                    this.assignationsData[0].contact_time &&
                    this.assignationsData[0].end_time
                );
            }

            return true;

        },

        isFormValid() {
            /** Used to prevent the form submission until all required values are set */
            return (
                //true
                // In case more needed in the future, uncommend, as of writting only brand
                // sub brand, client, and lat lon are required 
                //this.client_id !== null &&
                this.localNoteDetails.vehicle_brand !== null && this.localNoteDetails.vehicle_brand !== "" &&
                this.localNoteDetails.vehicle_sub_brand !== null && this.localNoteDetails.vehicle_sub_brand !== "" &&
                //this.vehicle_model !== "" &&
                //this.vehicle_plates !== "" &&
                //this.vehicle_engine_series !== "" &&
                //this.vehicle_color !== "" &&
                //this.insurance_policy !== "" &&
                //this.vehicle_owner_name !== "" &&
                //this.file_number !== "" &&
                //this.source_street !== "" &&
                //this.source_street_number !== "" &&
                //this.source_between_streets !== "" &&
                //this.source_neighborhood !== "" &&
                //this.source_city !== "" &&
                //this.source_zip_code !== "" &&
                //this.source_state !== "" &&
                // this.source_lat !== "" &&
                this.localNoteDetails.source.lat !== "" && /^-?\d+(\.\d+)?$/.test(this.localNoteDetails.source.lat) &&
                this.localNoteDetails.source.lon !== "" && /^-?\d+(\.\d+)?$/.test(this.localNoteDetails.source.lon) &&
                // this.source_lon !== "" &&
                //this.destination_street !== "" &&
                //this.destination_street_number !== "" &&
                //this.destination_between_streets !== "" &&
                //this.destination_neighborhood !== "" &&
                //this.destination_city !== "" &&
                //this.destination_zip_code !== "" &&
                //this.destination_state !== "" &&
                // this.destination_lat !== "" &&
                // this.destination_lon !== "" //&&
                this.localNoteDetails.destination.lat !== "" && /^-?\d+(\.\d+)?$/.test(this.localNoteDetails.destination.lat) &&
                this.localNoteDetails.destination.lon !== "" && /^-?\d+(\.\d+)?$/.test(this.localNoteDetails.destination.lon)
                //this.source_km !== "" &&
                //this.source_references !== "" &&
                //this.destination_km !== "" &&
                //this.destination_references !== "" &&
                //this.employeeid !== ""
            );
        },
        missingRequiredFields() {
            const missing = [];
            const source = this.localNoteDetails?.source || {};
            const destination = this.localNoteDetails?.destination || {};
            const sourceLat = source.lat === null || source.lat === undefined ? "" : String(source.lat).trim();
            const sourceLon = source.lon === null || source.lon === undefined ? "" : String(source.lon).trim();
            const destinationLat = destination.lat === null || destination.lat === undefined ? "" : String(destination.lat).trim();
            const destinationLon = destination.lon === null || destination.lon === undefined ? "" : String(destination.lon).trim();
            const floatRegex = /^-?\d+(\.\d+)?$/;

            if (!this.localNoteDetails?.vehicle_brand) missing.push('Marca');
            if (!this.localNoteDetails?.vehicle_sub_brand) missing.push('Submarca');
            if (!sourceLat || !floatRegex.test(sourceLat)) missing.push('Latitud origen');
            if (!sourceLon || !floatRegex.test(sourceLon)) missing.push('Longitud origen');
            if (!destinationLat || !floatRegex.test(destinationLat)) missing.push('Latitud destino');
            if (!destinationLon || !floatRegex.test(destinationLon)) missing.push('Longitud destino');

            return missing;
        },
        missingRequiredFieldsMessage() {
            if (!this.missingRequiredFields.length) return '';
            return `Faltan campos obligatorios: ${this.missingRequiredFields.join(', ')}`;
        },
        missingRequiredFieldMap() {
            const source = this.localNoteDetails?.source || {};
            const destination = this.localNoteDetails?.destination || {};
            const sourceLat = source.lat === null || source.lat === undefined ? "" : String(source.lat).trim();
            const sourceLon = source.lon === null || source.lon === undefined ? "" : String(source.lon).trim();
            const destinationLat = destination.lat === null || destination.lat === undefined ? "" : String(destination.lat).trim();
            const destinationLon = destination.lon === null || destination.lon === undefined ? "" : String(destination.lon).trim();
            const floatRegex = /^-?\d+(\.\d+)?$/;

            return {
                vehicle_brand: !this.localNoteDetails?.vehicle_brand,
                vehicle_sub_brand: !this.localNoteDetails?.vehicle_sub_brand,
                source_lat: !sourceLat || !floatRegex.test(sourceLat),
                source_lon: !sourceLon || !floatRegex.test(sourceLon),
                destination_lat: !destinationLat || !floatRegex.test(destinationLat),
                destination_lon: !destinationLon || !floatRegex.test(destinationLon),
            };
        },
        selectedBrandId() {
            // Find the ID (pk) for the selected brand name
            const brandEntry = Object.entries(this.brands).find(
            ([, brand]) => brand === this.localNoteDetails.vehicle_brand
            );
            return brandEntry ? brandEntry[0] : null;  // Return the ID or null if not found
        },
        selectedSubBrandId() {
            // Find the ID that matches the selected sub-brand name
            const subBrandEntry = Object.entries(this.sub_brands).find(
            ([, sub_brand]) => sub_brand === this.localNoteDetails.vehicle_sub_brand
            );
            return subBrandEntry ? subBrandEntry[0] : null;  // Returns the ID or null if not found
        },
    },
    methods: {
        loadPermissions() {
            try {
                this.permissions = JSON.parse(localStorage.getItem('userPermissions')) || []
            } catch (error) {
                this.permissions = []
            }
        },
        hasPerm(perm) {
            if (!perm) return false
            if (this.permissions.includes(perm)) return true
            return this.permissions.includes(`access_control.${perm}`)
        },
        hasAnyPerm(perms) {
            if (!Array.isArray(perms) || perms.length === 0) return false
            return perms.some((perm) => this.hasPerm(perm))
        },
        normalizeCoords(v) {
    return v === null || v === undefined ? "" : String(v).trim();
  },
  parseCoordsStrict(val) {
    const s = this.normalizeCoords(val);
    const m = s.match(/^(-?\d+(?:\.\d+)?),\s*(-?\d+(?:\.\d+)?)$/);
    if (!m) return null;

    const latNum = Number(m[1]);
    const lonNum = Number(m[2]);
    if (!Number.isFinite(latNum) || !Number.isFinite(lonNum)) return null;
    if (latNum < -90 || latNum > 90) return null;
    if (lonNum < -180 || lonNum > 180) return null;

    return { lat: m[1], lon: m[2] };
  },
        loadSignature(signatureDataUrl) {
        const image = new Image();
        image.src = signatureDataUrl;

        image.onload = () => {
            const canvas = this.$refs.signatureCanvas;
            const context = canvas.getContext('2d');

            // Clear the canvas and draw the saved signature
            context.clearRect(0, 0, canvas.width, canvas.height);
            context.drawImage(image, 0, 0, canvas.width, canvas.height);
        };
    },
        resizeCanvas() {
        const canvas = this.$refs.signaturePad.$el.querySelector('canvas');
        const ratio = Math.max(window.devicePixelRatio || 1, 1);

        // Set the canvas size to its rendered dimensions
        const width = canvas.offsetWidth;
        const height = canvas.offsetHeight;

        // Scale the canvas for high-DPI screens
        canvas.width = width * ratio;
        canvas.height = height * ratio;
        canvas.getContext('2d').scale(ratio, ratio);

        // Clear and reset the signature pad
        this.$refs.signaturePad.clear();
    },
        clearSignature() {
            this.signaturePad.clear();
        },
        saveSignature() {
    // Get the signature in Base64 format
    const signatureDataUrl = this.signaturePad.toDataURL('image/png'); // You can choose different image formats (e.g., PNG, JPEG)

    // Check if the signature pad has been drawn on
    if (this.signaturePad.isEmpty()) {
        Swal.fire({
            title: '¡Error!',
            text: 'La firma está vacía. Por favor, firme antes de guardar.',
            icon: 'error',
            confirmButtonText: 'Ok'
        });
        return;
    }

    // Prepare the payload for sending to the server
    const payload = {
        client_signature: signatureDataUrl, // Base64 signature image
        assignation_id: this.assignation.id // Include the assignation ID
    };

    // Send the signature to your server
    const apiDirectory = process.env.API_DIRECTORY;
    axios.post(`${apiDirectory}/save-signature/`, payload)
        .then(() => {
            // Handle the response (e.g., show a success message)
            Swal.fire({
                title: '¡Completado!',
                text: 'La firma se guardó correctamente.',
                icon: 'success',
                confirmButtonText: 'Ok'
            });
        })
        .catch((error) => {
            // Handle any errors that occurred during the request
            console.error('Error saving signature:', error);
            Swal.fire({
                title: '¡Error!',
                text: 'Ocurrió un error al guardar la firma. Intente nuevamente.',
                icon: 'error',
                confirmButtonText: 'Ok'
            });
        });
},
        async updateClientInvoiceInfo(clientId) {
            const apiDirectory = process.env.API_DIRECTORY;
            const response = await axios.get(`${apiDirectory}/clients/${clientId}/`);
            this.applies_retention = response.data.applies_retention;
            this.localNoteDetails.payment_method = response.data.client_payment_method;
            this.localNoteDetails.internal_payment_type = response.data.client_internal_payment_type;
            this.localNoteDetails.payment_type = response.data.client_payment_type;
            this.localNoteDetails.invoice_use = response.data.client_invoice_use 
        },
        updateLotStartTime(value) {
            this.localNoteDetails.lot_start_time = value || '';
        },
        updateLotEndTime(value) {
            this.localNoteDetails.lot_end_time = value || '';
        },
        updateStartTime(value, index) {
            this.assignationsData[index].start_time = value || '';
        },
        updateArrivalTime(value, index) {
            this.assignationsData[index].arrival_time = value || '';
        },
        updateContactTime(value, index) {
            this.assignationsData[index].contact_time = value || '';
        },
        updateEndTime(value, index) {
            this.assignationsData[index].end_time = value || '';
        },
        async saveCommissionsValidation() {
            const noteID = this.noteDetails.note_ident;
            const apiDirectory = process.env.API_DIRECTORY;
            this.validatingCommissions = true;

            try {
                await axios.patch(`${apiDirectory}/notes/${noteID}/`, {
                    commissions_validated: Boolean(this.localNoteDetails.commissions_validated),
                });
                Swal.fire({
                    toast: true,
                    position: "top-end",
                    icon: "success",
                    title: "Validación de comisiones actualizada",
                    showConfirmButton: false,
                    timer: 1800,
                    timerProgressBar: true,
                });
                this.$emit('refresh-note');
            } catch (error) {
                console.error("Failed to update commissions validation:", error);
                Swal.fire("Error", "No se pudo actualizar la validación de comisiones.", "error");
            } finally {
                this.validatingCommissions = false;
            }
        },
        async toggleCommissionsEdition() {
            if (!this.commissionsEditMode) {
                this.commissionsEditMode = true;
                return;
            }
            await this.saveFacturadaCommissionsOnly();
        },
        async saveFacturadaCommissionsOnly() {
            const apiDirectory = process.env.API_DIRECTORY;
            const assignationsToUpdate = (this.gruposCampos || []).filter((assignation) => Boolean(assignation?.id));

            if (!assignationsToUpdate.length) {
                Swal.fire("Atención", "No hay comisiones para actualizar.", "warning");
                return;
            }

            const hasInvalidCommission = assignationsToUpdate.some((assignation) => {
                if (assignation.commission === '' || assignation.commission === null || assignation.commission === undefined) {
                    return false;
                }
                return Number.isNaN(Number(assignation.commission));
            });

            if (hasInvalidCommission) {
                Swal.fire("Error", "Hay comisiones con un formato inválido.", "error");
                return;
            }

            this.savingCommissionChangesOnly = true;
            try {
                await Promise.all(assignationsToUpdate.map((assignation) => {
                    const commissionValue =
                        assignation.commission === '' || assignation.commission === null || assignation.commission === undefined
                            ? null
                            : Number(assignation.commission);
                    return axios.patch(
                        `${apiDirectory}/assignation-detail/${assignation.id}/`,
                        { commission: commissionValue }
                    );
                }));

                this.commissionsEditMode = false;
                Swal.fire({
                    toast: true,
                    position: "top-end",
                    icon: "success",
                    title: "Comisiones actualizadas",
                    showConfirmButton: false,
                    timer: 1800,
                    timerProgressBar: true,
                });
                this.$emit('refresh-note');
            } catch (error) {
                console.error("Failed to update commissions:", error);
                Swal.fire("Error", "No se pudieron actualizar las comisiones.", "error");
            } finally {
                this.savingCommissionChangesOnly = false;
            }
        },
        sourceFilterMunicipalities() {
            const searchTerm = this.localNoteDetails.source?.city?.toLowerCase() || '';
            this.sourceFilteredMunicipalities = this.municipalities.filter(municipality =>
                municipality.toLowerCase().includes(searchTerm)
            );
        },
        sourceSelectMunicipality(municipality) {
            this.localNoteDetails.source.city = municipality;
            this.sourceFilteredMunicipalities = [];
            console.log(this.localNoteDetails.source.city);
        },
        destinationFilterMunicipalities() {
            const searchTerm = this.localNoteDetails.destination?.city?.toLowerCase() || '';
            this.destinationFilteredMunicipalities = this.municipalities.filter(municipality =>
                municipality.toLowerCase().includes(searchTerm)
            );
        },
        destinationSelectMunicipality(municipality) {
            this.localNoteDetails.destination.city = municipality;
            this.destinationFilteredMunicipalities = [];
        },
        navigateClients(direction) {
            if (!this.filteredClients.length) return;

            const count = this.filteredClients.length;
            this.highlightedIndex = (this.highlightedIndex + direction + count) % count;

            // Scroll the highlighted item into view
            this.$nextTick(() => {
                const dropdown = this.$refs.dropdownContainer;
                const highlightedItem = this.$refs.dropdownItem[this.highlightedIndex];
                if (dropdown && highlightedItem) {
                    const itemOffsetTop = highlightedItem.offsetTop;
                    const itemHeight = highlightedItem.offsetHeight;
                    const dropdownScrollTop = dropdown.scrollTop;
                    const dropdownHeight = dropdown.offsetHeight;

                    if (itemOffsetTop < dropdownScrollTop) {
                        dropdown.scrollTop = itemOffsetTop;
                    } else if (itemOffsetTop + itemHeight > dropdownScrollTop + dropdownHeight) {
                        dropdown.scrollTop = itemOffsetTop - dropdownHeight + itemHeight;
                    }
                }
            });
        },
        selectHighlightedClient() {
            if (this.highlightedIndex !== -1) {
                this.selectClient(this.filteredClients[this.highlightedIndex]);
            }
        },
        updateCalculatedCosts() {
            const dateDifferenceDays = 
                (this.localNoteDetails?.lot_start_time && this.localNoteDetails?.lot_end_time)
                    ? Math.ceil(
                        Math.ceil(
                        Math.abs(new Date(this.localNoteDetails.lot_end_time) - new Date(this.localNoteDetails.lot_start_time)) 
                        / (1000 * 60 * 60)
                        ) / 24
                    )
                    : 0;
            console.log(dateDifferenceDays, );
            this.localNoteDetails.lot_total_cost = (
                (Number(this.localNoteDetails.lot_cost_per_day) || 0) * dateDifferenceDays
            ).toFixed(2);
            this.localNoteDetails.subtotal = (
                (Number(this.localNoteDetails.cost_by_km) * Number(this.localNoteDetails.total_kms) || 0) +
                (Number(this.localNoteDetails.cost_by_traffic) || 0) +
                (Number(this.localNoteDetails.maneuvers) || 0) +
                (Number(this.localNoteDetails.highway_tolls) || 0) +
                (Number(this.localNoteDetails.lot_total_cost) || 0) -
                (Number(this.localNoteDetails.discount) || 0)
            ).toFixed(2); // Ensures the result is a string formatted to two decimal places
            this.localNoteDetails.iva = (
                (this.localNoteDetails.subtotal) * .16
            ).toFixed(2);
            this.localNoteDetails.retention = (
                (this.localNoteDetails.subtotal) * (this.applies_retention ? .04 : 0)
            ).toFixed(2);
            this.localNoteDetails.total = (
                Number(this.localNoteDetails.subtotal) + Number(this.localNoteDetails.iva) - Number(this.localNoteDetails.retention)
            ).toFixed(2);
        },
        async fetchClientById(clientId) {
            try {
                const apiDirectory = process.env.API_DIRECTORY; // Adjust to your actual API endpoint
                const response = await axios.get(`${apiDirectory}/clients/${clientId}/`);
                this.client_id = clientId; // Keep the client ID in sync
                this.client_name = response.data.client_name; // Update the display name
                this.client_rfc = response.data.client_rfc;
                this.client_front_name = `${response.data.client_ident} - ${response.data.client_name}`;
                if (response.data.prefered_product_key_pension_days) {
                    this.prefered_product_key_pension_days = response.data.prefered_product_key_pension_days;
                }
                if (response.data.prefered_measurement_unit_pension_days) {
                    this.prefered_measurement_unit_pension_days = response.data.prefered_measurement_unit_pension_days;
                }
                if (response.data.prefered_product_key_traffic) {
                    this.prefered_product_key_traffic = response.data.prefered_product_key_traffic;
                }
                if (response.data.prefered_measurement_unit_traffic) {
                    this.prefered_measurement_unit_traffic = response.data.prefered_measurement_unit_traffic;
                }
                this.prefered_legend_traffic = response.data.prefered_legend_traffic || '';
                this.prefered_legend_maneuvers = response.data.prefered_legend_maneuvers || '';
                this.prefered_legend_cost_km = response.data.prefered_legend_cost_km || '';
                this.prefered_legend_pension_days = response.data.prefered_legend_pension_days || '';
                this.prefered_legend_service_hours = response.data.prefered_legend_service_hours || '';
                if (response.data.prefered_product_key_cost_km) {
                    this.prefered_product_key_cost_km = response.data.prefered_product_key_cost_km;
                }
                if (response.data.prefered_measurement_unit_cost_km) {
                    this.prefered_measurement_unit_cost_km = response.data.prefered_measurement_unit_cost_km;
                }
                if (response.data.prefered_product_key_maneuvers) {
                    this.prefered_product_key_maneuvers = response.data.prefered_product_key_maneuvers;
                }
                if (response.data.prefered_measurement_unit_maneuvers) {
                    this.prefered_measurement_unit_maneuvers = response.data.prefered_measurement_unit_maneuvers;
                }
                if (response.data.prefered_product_key_service_hours) {
                    this.prefered_product_key_service_hours = response.data.prefered_product_key_service_hours;
                }
                if (response.data.prefered_measurement_unit_service_hours) {
                    this.prefered_measurement_unit_service_hours = response.data.prefered_measurement_unit_service_hours;
                }
                
                // No need to update localNoteDetails.client here, as it should already have the correct ID
                //console.log(this.client_name)
            } catch (error) {
                console.error('Error fetching client details:', error);
            }
        },
        async fetchClients() {
            try {
                const apiDirectory = process.env.API_DIRECTORY;
                const response = await axios.get(`${apiDirectory}/get-privileged-clients`);
                this.clients = response.data;
            } catch (error) {
                // error
            }
        },
        formatDateTime(isoString) {
            if (!isoString) {
                // If the string is empty or null, returns the message
                return "No hay datos de tiempo";
            }

            // Check if the timezone offset contains seconds and remove them if present
            const timezoneIndex = isoString.lastIndexOf('-') !== -1 ? isoString.lastIndexOf('-') : isoString.lastIndexOf('+');
            let timezone = isoString.substring(timezoneIndex);
            const timezoneParts = timezone.split(':');
            if (timezoneParts.length > 2) {
                // Remove seconds from the timezone offset
                timezone = `${timezoneParts[0]}:${timezoneParts[1]}`;
            }
            const isoStringWithoutSeconds = isoString.substring(0, timezoneIndex) + timezone;

            // Attempt to create a Date object with the corrected ISO string
            const date = new Date(isoStringWithoutSeconds);

            // Check if the date is 'Invalid Date'
            if (isNaN(date.getTime())) {
                return "No hay datos de tiempo";
            }

            const optionsDate = { year: 'numeric', month: '2-digit', day: '2-digit' };
            const optionsTime = { hour: '2-digit', minute: '2-digit', hour12: true };

            const formattedDate = date.toLocaleDateString('es-MX', optionsDate);
            const formattedTime = date.toLocaleTimeString('es-MX', optionsTime).toLowerCase();

            // Combine the parts by eliminating AM/PM repetition
            const matchAmPm = formattedTime.match(/am|pm/);
            const amPm = matchAmPm ? ` ${matchAmPm[0]}` : '';
            return `${formattedTime.replace(/am|pm/, '').trim()} del ${formattedDate}${amPm}`;
        },
        filterClients() {
            const searchTerm = this.client_front_name.toLowerCase().trim();

            if (searchTerm === '') {
                this.filteredClients = [];
                this.highlightedIndex = -1;
                return;
            }

            this.filteredClients = this.clients.filter(client => {
                return (
                    client.client_name.toLowerCase().includes(searchTerm) ||
                    client.client_ident.toLowerCase().includes(searchTerm)
                );
            });

            this.highlightedIndex = -1;
        },  
        selectClient(client) {
            this.clientDetails = { ...client };
            this.client_name = client.client_name;
            this.client_id = client.id;
            this.localNoteDetails.client = this.client_id;
            this.filteredClients = [];
            this.isClientSelected = true;
            // this.applies_retention = false;
            this.highlightedIndex = -1;
            this.applies_retention = client.applies_retention;
            this.client_front_name = `${client.client_ident} - ${client.client_name}`;
            // if (client.applies_retention) {
            //         this.applies_retention = client.applies_retention;
            // }
        },
        editNoReopen() {
            this.blockEdit = false
        },  
        toggleNewClientForm(){
            this.addNewClient = true;
            if (this.addNewClient) {
                this.isClientSelected = false;
            }
        },
        cancelNewClient() {
            this.addNewClient = false; 
        },
        closeDropdown() {
            this.filteredClients = [];
            this.sourceFilteredMunicipalities = [];
            this.destinationFilteredMunicipalities = [];
            this.highlightedIndex = -1;
        },
        filterStates() {
            if (!this.searchState) {
                this.filteredStates = this.states;
            } else {
                this.filteredStates = this.states.filter((state) =>
                    state.toLowerCase().includes(this.searchState.toLowerCase())
            );
            }
            this.isStateDropdownActive = true;
        },
        getFilteredStates(searchValue) {
            if (searchValue.length < 0) {
                return [];
            }
            return this.allStates.filter(state =>
                state.name.toLowerCase().includes(searchValue.toLowerCase())
            );
        },
        selectClientState(name) {
            this.client_state = name;
            this.filteredClientStates = [];
        },
        selectSourceState(name){
            this.source_state = name;
            this.filteredSourceStates = [];
        },
        selectDestinationState(name){
            this.destination_state = name;
            this.filteredDestinationStates = [];
        },

        agregarCampos() {
            this.gruposCampos.push({ unit: '', operator: '', start_km: 0, end_km: 0, assistance_note: this.noteDetails.id, assigned_by: this.user_id, commission: ''});
        },
        async guardarDatos() {
            const apiDirectory = process.env.API_DIRECTORY;
            //Call the unit assignations endpoint to check if any of the units that is about to be assigned is in hard busy state
            let units = [];
            let response;
            const busyUnits = {};
            for (let obj of this.gruposCampos) {
                let unitValue = obj['unit'];
                units.push({ 'unit': unitValue });
            }
            console.log(units)
            try {
                response = await axios.post(`${apiDirectory}/get-unit-assignations`, units);
                // This iteration ensures even if the response contains duplicates, they are removed 
                response.data.forEach(item => {
                    if (item.status === "Ocupada") {
                        busyUnits[item.unit_short_id] = item.status;
                    }
                });
            }
            catch (error) {
                console.error(error);
                if (error.response && error.response.status === 404) {
                    Swal.fire({
                        title: '¡Error!',
                        text: 'Hubo un error al obtener los estatus de las unidades. Al menos una de las unidades que proporcionó no existen.',
                        icon: 'error',
                        showCancelButton: false, // Hide cancel button
                        confirmButtonText: 'Ok'
                    }).then((result) => {
                        if (result.isConfirmed) {
                            // return from func
                            return
                        }
                    });
                    // even if user ignores popup, return from func
                    return
                } else if (error.response && error.response.status === 400) {
                    console.error("Bad request", error)
                    Swal.fire({
                        title: '¡Error!',
                        text: 'Hubo un error al obtener los estatus de las unidades. Por favor intentelo de nuevo. Si el error persiste, contacte a su administrador.',
                        icon: 'error',
                        showCancelButton: false, // Hide cancel button
                        confirmButtonText: 'Ok'
                    }).then((result) => {
                        if (result.isConfirmed) {
                            // return from func
                            return
                        }
                    });
                    // even if user ignores popup, return from func
                    return
                } else if (error.response && error.response.status === 500) {
                    console.error("Internal server error", error)
                    Swal.fire({
                        title: '¡Error interno del servidor!',
                        text: 'Hubo un error al obtener los estatus de las unidades. Por favor intentelo de nuevo. Si el error persiste, contacte a su administrador.',
                        icon: 'error',
                        showCancelButton: false, // Hide cancel button
                        confirmButtonText: 'Ok'
                    }).then((result) => {
                        if (result.isConfirmed) {
                            // return from func
                            return
                        }
                    });
                } else {
                    console.error("Uncaught error", error)
                    Swal.fire({
                        title: '¡Error!',
                        text: 'Hubo un error al obtener los estatus de las unidades. Verifique que la información que introdujo sea válida',
                        icon: 'error',
                        showCancelButton: false, // Hide cancel button
                        confirmButtonText: 'Ok'
                    }).then((result) => {
                        if (result.isConfirmed) {
                            // return from func
                            return
                        }
                    });
                    // even if user ignores popup, return from func
                    return
                }
            }
            // After the unit status have been succesfully fetched, warn the user if there is a hard busy unit, if its not the case, or they 
            // ack the warning, continue, else stop
            if (Object.keys(busyUnits).length > 0) {
                // Construct message for SweetAlert
                let message = "Al menos una de las unidades que está asignando ya se encuentra ocupada.\n\n";
                message += "Unidades Ocupadas:\n";
                for (const unitId in busyUnits) {
                    message += `${unitId}\n`;
                }
                const result = await Swal.fire({
                    title: "¡Advertencia!",
                    text: message,
                    icon: "warning",
                    showCancelButton: true,
                    buttons: {
                        cancel: "Cancelar",
                        confirm: "Continuar"
                    }
                });
                if (!result.isConfirmed) return
            }
            try {
                // Update note status to 5
                const noteID = this.localNoteDetails.note_ident;
                this.localNoteDetails.status = 5;
                this.sanitizeForm();
                await axios.put(`${apiDirectory}/notes/${noteID}/`, this.localNoteDetails);
            }
            // Update the note status
            catch (error) {
                console.error(error)
                Swal.fire({
                    title: '¡Error!',
                    text: 'Hubo un error al actualizar el estatus de la nota, Por favor intente de nuevo.',
                    icon: 'error',
                    showCancelButton: false, // Hide cancel button
                    confirmButtonText: 'Ok'
                }).then((result) => {
                    if (result.isConfirmed) {
                        return
                    }
                });
                // Even if the user ignores the popup, exit out of the func
                return
            }
            // Update the note assignations    
            try {
                if (Object.keys(this.assignations).length === 0) {
                    // If assignations is empty, use POST method
                    response = await axios.post(`${apiDirectory}/set-note-assignations`, this.gruposCampos);
                } else {
                    // If assignations is not empty, use PUT method
                    response = await axios.put(`${apiDirectory}/set-note-assignations`, this.gruposCampos);
                }
                Swal.fire({
                    title: '¡Actualizado!',
                    text: 'Las asignaciones se han actualizado con éxito',
                    icon: 'success',
                    showCancelButton: false, // Hide cancel button
                    confirmButtonText: 'Ok'
                }).then((result) => {
                    if (result.isConfirmed) {
                        location.reload(); // Reload the page after 'Ok' is clicked
                    }
                });
            } catch (error) {
                // Check if the error is due to DNE 
                if (error.response && error.response.status === 404) {
                    console.error("Not found", error)
                    Swal.fire(
                        '¡Error!',
                        'Verifique el id de las unidades y operadores que intenta asignar. Si esta unidad existía en el pasado, asegurese de que no ha sido eliminada.',
                        'error'
                    );
                } else if (error.response && error.response.status === 400) {
                    console.error("Bad request", error)
                    Swal.fire(
                        '¡Error!',
                        (error.response.data && error.response.data.error) || 'Verifique que los valores que intenta asignar son correctos.',
                        'error'
                    );
                } else {
                    console.error("Failed to update assignation:", error);
                    Swal.fire(
                        '¡Error!',
                        'Hay errores en las asignaciones',
                        'error'
                    );
                }
            }
        },

        loadMap(originCoords, destinationCoords, baseCoordinates, route) {
      const script = document.createElement('script');
      const apiKey = 'AIzaSyDttJadFf5cWEcGQMFmRZCrjzUFony74xI'; // Use your actual API key
      script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places`;
      script.async = true;
      script.defer = true;
      script.onload = () => {
        this.initializeMap(originCoords, destinationCoords, baseCoordinates, route);
      };
      document.head.appendChild(script);
    },

    // Adjust initializeMap to use provided coordinates
    initializeMap(originCoords, destinationCoords, baseCoordinates, route) {
  const map = new google.maps.Map(document.getElementById('map'), {
    zoom: 10,
    center: originCoords, // Center the map on the origin by default
  });

  // Function to create a marker
  const createMarker = (position, color, title) => {
    return new google.maps.Marker({
      position: position,
      map: map,
      icon: {
        path: google.maps.SymbolPath.CIRCLE,
        fillColor: color,
        fillOpacity: 1,
        strokeColor: 'black',
        strokeWeight: 1,
        scale: 8, // Adjust the size of the marker
      },
      title: title,
    });
  };

  // Plot origin and destination as blue markers
  createMarker(originCoords, 'blue', 'Origin');
  createMarker(destinationCoords, 'blue', 'Destination');

  // Extract coordinates from the route array
  const routeCoordinates = route
  .map(point => {
    const lat = parseFloat(point.lat);
    const lng = parseFloat(point.long);

    // Return only valid coordinates
    if (!isNaN(lat) && !isNaN(lng)) {
      return { lat, lng };
    }
    console.warn('Invalid coordinate:', point);
    return null; // Skip invalid points
  })
  .filter(coord => coord !== null);

  // Plot route points as red markers
  routeCoordinates.forEach((point, index) => {
    createMarker(point, 'red', `Point ${index + 1}`);
  });

  if (routeCoordinates.length >= 2) {
    const routePolyline = new google.maps.Polyline({
      path: routeCoordinates,
      geodesic: true,
      strokeColor: 'red',
      strokeOpacity: 1.0,
      strokeWeight: 4,
    });
    routePolyline.setMap(map);
  }

  // Adjust the map bounds to fit all points
  const bounds = new google.maps.LatLngBounds();
  bounds.extend(originCoords);
  bounds.extend(destinationCoords);
  routeCoordinates.forEach(point => bounds.extend(point));
  map.fitBounds(bounds);
},

    async showMap() {
  // Fetch coordinates for both addresses
  const originCoords = { lat: Number(this.noteDetails.source.lat), lng: Number(this.noteDetails.source.lon) };
  const destinationCoords = { lat: Number(this.noteDetails.destination.lat), lng: Number(this.noteDetails.destination.lon) };
  console.log(originCoords)
  const baseCoordinates = { lat: 25.7247672, lng: -100.3613687 };
  const gpsID = this.assignationsData[0].unit.gps_id
  const unparsedStart = this.assignationsData[0].start_time
  const unparsedEnd = this.assignationsData[0].end_time
  const startTime = new Date(new Date(unparsedStart).getTime()).toISOString().replace("T", " ").substring(0, 19);
  const endTime = new Date(new Date(unparsedEnd).getTime()).toISOString().replace("T", " ").substring(0, 19);
  const route = await this.fetchUnitRoute(startTime, endTime, gpsID);
  const routeCoordinates = route
  .map(point => {
    const lat = parseFloat(point.lat);
    const lng = parseFloat(point.long);
    const tachometer = parseFloat(point.tachometer)

// Return only valid coordinates
if (!isNaN(lat) && !isNaN(lng) && !isNaN(tachometer)) {
  return { lat,lng,send_time: point.send_time, tachometer: parseFloat(point.tachometer) };
}
    console.warn('Invalid coordinate:', point);
    return null; // Skip invalid points
  })
  .filter(coord => coord !== null);

  //const startDate = this. assignationData[0].

  if (originCoords && destinationCoords) {
    // Now fetch distance and time between the two points
    const startCoordinates =  await { lat: Number(routeCoordinates[0].lat), lng: Number(routeCoordinates[0].lng) };
    const distanceAndTime = await this.fetchDistanceAndTime(originCoords, destinationCoords);
    const distanceToBase = await this.fetchDistanceAndTime(startCoordinates, originCoords);
    if (distanceAndTime && distanceAndTime.distance) {
      // Convert distance from meters to kilometers for pricing calculation and display
      this.origin_to_destination = distanceAndTime.distance / 1000;
      this.base_to_origin = distanceToBase.distance / 1000;

      // Update mapCenter and display the map
      this.reportMapCenter = originCoords;
      console.log(this.reportMapCenter)
      this.loadMap(originCoords, destinationCoords, baseCoordinates, route);
    } else {
      alert('Unable to fetch distance and time for the provided addresses.');
    }
  } else {
    alert('Unable to fetch coordinates for the provided addresses.');
  }
},


async fetchDistanceAndTime(originCoords, destinationCoords) {
  try {
    const apiDirectory = process.env.API_DIRECTORY;
    const response = await axios.post(`${apiDirectory}/get-distance-and-time`, {
      org_lat: originCoords.lat,
      org_lng: originCoords.lng,
      dest_lat: destinationCoords.lat,
      dest_lng: destinationCoords.lng
    });
    return response.data;
  } catch (error) {
    console.error('Failed to fetch distance and time:', error);
    return null;
  }
},

async fetchUnitRoute(start, end, unitGpsId) {
    try {
    const apiDirectory = process.env.API_DIRECTORY;
    const response = await axios.post(`${apiDirectory}/get-unit-route`, {
      start: start,
      end: end,
      unit: unitGpsId
    });
    return response.data;
  } catch (error) {
    console.error('Failed to fetch route:', error);
    return null;
  }
},

        seleccionarOpcion(unit){
            var n = this.assignations.length;
            if(n>0){
                this.agregarCampos()
                n = n+1;
            }
            else{
                n = 1;
            }
            this.gruposCampos[n-1].unit = unit
            this.buttonClicked['btn1'] = true;
            this.buttonClicked['btn2'] = true;
            this.buttonClicked['btn3'] = true;
            this.buttonClicked['btn4'] = true;
            this.buttonClicked['btn5'] = true;
        },
        async eliminarCampos(index = this.gruposCampos.length - 1) {
            const apiDirectory = process.env.API_DIRECTORY;
                const assignationToDelete = this.gruposCampos[index];

                try {
                // Make the API call for the specific assignation
                await axios.post(`${apiDirectory}/delete-note-assignations`, assignationToDelete);

                // Remove the row from the gruposCampos array
                this.gruposCampos.splice(index, 1);

                Swal.fire({
                    title: '¡Actualizado!',
                    text: 'Las asignaciones se han actualizado con éxito',
                    icon: 'success',
                    confirmButtonText: 'Ok',
                }).then((result) => {
                    if (result.isConfirmed) {
                    location.reload(); // Reload the page after 'Ok' is clicked
                    }
                });
                } catch (error) {
                console.error(error);
                Swal.fire({
                    title: 'Error',
                    text: 'Hubo un problema al eliminar la asignación. Por favor, inténtalo de nuevo.',
                    icon: 'error',
                    confirmButtonText: 'Ok',
                });
                }
        },

        backMainPanel() {
            window.location.href = '/main-panel';
        },
        initChatUnreadBadge() {
            if (!this.canViewChatTab) return;
            this.fetchChatUnread();
            this.onChatWsMessage((msg) => {
                if (msg && msg.topic === 'note_chat_message' && msg.note_ident === this.localNoteDetails.note_ident) {
                    this.fetchChatUnread();
                }
            });
        },
        async fetchChatUnread() {
            // The open chat already marks itself read; only the badge needs this.
            if (this.currentForm === 'chat') return;
            try {
                const apiDirectory = process.env.API_DIRECTORY;
                const response = await axios.get(
                    `${apiDirectory}/notes/${this.localNoteDetails.note_ident}/chat/?count_only=1`,
                    { headers: { Authorization: 'Token ' + localStorage.getItem('authToken') } }
                );
                this.chatUnread = response.data.unread_count;
            } catch (error) {
                // Badge is best-effort; ignore polling failures.
            }
        },
        showForm(formName) {
            if (formName === 'chat' && !this.canViewChatTab) {
                Swal.fire({
                    title: 'Sin permisos',
                    text: 'No tienes permisos para ver el chat.',
                    icon: 'warning',
                    confirmButtonText: 'Ok',
                });
                return;
            }
            if (formName === 'encuesta' && !this.canViewSurveyTab) {
                Swal.fire({
                    title: 'Sin permisos',
                    text: 'No tienes permisos para ver la encuesta.',
                    icon: 'warning',
                    confirmButtonText: 'Ok',
                });
                return;
            }
            if (formName === 'historial' && !this.canViewHistorialTab) {
                Swal.fire({
                    title: 'Sin permisos',
                    text: 'No tienes permisos para ver el historial.',
                    icon: 'warning',
                    confirmButtonText: 'Ok',
                });
                return;
            }
            if (formName === 'assignment' && !this.canViewAssignationsTab) {
                Swal.fire({
                    title: 'Sin permisos',
                    text: 'No tienes permisos para ver asignaciones.',
                    icon: 'warning',
                    confirmButtonText: 'Ok',
                });
                return;
            }
            if (formName === 'images' && !this.canViewImagesTab) {
                Swal.fire({
                    title: 'Sin permisos',
                    text: 'No tienes permisos para ver imágenes.',
                    icon: 'warning',
                    confirmButtonText: 'Ok',
                });
                return;
            }
            if (formName === 'report' && !this.canViewRouteReportTab) {
                Swal.fire({
                    title: 'Sin permisos',
                    text: 'No tienes permisos para ver el reporte de ruta.',
                    icon: 'warning',
                    confirmButtonText: 'Ok',
                });
                return;
            }
            // To save unnecesary calls to azure, as tradeoff images are loaded on demand 
            if (formName=='images'&this.buttonClicked.images_tab==false){
                this.fetchImages();
            }
            this.currentForm = formName;
        },
        newSaveNote: async function () {
            const apiDirectory = process.env.API_DIRECTORY;

            try {
                // -------------------------------
                // 1) VALIDATE UNITS (skip if none)
                // -------------------------------
                // Only keep rows that actually have a unit (non-empty string)
                const validAssignations = (this.gruposCampos || []).filter(
                g => g && typeof g.unit === "string" && g.unit.trim() !== ""
                );

                let response;
                const busyUnits = {};

                if (validAssignations.length > 0) {
                // Payload expected by backend
                const unitsPayload = validAssignations.map(obj => ({ unit: obj.unit.trim() }));

                try {
                    response = await axios.post(`${apiDirectory}/get-unit-assignations`, unitsPayload);
                    response.data.forEach(item => {
                    if (item.status === "Ocupada") busyUnits[item.unit_short_id] = item.status;
                    });
                } catch (error) {
                    console.error(error);
                    Swal.fire("Error", "No se pudieron validar las unidades. Verifique los datos.", "error");
                    return;
                }

                if (Object.keys(busyUnits).length > 0) {
                    const message =
                    "Al menos una de las unidades ya está ocupada:\n" +
                    Object.keys(busyUnits).join("\n");
                    const result = await Swal.fire({
                    title: "¡Advertencia!",
                    text: message,
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonText: "Continuar",
                    cancelButtonText: "Cancelar",
                    });
                    if (!result.isConfirmed) return;
                }
                }
                // If validAssignations.length === 0 we silently skip validation.

                // -------------------------------
                // 2) SAVE NOTE (status=5)
                // -------------------------------
                const noteID = this.noteDetails.note_ident;

                const sumCommissions = (this.gruposCampos || []).reduce(
                (total, grupo) => total + (Number(grupo.commission) || 0),
                0
                );

                const commissionsValidation =
                Number(this.localNoteDetails.subtotal) === sumCommissions ? 1 : 0;

                const description =
                commissionsValidation === 1
                    ? "Los datos del formulario se han actualizado con éxito."
                    : "Los datos del formulario se han actualizado con éxito.<br>Comisiones no son iguales al subtotal.";

                // ✅ Check lot start/end times
                const lotStart = this.localNoteDetails.lot_start_time
                ? new Date(this.localNoteDetails.lot_start_time)
                : null;
                const lotEnd = this.localNoteDetails.lot_end_time
                ? new Date(this.localNoteDetails.lot_end_time)
                : null;

                if (lotStart && (!lotEnd || lotStart > lotEnd)) {
                this.localNoteDetails.in_lot = true;
                } else {
                this.localNoteDetails.in_lot = false;
                }   

                // this.localNoteDetails.note_status = 5;


                // -------------------------------
                // 3) SAVE UNIT ASSIGNATIONS (skip if none)
                // -------------------------------
                try {
                if (validAssignations.length > 0) {
                    // Use the same, cleaned array we validated
                    if (Object.keys(this.assignations || {}).length === 0) {
                    await axios.post(`${apiDirectory}/set-note-assignations`, validAssignations);
                    } else {
                    await axios.put(`${apiDirectory}/set-note-assignations`, validAssignations);
                    }
                }
                } catch (error) {
                console.error("Error al guardar asignaciones:", error);
                Swal.fire("Error", (error.response && error.response.data && error.response.data.error) || "No se pudieron guardar las asignaciones de unidades.", "error");
                return;
                }

                // -------------------------------
                // 4) SAVE ASSIGNATION DETAILS (skip loop if none)
                // -------------------------------
                let allSuccess = true;
                for (let index = 0; index < (this.assignationsData || []).length; index++) {
                const assignationData = this.assignationsData[index];

                const start_time_updated =
                    assignationData.start_time != null &&
                    (assignationData.start_time != this.initialAssignations[index].start_time);
                const arrival_time_updated =
                    assignationData.arrival_time != null &&
                    (assignationData.arrival_time != this.initialAssignations[index].arrival_time);
                const contact_time_updated =
                    assignationData.contact_time != null &&
                    (assignationData.contact_time != this.initialAssignations[index].contact_time);
                const end_time_updated =
                    assignationData.end_time != null &&
                    (assignationData.end_time != this.initialAssignations[index].end_time);

                let payload;
                try {
                    payload = {
                    start_time: start_time_updated
                        ? this.toISOFormatWithTimezone(assignationData.start_time)
                        : this.initialAssignations[index].start_time,
                    arrival_time: arrival_time_updated
                        ? this.toISOFormatWithTimezone(assignationData.arrival_time)
                        : this.initialAssignations[index].arrival_time,
                    contact_time: contact_time_updated
                        ? this.toISOFormatWithTimezone(assignationData.contact_time)
                        : this.initialAssignations[index].contact_time,
                    end_time: end_time_updated
                        ? this.toISOFormatWithTimezone(assignationData.end_time)
                        : this.initialAssignations[index].end_time,
                    };
                } catch (error) {
                    console.error(error);
                    Swal.fire("Error!", `Tiempo inválido en asignación ${index + 1}`, "error");
                    allSuccess = false;
                    continue;
                }

                try {
                    await axios.patch(`${apiDirectory}/assignation-detail/${assignationData.id}/`, payload);
                } catch (error) {
                    console.error("Error al actualizar asignación:", error);
                    allSuccess = false;
                }
                }

                // -------------------------------
                // 5) SEND TO LOT (if applicable)
                // -------------------------------
                // if (this.sendToLot) {
                // this.localNoteDetails.note_ident = this.localNoteDetails.note_ident.replace(/^ASV/, "LOT");
                // this.localNoteDetails.type = 4;

                // this.$router.push({
                //     name: "EditNote",
                //     params: { notetype: 4, noteID: this.localNoteDetails.note_ident },
                // });
                // return;
                // }

                // -------------------------------
                // 6) saveNote && FINAL FEEDBACK
                // -------------------------------

                this.sanitizeForm();
                this.saving_note = true;
                await axios.put(`${apiDirectory}/notes/${noteID}/`, this.localNoteDetails);
                this.saving_note = false;

                if (allSuccess) {
                    Swal.fire({
                        toast: true,
                        position: "top-end",
                        icon: "success",
                        background: "#d4edda",
                        title: "¡Completado!",
                        text: description,
                        showConfirmButton: false,
                        timer: 2500,
                        timerProgressBar: true,
                        didClose: () => {
                        this.$emit('refresh-note');
                        }
                    });
                } else {
                Swal.fire(
                    "Atención",
                    "La nota y asignaciones se guardaron, pero algunas asignaciones de detalle fallaron.",
                    "warning"
                ).then(result => {
                    if (result.isConfirmed) this.$emit('refresh-note');
                });
                }
            } catch (error) {
                console.error(error);
                this.saving_note = false;
                Swal.fire("Error", "Hubo un problema al guardar todo.", "error");
            }
        },
        saveNote: async function() {
            try {
                const noteID = this.noteDetails.note_ident; // Ensure this matches the actual ID property
                const apiDirectory = process.env.API_DIRECTORY;
                
                const sumCommissions = this.gruposCampos.reduce((total, grupo) => {
                                        return total + (Number(grupo.commission) || 0);
                                        }, 0);

                const commissionsValidation = Number(this.localNoteDetails.subtotal) === sumCommissions ? 1 : 0;

                const description =
                            commissionsValidation === 1
                                ? 'Los datos del formulario se han actualizado con éxito.'
                                : 'Los datos del formulario se han actualizado con éxito.<br>Comisiones no son iguales al subtotal.';
                
                this.sanitizeForm();
                this.saving_note = true
                console.log(this.localNoteDetails);
                await axios.put(`${apiDirectory}/notes/${noteID}/`, this.localNoteDetails);
                Swal.fire(
                    '¡Actualizado!',
                    description,
                    'success'
                ).then((result) => {
                if (result.isConfirmed) window.location.reload();
                });
                this.saving_note = false;
                this.$forceUpdate;
                // Additional actions after success, e.g., redirecting or updating local state
            } catch (error) {
                // Polygon condition and bad serializer cases
                console.error(error)
                this.saving_note=false
                if (error.response.status == 400) {
                    let isPolygon = false
                    if (error.response.data) {
                        const errorDataString = JSON.stringify(error.response.data);
                        try { isPolygon = errorDataString.includes("Mexico") }
                        catch { isPolygon = false }
                    }
                    if (isPolygon) {
                        Swal.fire('Error', 'Verifique que la latitud y longitud sean válidas. \nLos datos que intentó ingresar no corresponden a una dirección dentro de México.', 'error');
                    }
                    else {
                        Swal.fire('Error', 'Verifique que los datos que está ingresando son válidos', 'error');
                    }
                }
                else {
                    Swal.fire('Error', 'Hubo un problema al actualizar los datos de la nota.', 'error');
                }
            }
        },
        completeNote: async function() {
            try {
                // const noteID = this.localNoteDetails.note_ident; 
                const apiDirectory = process.env.API_DIRECTORY;
                
                if (this.gruposCampos.length === 1) {
                    this.gruposCampos[0].commission = this.localNoteDetails?.subtotal ?? 0;
                    await axios.patch(`${apiDirectory}/assignation-detail/${this.gruposCampos[0].id}/`, {commission: this.gruposCampos[0].commission});
                }

                //todas las horas de asignacion sean iguales a la primera
                if (this.assignationsData && this.assignationsData.length > 1) {
                    const first = this.assignationsData[0];
                    for (let i = 0; i < this.assignationsData.length; i++) {
                        const item = this.assignationsData[i];
                        item.start_time = item.start_time ?? first.start_time;
                        item.arrival_time = item.arrival_time ?? first.arrival_time;
                        item.contact_time = item.contact_time ?? first.contact_time;
                        item.end_time = item.end_time ?? first.end_time;
                        const payload = {
                            start_time: item.start_time,
                            arrival_time: item.arrival_time,
                            contact_time: item.contact_time,
                            end_time: item.end_time,
                        }
                        await axios.patch(`${apiDirectory}/assignation-detail/${item.id}/`, payload);
                    }
                }

                this.localNoteDetails.status = 4; 
                this.newSaveNote();
                // this.sanitizeForm();
                // const response = await axios.put(`${apiDirectory}/notes/${noteID}/`, this.localNoteDetails);
                
                // // Check for 500 error in response
                // if (response.status === 500) {
                //     Swal.fire('Error', 'Internal Server Error occurred while completing the note.', 'error');
                //     return;
                // }

                // Swal.fire({
                //     title: 'Completado!',
                //     text: 'La nota se ha completado con éxito',
                //     icon: 'success',
                //     showCancelButton: true,
                //     confirmButtonText: 'Aceptar',
                //     cancelButtonText: 'Regresar',
                // }).then((result) => {
                //     if (result.isConfirmed) {
                //         window.location.reload();
                //     } else if (result.dismiss === Swal.DismissReason.cancel) {
                //         window.history.back();
                //     }
                // });
            } catch (error) {
                console.error("Failed to update note:", error);
                Swal.fire('Error', 'Hubo un problema al completar la nota.', 'error');
            }
        },
        cancelNote: async function() {
            try {
                const noteID = this.localNoteDetails.note_ident; 
                const apiDirectory = process.env.API_DIRECTORY;
                this.localNoteDetails.status = 2; 
                this.sanitizeForm();
                const response = await axios.put(`${apiDirectory}/notes/${noteID}/`, this.localNoteDetails);
                
                // Check for 500 error in response
                if (response.status === 500) {
                    Swal.fire('Error', 'Internal Server Error occurred while closing the note.', 'error');
                    return;
                }

                Swal.fire({
                    title: '¡Cancelado!',
                    text: 'La nota y sus asignaciones se han cancelado con éxito',
                    icon: 'success',
                    showCancelButton: false,
                    confirmButtonText: 'Ok'
                }).then((result) => {
                    if (result.isConfirmed) {
                        location.reload();
                    }
                });
            } catch (error) {
                console.error("Failed to update note:", error);
                Swal.fire('Error', 'Hubo un problema al cancelar la nota.', 'error');
            }
        },
        saveBilling() {
            // Generate sign and stamp invoice
            const noteID = this.localNoteDetails.note_ident; 
            // console.log(noteID);
            const firstAssignation = this.assignationsData[0];
            //const vectorNoteID = this.localNoteDetails.note_ident.split('-');
            const apiDirectory = process.env.API_DIRECTORY;
            const dateDifferenceDays = Math.ceil(Math.ceil(Math.abs(new Date(this.localNoteDetails.lot_end_time) - new Date(this.localNoteDetails.lot_start_time)) / (1000 * 60 * 60)) / 24);
            const productDescriptions = {
                '78101803': "TRAFICO",
                '72154503': 'SERVICIO DE GRUA',
                '78121603': 'KILOMETRAJE',
                '90121800': 'ASISTENCIA DE EMERGENCIA',
                '81141601': 'MONTACARGAS 15 MIL LBS',
                '78181702': 'PENSION',
                '78181500': 'SERVICIOS DE MANTENIMIENTO Y REPARACIÓN DE VEHÍCULOS',
                '01010101': 'VENTA',
                '78121604': "TRAFICO",
                // Add more keys as needed
            };
            const retention_perc = this.applies_retention ? 0.04 : 0.00;
            // console.log(retention_perc);
            // const subbrandinfo = axios.post(`${apiDirectory}/get-sub-brand`, {"sub_brand_id": firstAssignation.assistance_note.vehicle_sub_brand});
            // console.log(subbrandinfo);

            // Get distance data
            const distTime = axios.post(`${apiDirectory}/get-distance-and-time`, {
                "org_lat": this.localNoteDetails.source?.lat || 0,
                "org_lng": this.localNoteDetails.source?.lon || 0,
                "dest_lat": this.localNoteDetails.destination?.lat || 0,
                "dest_lng": this.localNoteDetails.destination?.lon || 0
            });
            distTime.then(response => {
                this.distance = response.data?.distance || 0;
            }).catch(() => {
                this.distance = 0;
            });
            
            return axios.get(`${apiDirectory}/get-billing-info/${noteID}/`)
                .then(response => {

                try{
                let conceptos;
            // console.log(this.invoiceBreakdown);
                if (this.invoiceBreakdown === false){
                    conceptos = { 
                        //Custom product key
                        1:{
                        clave_prod_serv: this.prefered_product_key_traffic,
                        cantidad:'1',
                        clave_unidad: this.prefered_measurement_unit_traffic,    
                        descripcion: this.prefered_legend_traffic || productDescriptions[this.prefered_product_key_traffic],
                        valor_unitario: response.data['subtotal'],
                        objeto_imp: '02', 
                        no_identificacion: '8635',
                        impuestos:{
                            traslados:{
                                impuesto:'002',
                                tipo_factor:'Tasa',
                                tasa_o_cuota:'0.16',
                                importe: response.data['iva'],
                            },
                            retenciones:{
                                impuesto:'002',
                                tipo_factor:'Tasa',
                                tasa_o_cuota: retention_perc.toString(),
                                importe: Number(response.data['subtotal'] || 0) * retention_perc,
                            }
                        },
                    }};
                } else {
                    // console.log('hola');
                    const grandTraffic = Number(response.data['cost_by_traffic']);
                    const grandHighwayToll = Number(response.data['highway_tolls']);
                    const grandManeuvers = Number(response.data['maneuvers']);
                    // console.log(grandManeuvers);
                    const grandKms = Number(response.data['cost_by_km']);
                    // const grandImpoundLot =  Number(response.data['lot_total_cost']);
                    conceptos = { 
                        1:{ //TRAFICO
                        clave_prod_serv: this.prefered_product_key_traffic,
                        cantidad:'1',
                        clave_unidad:this.prefered_measurement_unit_traffic,    
                        descripcion: this.prefered_legend_traffic || 'TRAFICO',
                        valor_unitario: grandTraffic.toString(),
                        objeto_imp: '02', 
                        no_identificacion: '8635',
                        impuestos:{
                            traslados:{
                                impuesto:'002',
                                tipo_factor:'Tasa',
                                tasa_o_cuota:'0.16',
                                importe: grandTraffic * .16,
                            },
                            retenciones:{
                                impuesto:'002',
                                tipo_factor:'Tasa',
                                tasa_o_cuota: retention_perc.toLocaleString(),
                                importe: grandTraffic * retention_perc,
                            }
                        },
                    },
                    2: {//MANOIBRAS
                        clave_prod_serv:this.prefered_product_key_maneuvers,
                        cantidad:'1',
                        clave_unidad:this.prefered_measurement_unit_maneuvers,    
                        descripcion: this.prefered_legend_maneuvers || 'MANIOBRAS',
                        valor_unitario: grandManeuvers.toString(),
                        objeto_imp: '02', 
                        no_identificacion: '8635',
                        impuestos:{
                            traslados:{
                                impuesto:'002',
                                tipo_factor:'Tasa',
                                tasa_o_cuota:'0.16',
                                importe: grandManeuvers * .16,
                            },
                            retenciones:{
                                impuesto:'002',
                                tipo_factor:'Tasa',
                                tasa_o_cuota: retention_perc.toString(),
                                importe: grandManeuvers * retention_perc
                            }
                        },
                    },
                    3:{//CASETAS
                        clave_prod_serv:this.prefered_product_key_traffic,
                        cantidad:'1',
                        clave_unidad:this.prefered_measurement_unit_traffic,    
                        descripcion: 'CASETAS',
                        valor_unitario: grandHighwayToll.toString(),
                        objeto_imp: '02', 
                        no_identificacion: '8635',
                        impuestos:{
                            traslados:{
                                impuesto:'002',
                                tipo_factor:'Tasa',
                                tasa_o_cuota:'0.16',
                                importe: grandHighwayToll * .16,
                            },
                            retenciones:{
                                impuesto:'002',
                                tipo_factor:'Tasa',
                                tasa_o_cuota: retention_perc.toString(),
                                importe: grandHighwayToll * retention_perc
                            }
                        },
                    },
                    4:{//KILOMETRAJE
                        clave_prod_serv:this.prefered_product_key_cost_km,
                        cantidad: response.data['total_kms'].toString(),
                        clave_unidad:this.prefered_measurement_unit_cost_km,    
                        descripcion: this.prefered_legend_cost_km || 'KILOMETRAJE',
                        valor_unitario: grandKms.toString(),
                        objeto_imp: '02', 
                        no_identificacion: '8635',
                        impuestos:{
                            traslados:{
                                impuesto:'002',
                                tipo_factor:'Tasa',
                                tasa_o_cuota:'0.16',
                                importe: grandKms * .16,
                            },
                            retenciones:{
                                impuesto:'002',
                                tipo_factor:'Tasa',
                                tasa_o_cuota: retention_perc.toString(),
                                importe: grandKms * retention_perc
                            }
                        },
                    },
                    5:{//PENSION
                        clave_prod_serv:this.prefered_product_key_pension_days,
                        cantidad: dateDifferenceDays,
                        clave_unidad:this.prefered_measurement_unit_pension_days,    
                        descripcion: this.prefered_legend_pension_days || 'PENSION',
                        valor_unitario: response.data['lot_cost_per_day'].toString(),
                        objeto_imp: '02', 
                        no_identificacion: '8635',
                        impuestos:{
                            traslados:{
                                impuesto:'002',
                                tipo_factor:'Tasa',
                                tasa_o_cuota:'0.16',
                                importe: Number(response.data['lot_cost_per_day']) * .16,
                            },
                            retenciones:{
                                impuesto:'002',
                                tipo_factor:'Tasa',
                                tasa_o_cuota: retention_perc.toString(),
                                importe: Number(response.data['lot_cost_per_day']) * retention_perc
                            }
                        },
                    }
                };
                }
                //comenzar diccionario con info
                this.billingInfo = {
                    cartaporte: this.cartaporte,
                    receptor: {
                        rfc: response.data['client']['client_rfc'],
                        nombre: response.data['client']['client_name'],
                        uso_cfdi: response.data['invoice_use'],
                        domicilio_fiscal_receptor: response.data['client']['client_address']['codigoPostal'],
                        regimen_fiscal_receptor: response.data['client']['tax_regime']
                    },
                    metodo_pago: response.data['payment_method'],
                    forma_pago: response.data['payment_type'],
                    serie: this.invoiceSeries,//vectorNoteID[0], 
                    folio: String(this.invoiceNumber),//vectorNoteID[2], 
                    conceptos: conceptos,
                    periodicidad: this.invoice_generic_frequency || 0,
                    meses: this.invoice_generic_month || 0,
                    ano: this.invoice_generic_year || 0,
                    tipo_relacion: String(this.relationship_type),
                    uuid_relacionado: this.related_cfdi,
                };
                //CARTAPORTE
                        if (this.cartaporte) {
                        this.billingInfo.complemento = {
                            transp_internac: "No",
                            ubicacion_origen: {
                                tipo_ubicacion: "Origen",
                                id_ubicacion: "OR008635",
                                domicilio: {
                                    calle: response.data['source']['street_name'],
                                    estado: response.data['source']['state'],
                                    pais: 'MEX',
                                    codigo_postal: response.data['source']['zip_code']
                                },
                                fecha_hora: firstAssignation.start_time
                            },
                            ubicacion_destino: {
                                tipo_ubicacion: "Destino",
                                id_ubicacion: "DE008635",
                                domicilio: {
                                    calle: response.data['destination']['street_name'],
                                    estado: response.data['destination']['state'],
                                    pais: 'MEX',
                                    codigo_postal: response.data['destination']['zip_code']
                                },
                                fecha_hora: firstAssignation.end_time,
                                distancia_recorrida: this.distance
                            },
                            mercancia: {
                                peso_bruto_total: this.mercancia_peso, //
                                unidad_peso: 'KGM', 
                                num_total_mercancias: 1,
                                bienes_transp: this.bienes_transportados, //
                                descripcion: this.localNoteDetails.mercancia_descripcion,
                                cantidad: "1.00",
                                clave_unidad: this.unit_inventory,
                                peso_en_kg: this.mercancia_peso,
                                dimensiones: this.mercancia_dimensiones, //
                                valor_mercancia: this.localNoteDetails.mercancia_valor,
                                moneda: 'MXN',
                                autotransporte: {
                                    perm_sct: "TPAF04",
                                    num_permiso_sct: firstAssignation.unit.sct_permission,
                                    config_vehicular: firstAssignation.unit.vehicular_configuration,
                                    peso_bruto_vehicular: firstAssignation.unit.gross_weight,
                                    placa: firstAssignation.unit.unit_plates,
                                    anio_modelo_vm: firstAssignation.unit.unit_model,
                                    asegura_resp_civil: firstAssignation.unit.civil_liability_insurance,
                                    poliza_resp_civil: firstAssignation.unit.civil_liability_policy,
                                    sub_tipo_rem: firstAssignation.unit.trailer_sub_type
                                }
                            },
                            figura_transporte: {
                                tipo_figura: '01',
                                // rfc_figura: "EAPR9508168MA", // Example value
                                rfc_figura: firstAssignation.operator.employee_rfc,
                                num_licencia: firstAssignation.operator.employee_license_number,
                                nombre_figura: firstAssignation.operator.employee_first_name + ' ' + firstAssignation.operator.employee_last_name,
                                domicilio: {
                                    calle: firstAssignation.operator.employee_street,
                                    estado: "Nuevo León",
                                    pais: 'MEX',
                                    codigo_postal: firstAssignation.operator.employee_postcode
                                }
                            }
                        };
                    }
                   
                return this.invoiceStamping(this.billingInfo)
                .then(async (stampedInvoice) => {
                        if (!stampedInvoice) {
                            await Swal.fire({
                                icon: 'error',
                                title: 'Error de timbrado',
                                text: stampedInvoice?.error || 'No se pudo timbrar la factura',
                                confirmButtonText: 'Entendido'
                            });
                            return;
                        }

                        try {
                            const type = this.localNoteDetails.internal_payment_type === '4' ? 'Credito' : 'Contado';
                            // const series = 'G';
                            const numberResponse = await axios.post(`${apiDirectory}/calculate-invoice-number`);
                            const invoiceResponse = await axios.post(`${apiDirectory}/create-invoice/`, {
                                invoice_ident: (numberResponse.data[this.invoiceSeries] ?? 1) + '-' + this.invoiceSeries,
                                invoice_series: this.invoiceSeries,
                                invoice_number: Number((numberResponse.data[this.invoiceSeries] ?? 1)),
                                date_issued: new Date().toISOString(),
                                xml: stampedInvoice,
                                invoice_type: type,
                                amount: Number(this.localNoteDetails.total),
                                balance: 0,
                                invoice_generic_frequency: this.invoice_generic_frequency,
                                invoice_generic_month: this.invoice_generic_month,
                                invoice_generic_year: this.invoice_generic_year,
                                note_ids: [this.localNoteDetails.id],
                            });
                            
                            this.invoice_id = invoiceResponse.data?.id;
                            this.localNoteDetails.invoice = this.invoice_id;
                            this.localNoteDetails.status = 6;
                            
                            response = await axios.post(`${apiDirectory}/set-invoice-transactions`, 
                                        [{   transaction_ident: '',
                                            invoice: this.invoice_id, //this.localNoteDetails.invoice_detail.id,
                                            amount: Number(this.localNoteDetails.total),
                                            reference: '',
                                            transaction_type: 1,
                                            transaction_date: new Date().toISOString(),
                                            origin_bank_account: '',
                                            destination_bank_account: '',
                                            bank: '',
                                            payment_method: '',
                                            cfdi_comments: '',
                                            observations: '',
                                        }]); //Create transaction of type FACTURACION
                                    //If payment_method = PUE, create another transaction of payment
                                    if (this.localNoteDetails.payment_method == "PUE"){
                                        response = await axios.post(`${apiDirectory}/set-invoice-transactions`, 
                                               [{   transaction_ident: '',
                                                    invoice: this.invoice_id, //this.localNoteDetails.invoice_detail.id,
                                                    amount: Number(this.localNoteDetails.total),
                                                    reference: '',
                                                    transaction_type: 2,
                                                    transaction_date: new Date().toISOString(),
                                                    origin_bank_account: '',
                                                    destination_bank_account: '',
                                                    bank: '',
                                                    payment_method: '',
                                                    cfdi_comments: '',
                                                    observations: '',
                                                }]);
                                    }

                            const balanceNumber = await axios.post(`${apiDirectory}/calculate-invoice-balance`, { invoice_ident: this.invoice_id });
                            // console.log(balanceNumber.data);

                            response = await axios.put(`${apiDirectory}/update-invoice/${(numberResponse.data[this.invoiceSeries] ?? 1) + '-' + this.invoiceSeries}/`, {balance: Number(balanceNumber.data)}); 
                            if (response.data === "Success" || response.data.success) {
                                await Swal.fire({
                                    title: '¡Actualizado!',
                                    text: 'Movimiento creado con éxito.',
                                    icon: 'success',
                                    confirmButtonText: 'Ok'
                                }) //.then(() => location.reload());
                            }

                            await this.saveNote();
                            return stampedInvoice;
                            
                            // await Swal.fire({
                            //     icon: 'success',
                            //     title: 'Éxito',
                            //     text: 'Factura generada correctamente',
                            //     confirmButtonText: 'Aceptar'
                            // });
                            
                            // return stampedInvoice;
                            
                        } catch (error) {
                            console.error('Error:', error);
                            return error;
                            // await Swal.fire({
                            //     icon: 'error',
                            //     title: 'Error',
                            //     text: 'Hubo un problema al guardar la factura',
                            //     confirmButtonText: 'Entendido'
                            // });
                        }
                    });
            } catch (error) {
                console.error('Error:', error);
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Ocurrió un error al preparar los datos de facturación',
                    confirmButtonText: 'Entendido'
                });
            }
        })
        .catch(error => {
            console.error('Error:', error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'No se pudo obtener la información de facturación',
                confirmButtonText: 'Entendido'
            });
        });
},
        invoiceStamping(billingInfo) {
            const apiDirectory = process.env.API_DIRECTORY;
            return axios.post(`${apiDirectory}/invoice-stamping`, billingInfo)
                .then(response => {
                    return response.data;
                })
                .catch(error => {
                    // const errorMessage = 
                    //     error.response.data.error === 'conversion from NoneType to Decimal is not supported'
                    //         ? 'Error en datos de costos'
                    //         : error.response.data.error;
                    console.error('Error generando factura:', error);
                    Swal.fire('Error', 'Hubo un problema al generar la factura. ' + error.response.data.error, 'error');
                    // console.log(error.response.data.error);
                    // console.log(error);
                    return error;
                });
        },

        closePopup() {
            this.showPopup = false;
            this.related_cfdi = '';
            this.relationship_type = '';
        },

        async checkForRelatedInvoices() {
                if (this.saving_invoice) return; // 🚫 Prevent spamming clicks
                this.saving_invoice = true;
                try {
                    const apiDirectory = process.env.API_DIRECTORY;
                    const linkedInvoices = await axios.post(`${apiDirectory}/list-invoices-for-note/`, {
                    note_id: this.localNoteDetails.id,
                    });

                    if (!this.localNoteDetails.invoice_detail && linkedInvoices.data.length > 0) {
                    this.showPopup = true;
                    } else {
                    await this.generateInvoiceDocument();
                    }
                } catch (error) {
                    console.error("Error en guardado:", error);
                } finally {
                    this.saving_invoice = false;
                }
            },

        async generateInvoiceDocument(){
            if (!this.canGenerateDocuments) {
                Swal.fire('Sin acceso', 'No tienes permisos para generar factura.', 'warning')
                return
            }
            const apiDirectory = process.env.API_DIRECTORY;
            this.showPopup = false;

            this.saving_invoice = true;

            let signedXML;
            if (this.localNoteDetails.invoice_detail) {
                signedXML = this.localNoteDetails.invoice_detail.xml;
                this.invoiceNumber = this.localNoteDetails.invoice_detail.invoice_number;
                } else {
                    const response = await axios.post(`${apiDirectory}/calculate-invoice-number`);
                // Store the invoice number in your component state
                    this.invoiceNumber = (response.data[this.invoiceSeries] ?? 1);
                // If no invoice_detail.xml exists, generate and save billing
                signedXML = await this.saveBilling();
                if (!signedXML) {
                //     await Swal.fire({
                //         icon: 'error',
                //         title: 'Error',
                //         text: 'No se pudo generar la factura',
                //         confirmButtonText: 'Entendido'
                //     });
                    return;
                }
                // console.log(signedXML);
                }
                // console.log(signedXML);
            // console.log(this.localNoteDetails);
            const firstAssignation = this.assignationsData[0];
            const dateDifferenceHours = Math.ceil(Math.abs(new Date(this.localNoteDetails.lot_end_time) - new Date(this.localNoteDetails.lot_start_time)) / (1000 * 60 * 60));
            axios.post(`${apiDirectory}/generate-invoice-documents`, 
                {signedXML: signedXML,
                    plh_authorize: this.localNoteDetails?.approved_by ?? '',
                    plh_operatorName: (this.invoiceSeries === 'NSN' || 
                            this.invoiceSeries === 'SN' || 
                            this.client_rfc === 'XEXX010101000' || 
                            this.client_rfc === 'XAXX010101000')
                                ? ''
                                : (firstAssignation?.operator?.employee_first_name ?? '') + ' ' + (firstAssignation?.operator?.employee_last_name ?? ''),
                    plh_operatorNumber: (this.invoiceSeries === 'NSN' || 
                            this.invoiceSeries === 'SN' || 
                            this.client_rfc === 'XEXX010101000' || 
                            this.client_rfc === 'XAXX010101000')
                                ? ''
                                : firstAssignation?.operator?.employee_ident ?? '',
                    plh_orderId: this.localNoteDetails?.note_number ?? '',
                    plh_unitNumber: (this.invoiceSeries === 'NSN' || 
                            this.invoiceSeries === 'SN' || 
                            this.client_rfc === 'XEXX010101000' || 
                            this.client_rfc === 'XAXX010101000')
                                ? ''
                                : firstAssignation?.unit?.unit_short_id ?? '',
                    plh_plates: this.localNoteDetails?.vehicle_plates ?? '',
                    plh_vehicleBrand:
                            (this.invoiceSeries === 'NSN' || this.invoiceSeries === 'SN' ||
                            this.client_rfc === 'XEXX010101000' || this.client_rfc === 'XAXX010101000')
                            ? ''
                            : ((this.selectedBrandId ?? '') + ' ' + (this.selectedSubBrandId ?? '')).trim(),
                    plh_vehicleModel: (this.invoiceSeries === 'NSN' || 
                            this.invoiceSeries === 'SN' || 
                            this.client_rfc === 'XEXX010101000' || 
                            this.client_rfc === 'XAXX010101000')
                                ? ''
                                : (this.localNoteDetails?.vehicle_model ?? '') + ' ' + (this.localNoteDetails?.vehicle_color ?? ''),
                    plh_niv: this.localNoteDetails?.vehicle_engine_series ?? '',
                    plh_insuredName: this.localNoteDetails?.vehicle_owner_name ?? '',
                    plh_record: this.localNoteDetails?.file_number ?? '',
                    plh_insurancePolicy: this.localNoteDetails?.insurance_policy ?? '',
                    plh_lot: this.localNoteDetails?.lot ?? '',
                    plh_origin: 
                    (this.localNoteDetails?.source?.neighborhood ?? '') + ', ' +
                    (this.localNoteDetails?.source?.city ?? '') + ' ' +
                    (this.localNoteDetails?.source?.state ?? ''),
                    plh_detentionDescription: this.localNoteDetails?.lot_retention ?? '',
                    plh_authority: this.localNoteDetails?.lot_authority ?? '',
                    plh_arrivalTime: this.localNoteDetails?.lot_start_time 
                    ? this.localNoteDetails.lot_start_time.slice(0, 10) + ' ' + this.localNoteDetails.lot_start_time.slice(11, 16) 
                    : '',
                    plh_endTime: this.localNoteDetails?.lot_end_time 
                    ? this.localNoteDetails.lot_end_time.slice(0, 10) + ' ' + this.localNoteDetails.lot_end_time.slice(11, 16) 
                    : '',
                    plh_totalTime: dateDifferenceHours ?? 0,
                    plh_discount: '0.00',
                    note_type: 'LOT',
                    invoice_number: this.invoiceNumber ?? '',
                    plh_series: this.invoiceSeries ?? '',
                    plh_total: this.localNoteDetails?.total ?? 0,
                    plh_subtotal: this.localNoteDetails?.subtotal ?? 0,
                    plh_retention: this.localNoteDetails?.retention ?? 0,
                    plh_iva: this.localNoteDetails?.iva ?? 0,
                    plh_client_name: this.client_name ?? ''
                }, {
                responseType: 'blob'
            })
            .then(response => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `factura_${this.invoiceNumber}.zip`);
                document.body.appendChild(link);
                link.click();
                link.remove();
                this.saving_invoice = false;
            })
            .catch(error => {
                this.saving_invoice = false;
                console.error('Error generating files', error)
            });
        },
        async generateNoteDocument() {
            const apiDirectory = process.env.API_DIRECTORY;
            const firstAssignation = this.assignationsData[0];

            // Calculate hours and days difference safely
            const lotStart = this.localNoteDetails.lot_start_time ? new Date(this.localNoteDetails.lot_start_time) : null;
            const lotEnd = this.localNoteDetails.lot_end_time ? new Date(this.localNoteDetails.lot_end_time) : null;

            let dateDifferenceHours = 0;
            let dateDifferenceDays = 0;
            if (lotStart && lotEnd) {
                const diffMs = Math.abs(lotEnd - lotStart);
                dateDifferenceHours = Math.ceil(diffMs / (1000 * 60 * 60));
                dateDifferenceDays = Math.ceil(dateDifferenceHours / 24);
            }

            // Helper to safely format a date string
            const formatDate = (dt) =>
                dt ? dt.slice(0, 10) + ' ' + dt.slice(11, 16) : '';

            try {
                const response = await axios.post(
                    `${apiDirectory}/generate-note-documents`,
                    {
                        plh_authorize: this.localNoteDetails.approved_by ?? '',
                        plh_operatorName: ((firstAssignation?.operator?.employee_first_name ?? '') + ' ' + (firstAssignation?.operator?.employee_last_name ?? '')).trim(),
                        plh_operatorNumber: firstAssignation?.operator?.employee_ident ?? '',
                        plh_orderId: this.localNoteDetails.note_number ?? '',
                        plh_unitNumber: firstAssignation?.unit?.unit_short_id ?? '',
                        plh_plates: this.localNoteDetails.vehicle_plates ?? '',
                        plh_vehicleBrand: (this.selectedBrandId ?? '') + ' ' + (this.selectedSubBrandId ?? ''),
                        plh_vehicleModel: (this.localNoteDetails.vehicle_model ?? '') + ' ' + (this.localNoteDetails.vehicle_color ?? ''),
                        plh_niv: this.localNoteDetails.vehicle_engine_series ?? '',
                        plh_insuredName: this.localNoteDetails.vehicle_owner_name ?? '',
                        plh_record: this.localNoteDetails.file_number ?? '',
                        plh_insurancePolicy: this.localNoteDetails.insurance_policy ?? '',
                        plh_lot: this.localNoteDetails.lot ?? '',
                        plh_origin: ((this.localNoteDetails.source?.neighborhood ?? '') + ', ' + (this.localNoteDetails.source?.city ?? '') + ' ' + (this.localNoteDetails.source?.state ?? '')).trim(),
                        plh_detentionDescription: this.localNoteDetails.lot_retention ?? '',
                        plh_authority: this.localNoteDetails.lot_authority ?? '',
                        plh_arrivalTime: formatDate(this.localNoteDetails.lot_start_time),
                        plh_endTime: formatDate(this.localNoteDetails.lot_end_time),
                        plh_totalTime: dateDifferenceHours,
                        plh_discount: '0.00',
                        note_type: 'LOT',
                        invoice_number: this.invoiceNumber ?? '',
                        plh_total: this.localNoteDetails.total ?? 0,
                        plh_subtotal: this.localNoteDetails.subtotal ?? 0,
                        plh_retention: this.localNoteDetails.retention ?? 0,
                        plh_iva: this.localNoteDetails.iva ?? 0,
                        plh_clientName: this.client_name ?? '',
                        plh_series: this.invoiceSeries ?? '',
                        plh_clientRfc: this.client_rfc ?? '',
                        plh_invoice: this.localNoteDetails?.invoice_detail?.invoice_ident ?? 'No facturado',
                        plh_sucursal: this.localNoteDetails.sucursal ?? '',
                        plh_internalPaymentType: this.localNoteDetails.internal_payment_type ?? '',
                        plh_requestedDate: formatDate(this.localNoteDetails.request_time),
                        plh_lotAuthority: this.localNoteDetails.lot_authority ?? '',
                        plh_totalKms: this.localNoteDetails.total_kms ?? 0,
                        plh_highwayTolls: this.localNoteDetails.highway_tolls ?? 0,
                        plh_costTraffic: this.localNoteDetails.cost_by_traffic ?? 0,
                        plh_maneuvers: this.localNoteDetails.maneuvers ?? 0,
                        plh_costKm: this.localNoteDetails.cost_by_km ?? 0,
                        plh_costAllKms: Number(this.localNoteDetails.total_kms ?? 0) * Number(this.localNoteDetails.cost_by_km ?? 0),
                        plh_pensionDays: dateDifferenceDays,
                        plh_costDay: this.localNoteDetails.lot_cost_per_day ?? 0,
                        plh_costAllPension: this.localNoteDetails.lot_total_cost ?? 0
                    },
                    { responseType: 'blob' }
                );

                // Download file
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `orden_trabajo_${this.localNoteDetails.note_number ?? 'NA'}.zip`);
                document.body.appendChild(link);
                link.click();   
                link.remove();

                // Optional: save note
                // this.saveNote();
            } catch (error) {
                console.error('Error generating files', error);
            }
        },
        // async generateNoteDocument(){
        //     const apiDirectory = process.env.API_DIRECTORY;
        //     // const signedXML = await this.saveBilling();
        //     const firstAssignation = this.assignationsData[0];
        //     const dateDifferenceHours = Math.ceil(Math.abs(new Date(this.localNoteDetails.lot_end_time) - new Date(this.localNoteDetails.lot_start_time)) / (1000 * 60 * 60));
            
        //     const dateDifferenceDays = Math.ceil(Math.ceil(Math.abs(new Date(this.localNoteDetails.lot_end_time) - new Date(this.localNoteDetails.lot_start_time)) / (1000 * 60 * 60)) / 24);
        
        //     axios.post(`${apiDirectory}/generate-note-documents`, 
        //                 {
        //                 plh_authorize: this.localNoteDetails.approved_by,
        //                 plh_operatorName: firstAssignation.operator.employee_first_name + ' ' + firstAssignation.operator.employee_last_name,
        //                 plh_operatorNumber: firstAssignation.operator.employee_ident,
        //                 plh_orderId: this.localNoteDetails.note_number, //note_ident,
        //                 plh_unitNumber: firstAssignation.unit.unit_short_id,
        //                 plh_plates: this.localNoteDetails.vehicle_plates,
        //                 plh_vehicleBrand: this.selectedBrandId + ' ' + this.selectedSubBrandId, 
        //                 plh_vehicleModel: this.localNoteDetails.vehicle_model + '  ' + this.localNoteDetails.vehicle_color,
        //                 plh_niv: this.localNoteDetails.vehicle_engine_series,
        //                 plh_insuredName: this.localNoteDetails.vehicle_owner_name,
        //                 plh_record: this.localNoteDetails.file_number,
        //                 plh_insurancePolicy: this.localNoteDetails.insurance_policy,
        //                 plh_lot: this.localNoteDetails.lot,
        //                 plh_origin: this.localNoteDetails.source.neighborhood + ', ' + this.localNoteDetails.source.city + ' ' + this.localNoteDetails.source.state,
        //                 plh_detentionDescription: this.localNoteDetails.lot_retention,
        //                 plh_authority: this.localNoteDetails.lot_authority,
        //                 plh_arrivalTime: this.localNoteDetails.lot_start_time.slice(0, 10) + ' ' + this.localNoteDetails.lot_start_time.slice(11, 16),
        //                 plh_endTime: this.localNoteDetails.lot_end_time.slice(0, 10) + ' ' + this.localNoteDetails.lot_end_time.slice(11, 16),
        //                 // plh_retention:this.localNoteDetails.retention,
        //                 plh_totalTime: dateDifferenceHours,
        //                 plh_discount: '0.00',
        //                 note_type: 'LOT',
        //                 invoice_number: this.invoiceNumber,
        //                 plh_total: this.localNoteDetails.total,
        //                 plh_subtotal: this.localNoteDetails.subtotal,
        //                 plh_retention: this.localNoteDetails.retention,
        //                 plh_iva: this.localNoteDetails.iva,
        //                 plh_clientName: this.client_name,
        //                 plh_series: 'G',
        //                 plh_clientRfc: this.client_rfc,

        //                 plh_invoice: this.localNoteDetails?.invoice_detail?.invoice_ident ?? 'No facturado',
        //                 plh_sucursal: this.localNoteDetails.sucursal,
        //                 plh_internalPaymentType: this.localNoteDetails.internal_payment_type,
        //                 plh_requestedDate: this.localNoteDetails.request_time.slice(0, 10) + ' ' + this.localNoteDetails.request_time.slice(11, 16),
        //                 plh_lotAuthority: this.localNoteDetails.lot_authority,

        //                 plh_totalKms: this.localNoteDetails.total_kms,
        //                 plh_highwayTolls: this.localNoteDetails.highway_tolls,
        //                 plh_costTraffic: this.localNoteDetails.cost_by_traffic,
        //                 plh_maneuvers: this.localNoteDetails.maneuvers,
        //                 plh_costKm: this.localNoteDetails.cost_by_km,
        //                 plh_costAllKms: Number(this.localNoteDetails.total_kms) * Number(this.localNoteDetails.cost_by_km),
        //                 plh_pensionDays: dateDifferenceDays,
        //                 plh_costDay: this.localNoteDetails.lot_cost_per_day,
        //                 plh_costAllPension: this.localNoteDetails.lot_total_cost

        //                 }, 
        //         {
        //         responseType: 'blob'
        //     })
        //     .then(response => {
        //         const url = window.URL.createObjectURL(new Blob([response.data]));
        //         const link = document.createElement('a');
        //         link.href = url;
        //         link.setAttribute('download', `orden_trabajo_${this.localNoteDetails.note_number}.zip`);
        //         document.body.appendChild(link);
        //         link.click();
        //         link.remove();
        //         // this.saveNote();
        //     })
        //     .catch(error => {
        //         console.error('Error generating files', error)
        //     });
        // },
        // fetchLocations() {
        //     const apiDirectory = process.env.API_DIRECTORY;
        //     axios.get(`${apiDirectory}/fetch-last-vehicle-locations`)
        //         .then(response => {
        //             this.locations.value = response.data;
        //         })
        //         .catch(error => {
        //             console.error('Error fetching locations:', error);
        //         });
        // },
        // onMounted() {
        //     this.fetchLocations();
        //     setInterval(this.fetchLocations, 20000);
        // },
        async saveNewClient() {
            const clientData = {
                client_ident: 'test',
                client_name: this.client_front_name,
                client_address: {
                    street: this.clientDetails.client_address.street,
                    codigoPostal: this.clientDetails.client_codigoPostal,
                    neighborhood: this.client_neighborhood,
                    city: this.client_city,
                    state: this.client_state,
                },
                client_rfc: this.clientDetails.client_rfc,
                phone: this.clientDetails.phone,
                client_status: 1,
                is_privileged: this.clientDetails.is_privileged,
                client_type: this.clientDetails.client_type
                
            };
            try {
                // Validate clientData here (optional)

                // Replace 'http://yourbackend.api/clients' with your actual API endpoint
                //console.log(clientData);
                const apiDirectory = process.env.API_DIRECTORY;
                const response = await axios.post(`${apiDirectory}/create-client`, clientData, {
                            headers:
                            {
                                'Content-Type': 'application/json',
                            },
                        });
                this.client_id = response.data.id;
                this.localNoteDetails.client = this.client_id;
                
                // If the request is successful
                Swal.fire('Guardado!', 'El nuevo cliente se guardó correctamente.', 'success');
                

            } catch (error) {
                console.error('There was an error saving the client:', error);
                Swal.fire('Error', 'Hubo un problema al guardar el cliente nuevo.', 'error');
            }
        },
        fetchAssignationsForNote() {
            const apiDirectory = process.env.API_DIRECTORY;
            const noteId = this.localNoteDetails.note_ident;
            axios.post(`${apiDirectory}/get-note-assignations`, { note_ident: noteId })
                .then(response => {
                    this.assignationsData = response.data.map(assignation => ({
                        ...assignation,
                        unidad: assignation.unit.unit_short_id,
                        operador: assignation.operator.employee_ident,
                        operador_name: assignation.operator.employee_first_name,
                        operador_last_name: assignation.operator.employee_last_name,
                        unidad_name: assignation.unit.unit_sub_brand,
                        commission: assignation.commission
                    }));
                    //Used afterwards to compare if the original or the updated value should be used when making an update
                    this.initialAssignations = JSON.parse(JSON.stringify(this.assignationsData));
                    if (this.assignationsData[0]) {
                const startTime = new Date(this.assignationsData[0].start_time);
                const endTime = new Date(this.assignationsData[0].end_time);
                const timeDifference = (endTime - startTime) / (1000 * 60 * 60); // Convert ms to hours

                // Set the total_hours in localNoteDetails
                this.timeToComplete = parseFloat(timeDifference.toFixed(2));
                if (this.assignationsData[0].client_signature) {
        this.loadSignature(this.assignationsData[0].client_signature);
    }
            }
                })
                .catch(error => {
                    console.error('Error fetching assignations:', error);
                });
        },
        // formatDateTimeShow() {
        //     if (this.localNoteDetails.lot_start_time) {
        //     console.log(this.localNoteDetails.lot_start_time)
        //     let date = new Date(this.localNoteDetails.lot_start_time);
        //     this.localNoteDetails.lot_start_time = date.toISOString().slice(0, 16);
        //     }
            
        //     if (this.localNoteDetails.lot_end_time) {
        //     console.log(this.localNoteDetails.lot_end_time)
        //     let date = new Date(this.localNoteDetails.lot_end_time);
        //     this.localNoteDetails.lot_end_time = date.toISOString().slice(0, 16);
        //     }
            
        // },
        toISOFormatWithTimezone(dateString) {
            if (!dateString) return null;
            try {
                const date = new Date(dateString);
                let isoDate = date.toISOString();
                return isoDate;
            }
            catch (error) {
                console.error(error);
                throw new Error('Failed to format date str: ' + error.message);
            }
        },

        async saveAssignation(assignationData, index) {
            let payload;
            // check if indeed there was a change. If the original time and current time are different, plus current is not null, set flag to true
            const start_time_updated = assignationData.start_time != null && (assignationData.start_time != this.initialAssignations[index].start_time);
            const arrival_time_updated = assignationData.arrival_time != null && (assignationData.arrival_time != this.initialAssignations[index].arrival_time);
            const contact_time_updated = assignationData.contact_time != null && (assignationData.contact_time != this.initialAssignations[index].contact_time);
            const end_time_updated = assignationData.end_time != null && (assignationData.end_time != this.initialAssignations[index].end_time);
            try {
                payload = {
                    // Depending on the flag control wether to use the (new) current value, or the existing one
                    start_time: start_time_updated ? this.toISOFormatWithTimezone(assignationData.start_time) : this.initialAssignations[index].start_time,
                    arrival_time: arrival_time_updated ? this.toISOFormatWithTimezone(assignationData.arrival_time) : this.initialAssignations[index].arrival_time,
                    contact_time: contact_time_updated ? this.toISOFormatWithTimezone(assignationData.contact_time) : this.initialAssignations[index].contact_time,
                    end_time: end_time_updated ? this.toISOFormatWithTimezone(assignationData.end_time) : this.initialAssignations[index].end_time,
                };
            }
            catch (error) {
                console.error(error)
                Swal.fire({
                    title: 'Error!',
                    text: 'Se recibio un valor inválido de tiempo para la actualización. Verifique los datos que introdujo.',
                    icon: 'error',
                    showCancelButton: false, // Hide cancel button
                    confirmButtonText: 'Ok'
                })
                return
            }
            const apiDirectory = process.env.API_DIRECTORY;
            const assignationId = assignationData.id;
            try {
                await axios.patch(`${apiDirectory}/assignation-detail/${assignationId}/`, payload);
                if (assignationData.start_time) {
                    this.localNoteDetails.status = 1;
                    await this.saveNote();
                }
                Swal.fire({
                    title: '¡Completado!',
                    text: 'La hora y fecha se actualizó con éxito',
                    icon: 'success',
                    showCancelButton: false, // Hide cancel button
                    confirmButtonText: 'Ok'
                }).then((result) => {
                    if (result.isConfirmed) {
                        location.reload(); // Reload the page after 'Ok' is clicked
                    }
                });
            } catch (error) {
                console.error('Error al actualizar la asignación:', error);
                Swal.fire('Error', 'Hubo un problema al actualizar las asignaciones', 'error');
            }
        },
        async fetchRecommendations() {
            const noteID = this.$route.params.noteID; // Get noteID from route params
            this.recommendations = [
                { 'unit': 'Cargando', 'time_queue': 'Cargando', 'distance_to_origin': 'Cargando' },
                { 'unit': 'Cargando', 'time_queue': 'Cargando', 'distance_to_origin': 'Cargando' },
                { 'unit': 'Cargando', 'time_queue': 'Cargando', 'distance_to_origin': 'Cargando' },
                { 'unit': 'Cargando', 'time_queue': 'Cargando', 'distance_to_origin': 'Cargando' },
                { 'unit': 'Cargando', 'time_queue': 'Cargando', 'distance_to_origin': 'Cargando' }]
            this.recommenderLoading = true; 
            this.$forceUpdate();
            try {
                const apiDirectory = process.env.API_DIRECTORY;
                const response = await axios.post(`${apiDirectory}/recommend-tow`, { "note_ident": noteID });
                //this.recommendations = response.data;
                this.recommendations = [...response.data];
                while (this.recommendations.length < 5) {
                this.recommendations.push({ unit: "No disponible", time_queue: "No disponible", distance_to_origin: "No disponible" });
                }
                this.originMarkerPosition.value = { lat: parseFloat(this.noteDetails.source.lat), lng: parseFloat(this.noteDetails.source.lon) };
                this.destinationMarkerPosition.value = { lat: parseFloat(this.noteDetails.destination.lat), lng: parseFloat(this.noteDetails.destination.lon) };
                this.showOriginMarker = true;
                this.showDestinationMarker = true;
                this.blockRecommend = false;
                this.$forceUpdate();
                console.log("recommendations are", this.recommendations)
            }
            catch (error) {
                this.recommenderLoading = false; 
                console.error("Failed to fetch recommendations:", error);
                if (error.response.status == 500) {
                    Swal.fire(
                        '¡Error!',
                        'Ocurrió un error al obtener las recomendaciones\n Intente de nuevo. Si el problema persiste, contacte a su administrador',
                        'error'
                    );
                }
                this.recommendations = [
                    { 'unit': 'Error', 'time_queue': 'Error', 'distance_to_origin': 'Error' },
                    { 'unit': 'Error', 'time_queue': 'Error', 'distance_to_origin': 'Error' },
                    { 'unit': 'Error', 'time_queue': 'Error', 'distance_to_origin': 'Error' },
                    { 'unit': 'Error', 'time_queue': 'Error', 'distance_to_origin': 'Error' },
                    { 'unit': 'Error', 'time_queue': 'Error', 'distance_to_origin': 'Error' }]
            }
        },

        sanitizeForm() {
            /**Used to sanitize values before submitting any changes */

            //Since not all notes require km, change empty str to null
            this.localNoteDetails.source_km == "" ? this.localNoteDetails.source_km = null : true
            this.localNoteDetails.destination_km == "" ? this.localNoteDetails.destination_km = null : true
            //Since user is advised to not fill model if unkown, check if empty then change to null if its the case
            this.localNoteDetails.vehicle_model == "" ? this.localNoteDetails.vehicle_model = null : true
        },
        validatePositiveIntegerField(event) {
            /**Used to validate positive integer fields */
            if (event.charCode < 48 || event.charCode > 57) {
                event.preventDefault();
            }
        },
        validateFloatField(event) {
            const charCode = event.charCode;
            const value = event.target.value;

            const isDigit = charCode >= 48 && charCode <= 57;
            const isMinus = charCode === 45 && value.indexOf('-') === -1;
            const isDot = charCode === 46 && value.indexOf('.') === -1;

            if (!isDigit && !isMinus && !isDot) {
                event.preventDefault();
            }
        },
        async FetchBrands() {
            /** Fetches the brands from the db an passes it to the brands prop */
            try {
                const apiDirectory = process.env.API_DIRECTORY;
                const response = await axios.get(`${apiDirectory}/get-brands`);
                // Tmp dict to hold the response after processing 
                const brandsDict = {};
                // Convert response into dict of form: {pk:brand}
                response.data.forEach(brand => {
                    //brandsDict[brand.pk] = brand.brand;  // Adjust based on actual keys in your data
                    brandsDict[brand.brand] = brand.pk;  // Adjust based on actual keys in your data
                });
                console.log(brandsDict)
                this.brands = brandsDict
            }
            catch (error) {
                console.error("Failed to fetch brands", error);
                console.log(error.response)
                if (error.response.status == 400) {
                    Swal.fire('Error', "Hubo un problema con la solicitud. Intentalo nuevamente.\n\
                    Si el problema persiste, contacte a su administrador.", 'error');
                    return
                }
                if (error.response.status == 500) {
                    Swal.fire('Error', "Ocurrió un error desconocido. Intentalo nuevamente.\n\
                    Si el problema persiste, contacte a su administrador.", 'error');
                }
            }
        },
        async FetchFilteredSubBrands(event){
            // Grab the value from the brand selector 
            this.subBrandLoading = true
            const selectedBrandPk = event.target.value;
            // Checks if there was a change in the brand. If so, reset the vue model value to null to prevent form submission until a conscius selection is made
            selectedBrandPk !== this.localNoteDetails.vehicle_brand ?  this.localNoteDetails.vehicle_sub_brand = null : true;
            try { 
                const apiDirectory = process.env.API_DIRECTORY;
                const response = await axios.post(`${apiDirectory}/get-filtered-sub-brands`,{"brand_id":selectedBrandPk});
                // Tmp dict to hold the response after processing 
                const subBrandsDict = {};
                // Convert response into dict of form: {id:sub_brand + "Clase: "+ required_class}
                const classes={1:'A',2:'B',3:'C',4:'D'}
                response.data.forEach(sub_brand => {
                    subBrandsDict[sub_brand.sub_brand+' '+'-- Clase: '+classes[sub_brand.required_unit_type]] = sub_brand.id;  // Adjust based on actual keys in your data
                });
                this.sub_brands = subBrandsDict;
                this.subBrandLoading = false
            }
            catch (error) {
                console.error("Failed to fetch brands", error);
                console.log(error)
                if (error.response.status == 400) {
                    Swal.fire('Error', "Hubo un problema con la solicitud. Intentalo nuevamente. \
                    Si el problema persiste, contacte a su administrador.", 'error');

                }
                if (error.response.status == 500) {
                    Swal.fire('Error', "Ocurrió un error desconocido. Intentalo nuevamente. \
                    Si el problema persiste, contacte a su administrador.", 'error');
                }
            }
        },
        async SetStartingBrandSubBrand(){
            try { 
                const apiDirectory = process.env.API_DIRECTORY;
                const response = await axios.post(`${apiDirectory}/get-sub-brand`,{"sub_brand_id":this.noteDetails.vehicle_sub_brand});
                // Tmp dict to hold the response after processing 
                this.localNoteDetails.vehicle_brand = this.brands[response.data.brand];
                this.localNoteDetails.vehicle_sub_brand = response.data.id;
                //const classes={1:'A',2:'B',3:'C',4:'D'};
                const syntheticEvent = {
                    target: {
                        value: this.localNoteDetails.vehicle_brand 
                    }
                };
                await this.FetchFilteredSubBrands(syntheticEvent);
            }
            catch (error) {
                console.error("Failed to fetch brands", error);
                console.log(error.response)
                if (error.response.status == 400) {
                    Swal.fire('Error', "Hubo un problema con la solicitud. Intentalo nuevamente. \
                    Si el problema persiste, contacte a su administrador.", 'error');

                }
                if (error.response.status == 500) {
                    Swal.fire('Error', "Ocurrió un error desconocido. Intentalo nuevamente. \
                    Si el problema persiste, contacte a su administrador.", 'error');
                }
            }
        },

        isRecommendationValid(recommendation){
            return recommendation['unit']!='No disponible';
        },

        async fetchImages() {
            //Retrieves all the images linked to the current note 
            try {
                const apiDirectory = process.env.API_DIRECTORY;
                const response = await axios.get(`${apiDirectory}/get-files/`, {
                    params: {
                        object_id: this.localNoteDetails.note_ident,
                        object_type: 'note',
                    },
                });
                const files = response.data;
                console.log("Retrieved images: ",response.data)
                this.clearImages();
                this.populateImages(files);
                this.buttonClicked.images_tab = true;
                //console.log('Populated image blobs are ',this.imageSections)
            } catch (error) {
                console.error('Error fetching images:', error);
            }
        },
        populateImages(files) {
            files.forEach(file => {
                const section = this.imageSections.find(section => section.loc === file.metadata.loc);
                if (section) {
                    section.images.uploaded.push(`data:image/jpeg;base64,${file.content}`); 
                    section.images.blob_ids.push(file.file_id);
                }
            });
        },
        clearImages() {
            this.imageSections.forEach(section => {
                section.images.uploaded = [];
                section.images.blob_ids = [];
            });
        },
        getProportionalCompressionQuality(size) {
            // Define the max size and min/max quality
            const maxSize = 10000000; // 10MB as the maximum file size for the highest quality
            const minQuality = 0.4; // Minimum quality
            const maxQuality = 0.9; // Maximum quality

            // Calculate the proportional quality
            const quality = Math.max(minQuality, Math.min(maxQuality, maxQuality - (size / maxSize) * (maxQuality - minQuality)));

            return quality;
        },
        // Function to compress and convert to JPEG
        async compressAndConvertToJPG(file) {
            return new Promise((resolve, reject) => {
                // Determine the compression quality based on the file size
                const initialSize = file.size;
                const quality = this.getProportionalCompressionQuality(initialSize);

                new Compressor(file, {
                    quality: quality,
                    convertSize: 5000000, // Convert if size is larger than 5MB
                    success(result) {
                        const reader = new FileReader();
                        reader.onload = () => resolve(reader.result);
                        reader.onerror = () => reject(new Error('Error reading the file.'));
                        reader.readAsDataURL(result);
                    },
                    error(err) {
                        reject(err);
                    },
                });
            });
        },
        selectFile() {
            // Used to handle the image uploads 
            return new Promise((resolve) => {
                const input = document.createElement('input');
                input.type = 'file';
                input.accept = 'image/*'; 
                input.onchange = (event) => {
                    resolve(event.target.files[0]);
                };
                input.click();
            });
        },
        async uploadFile(section) {
            // Handles the upload of images to the upload-file endpoint
            const file = await this.selectFile();
            if (!file) {
                Swal.fire({
                    title: '¡Error!',
                    text: 'Ocurrio un error al subir el archivo. Intente de nuevo.',
                    icon: 'error',
                    showCancelButton: false, // Hide cancel button
                    confirmButtonText: 'Ok',
                    allowOutsideClick: false
                }).then((result) => {
                    if (result.isConfirmed) {
                        // return from func
                        return;
                    }
                });
                return;
            }

            try {
                const compressedFile = await this.compressAndConvertToJPG(file);

                // Create a new blob from the base64 data
                const response = await fetch(compressedFile);
                const blob = await response.blob();
                const jpgFile = new File([blob], 'image.jpg', { type: 'image/jpeg' });

                const formData = new FormData();
                formData.append('file', jpgFile);
                formData.append('object_type', 'note');
                formData.append('object_id', this.localNoteDetails.note_ident);
                formData.append('object_metadata', JSON.stringify({ 'loc': section.loc }));

                const apiDirectory = process.env.API_DIRECTORY;
                await axios.post(`${apiDirectory}/upload-file`, formData);
                this.fetchImages();
            } catch (error) {
                console.error('Error uploading file:', error);
            }
        },
        downloadAllImages(section) {
            // Get the list of images for the specified section
            const images = section.images.uploaded;

            if (images.length === 0) {
                Swal.fire({
                    title: '¡Error!',
                    text: 'No hay imágenes en esta sección.',
                    icon: 'error',
                    showCancelButton: false, // Hide cancel button
                    confirmButtonText: 'Ok',
                    allowOutsideClick: false
                }).then((result) => {
                    if (result.isConfirmed) {
                        // return from func
                        return
                    }
                });
            }

            // Trigger download for each image
            images.forEach((image, index) => {
                const link = document.createElement('a');
                link.href = image; // Image data URL
                link.download = `${section.loc}_${index + 1}.jpg`; // Name the downloaded file
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            });
            Swal.fire({
                    title: '¡Completado!',
                    text: 'Descarga realizada',
                    icon: 'success',
                    showCancelButton: false, // Hide cancel button
                    confirmButtonText: 'Ok'
                })
        },
        async deleteImage(section, index) {

            // Find the corresponding blob ID
            const blobId = section.images.blob_ids[index];

            if (!blobId) {
                Swal.fire({
                    title: '¡Error!',
                    text: 'Ocurrio un error al eliminar el archivo. Intente de nuevo. Si el problema persiste, contacte a su administrador.',
                    icon: 'error',
                    showCancelButton: false, // Hide cancel button
                    confirmButtonText: 'Ok',
                    allowOutsideClick: false
                }).then((result) => {
                    if (result.isConfirmed) {
                        return
                    }
                });
            }

            try {
                const apiDirectory = process.env.API_DIRECTORY;
                await axios.post(`${apiDirectory}/delete-file/`, { blob_id: blobId });

                // Remove the image from the section and the blob id from the dict 
                section.images.uploaded.splice(index, 1);
                section.images.blob_ids.splice(index, 1);


                Swal.fire({
                    title: '¡Completado!',
                    text: 'La imagen se eliminó con éxito',
                    icon: 'success',
                    showCancelButton: false, // Hide cancel button
                    confirmButtonText: 'Ok'
                })
            } catch (error) {
                console.error('Error deleting image:', error);
                Swal.fire({
                    title: '¡Error!',
                    text: 'Ocurrio un error al procesar la solicitud para eliminar la imagen. Por favor intente de nuevo. Si el problema periste, contacte a su administraodr.',
                    icon: 'error',
                    showCancelButton: false, // Hide cancel button
                    confirmButtonText: 'Ok',
                    allowOutsideClick: false
                }).then((result) => {
                    if (result.isConfirmed) {
                        // return from func
                        return
                    }
                });
            }
        },

    },
    async created() {
        // Here you can add any additional initialization that needs to happen when the component is created
        // For instance, setting initial form values based on props
        this.loadPermissions();
        this.localNoteDetails = { ...this.noteDetails };
        this.initChatUnreadBadge();
        this.localNoteDetails.commissions_validated = Boolean(this.noteDetails.commissions_validated);
        this.originMarkerPosition.value = { lat: parseFloat(this.noteDetails.source.lat), lng: parseFloat(this.noteDetails.source.lon) };
        this.destinationMarkerPosition.value = { lat: parseFloat(this.noteDetails.destination.lat), lng: parseFloat(this.noteDetails.destination.lon) };
        this.showOriginMarker = true;
        this.showDestinationMarker = true;
        this.fetchClients();
        this.fetchClientById(this.localNoteDetails.client);
        await this.FetchBrands()
        await this.SetStartingBrandSubBrand()        
        this.blockEdit = this.noteDetails.status == 2 || this.noteDetails.status == 4 || this.noteDetails.status == 6// Determines wheter editing the note should be enabled or disabled based on status
        this.blockRecommend = true; // Safelock to prevent buttons from being used before recommendations are computed
        this.recommenderLoading = false; // Safelock to prevent recommender from being invoked multiple times 
        this.recommendations = [
            { 'unit': 'Presione el boton para recomendar', 'time_queue': 'Esperando', 'distance_to_origin': 'Esperando' },
            { 'unit': 'Presione el boton para recomendar', 'time_queue': 'Esperando', 'distance_to_origin': 'Esperando' },
            { 'unit': 'Presione el boton para recomendar', 'time_queue': 'Esperando', 'distance_to_origin': 'Esperando' },
            { 'unit': 'Presione el boton para recomendar', 'time_queue': 'Esperando', 'distance_to_origin': 'Esperando' },
            { 'unit': 'Presione el boton para recomendar', 'time_queue': 'Esperando', 'distance_to_origin': 'Esperando' }]
    }
};
</script>